import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  inject,
  Inject,
  OnDestroy,
  OnInit,
  QueryList,
  signal,
  ViewChild,
  ViewChildren,
  WritableSignal,
} from '@angular/core';
import { FormArray, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PaymentErrorScreenComponent } from '@app/modules/setting/dialogs/payment-error-screen/payment-error-screen.component';
import { RootStoreState, relationshipStoreActions } from '@app/root-store';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import {
  AuthService,
  ChecklistUpdate,
  ClosedSideNavTemplate,
  CommonService,
  DataExtractionToggle,
  DocumentService,
  LoaderService,
  NotifyDocumentCreatedAddAsLocation,
  NotifyLinkedItemsUpdateService,
  NotifySummaryUpdateService,
  NotifyUpdateItemToResolve,
  UserService,
} from '@app/shared/services';
import { CryptoService } from '@app/shared/services/crypto/crypto.services';
import { NotifyDocumentUpdate } from '@app/shared/services/notify-document-update/notifyDocumentUpdate.service';
import { NotifyEstateActiveTabUpdate } from '@app/shared/services/notify-estate-active-tab-update/notify-estate-active-tab-update.service';
import { NotifyWorkSpaceUpdate } from '@app/shared/services/notify-workspace-update/notifyWorkSpaceUpdate.service';
import { PaymentDoneService } from '@app/shared/services/payment-done/payment-done.service';
import { toBase64 } from '@aws-sdk/util-base64-node';
import { environment } from '@env/environment';
import { select, Store } from '@ngrx/store';
import { AnimationOptions } from 'ngx-lottie';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, forkJoin, fromEvent, Observable, of, Subscription } from 'rxjs';
import { AskSecurityKeyPasswordComponent } from '../dialogs/ask-security-key-password/ask-security-key-password.component';
import { FolderRadioListComponent } from '../dialogs/folder-radio-list/folder-radio-list.component';

import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

// Depending on whether rollup is used, moment needs to be imported differently.
// Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// syntax. However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
import * as _moment from 'moment';
import { debounceTime, take, distinctUntilChanged, catchError } from 'rxjs/operators';
import * as vaultSelectors from '@app/root-store/vault-store/vault.selector';
import { ActivityLogFileComponent } from '../activity-log-file/activity-log-file.component';
import { foreverDeletedRemainingDays } from '@app/shared/models/constants/constant';
import { FileManagerComponent } from '../access-manager/file-manager.component';
import { AddSubfolderComponent } from '../dialogs/add-subfolder/add-subfolder.component';
import { isArray } from 'rxjs/internal-compatibility';
import { AddFinancialAttributeComponent } from './add-finacial-attribute/add-finacial-attribute.component';
import { AddTransactionAttributeComponent } from './add-transaction-attribute/add-transaction-attribute.component';
import { ReminderNotificationListComponent } from './reminder-notification-list/reminder-notification-list.component';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { CreateShareLinkComponent } from '../dialogs/create-share-link/create-share-link.component';
import { InboxSettingsService } from '@app/shared/services/settings/inbox-settings/inbox-settings.service';
import { SharedDocViewerDialogComponent } from '@app/shared/component/shared-doc-viewer-dialog/shared-doc-viewer-dialog.component';
import { FileExtensionPreviewComponent } from './upload-ducoument/file-extension-preview/file-extension-preview.component';
import { BsFileUploadNewComponent } from '@app/modules/bs-file-upload-new/bs-file-upload-new.component';
import { ViewImageComponent } from './view-image/view-image.component';
import { MxconnectionService } from '@app/shared/services/vault/mxconnection.service';
import { AddAssetFormAssociationComponent } from './add-asset-form-association/add-asset-form-association.component';
import { AddEntityFormAssociationComponent } from './add-entity-form-association/add-entity-form-association.component';
import { VaultSideNavService } from '../../container/vault.side-nav.service';
import { FileUploadService } from '@app/shared/services/file-upload/file-upload.service';
import { AddPerformanceSummaryComponent } from './add-performance-summary/add-performance-summary.component';
import { Editor, Toolbar } from 'ngx-editor';
import { InsuranceAttributesComponent } from './insurance-attributes/insurance-attributes/insurance-attributes.component';
import { NonDocumentSummaryComponent } from './non-document-summary/non-document-summary.component';
import { DocumentLinkingTemplateComponent } from './document-linking-template/document-linking-template.component';
import * as selectors from '../../../../root-store/relationship-store/relationship.selector';
import { NgxEditorFieldComponent } from './ngx-editor-field/ngx-editor-field.component';
import { ShareService } from '@app/shared/services/vault/share.service';
import { ItemsToSetUpComponent } from './items-to-set-up/items-to-set-up.component';
import { ManageTagsDialog } from '../dialogs/manage-tags-dialog/manage-tags-dialog.component';
import { SharedVaultService } from '../../../../shared/services/vault/shared-vault.service';
import { CreateAttachemntPopupComponent } from './create-attachemnt-popup/create-attachemnt-popup.component';
import { AddApiRapidMotorValueComponent } from './add-api-rapid-motor-value/add-api-rapid-motor-value.component';
import { AddApiKeyManagedComponent } from './add-api-key-managed/add-api-key-managed.component';
import { AddApiRapidPropertyValueComponent } from './add-api-rapid-property-value/add-api-rapid-property-value.component';
import { NotifyRolePlayersUpdateService } from '@app/shared/services/notify-role-players-update.service/notify-role-players-update.service';
import { RolePlayersCardInFormComponent } from './role-players/role-players-card-in-form/role-players-card-in-form.component';
import { HttpClient } from '@angular/common/http';
import { LocationLinkedTemplatesComponent } from './location-linked-templates/location-linked-templates.component';
import { NonDocumentLinkingTemplateComponent } from './non-document-linking-template/non-document-linking-template/non-document-linking-template.component';
import { LinkedTemplateMethodComponent } from './linked-template-methods/linked-template-method.component';
import { LinkedOwnershipPositionsComponent } from './linked-ownership-positions/linked-ownership-positions.component';
import { RolePlayersAssociationCardComponent } from './role-players-association/role-players-association-card/role-players-association-card.component';
import { NonDocumentAttachmentComponent } from './non-document-attachment/non-document-attachment.component';
import { NotifyAPIUpdateService } from '@app/shared/services/notify-api-update/notify-api-update.service';
import { NotifySharingUpdateService } from '@app/shared/services/notify-sharing-update/notify-sharing-update.service';
import { NotesComponent } from './notes/notes.component';
import { EditAddLinkedTemplatePopupComponent } from './linked-templates/edit-add-linked-template-popup/edit-add-linked-template-popup.component';
import { MatSidenav } from '@angular/material/sidenav';
import { TemplateActiveConformationPopupComponent } from './template-active-conformation-popup/template-active-conformation-popup.component';
import { jsonDiffPipe } from '@app/shared/pipes/json-diff.pipe';
import { AutoNamingFormModelComponent } from './auto-naming-form-model/auto-naming-form-model.component';
import { FileTypeListSizeEnum, FileUploadedLimitExtension } from '@app/enum/FileTypeListSizeEnum';
import { AddSecurityKeyComponent } from './add-security-key/add-security-key.component';
import { AddFolderDialogWithVaultComponent } from '../dialogs/add-folder-dialog-with-vault/add-folder-dialog-with-vault.component';
import { ManagePermissionDialogComponent } from '../non-vault-forms/manage-permission-dialog/manage-permission-dialog.component';
import { AddApiRapidValueService } from './add-api-rapid-value.service';
import { USStates } from '@app/shared/utils/enum';
import { v4 as uuidv4 } from 'uuid';
import { ManageActivityComponent } from './manage-activity/manage-activity.component';
import { ReminderV2Component } from './reminder-v2/reminder-v2/reminder-v2.component';
import { AddressFormMapping, GoogleMapsAutocompleteService } from '@app/shared/services/google-maps-autocomplete/google-maps-autocomplete.service';
import { ShowSuggestionFormComponent } from './show-suggestion-form/show-suggestion-form.component';
import { MoveFileItemComponent } from '../dialogs/move-file-item/move-file-item.component';
import { fetchAuthSession } from '@aws-amplify/auth';
import heic2any from 'heic2any';
import { VaultSelectionFormComponent } from './vault-selection-form/vault-selection-form.component';
import { FormAttachmentComponent } from './form-attachment/form-attachment.component';
import { FetchAttributeDataSubject } from '@app/modules/vault/components/add-document/add-finacial-attribute/attribute-subject.service';
import { TemplateDocumentTagComponent } from './template-document-tag/template-document-tag.component';
import { DialogEventService } from '@app/shared/services/dialog/dialog-refresh-service.component';
import { TransformToUserAction, TransformToUserDialogComponent } from '../dialogs/transform-to-user-dialog/transform-to-user-dialog.component';
import { SyncEntityDialogComponent } from '../dialogs/sync-entity-dialog/sync-entity-dialog.component';
import { AddEntityDilaogComponent } from '../dialogs/add-entity-dilaog/add-entity-dilaog.component';
import { SyncUserDialogComponent } from '../dialogs/sync-user-dialog/sync-user-dialog.component';
import { UserInviteComponent } from '@app/shared/component/user-invite/user-invite.component';
import { AddConnectionComponent } from '@app/shared/component/add-connection-component/add-connection.component';
import { UserTypeEnum, ProfessionalUserRelationShip } from '@app/enum/UserTypeEnum';
import { TemplateStatus } from '@app/modules/vault/components/common/common-file-view-with-groups/individual-group-files-list-items/individual-group-files-list-items.component';
import { RenameDocumentNameComponent } from '@app/modules/inbox-v2/component/dialogs/rename-document-name/rename-document-name.component';
import { VaultSelectionBroadcastService } from '@app/shared/services/vault/vault-selection-broadcast.service';
import { Actions, ofType } from '@ngrx/effects';
import { vaultStoreActions } from '@app/root-store/vault-store';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

// tslint:disable-next-line:no-duplicate-imports
const moment = _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

// export enum TrustType {
//   grantor = 'grantor',
//   trustee = 'trustee',
//   trustProtector = 'trust_protector',
// }

declare let $: any;

export enum VaultUserFormOrigin {
  workspace = 'workspace',
  vault = 'vault',
  officeVault = 'office-vault',
}

@AutoUnsubscribe()
@Component({
  selector: 'add-document',
  templateUrl: './add-document.component.html',
  styleUrls: ['./add-document.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    jsonDiffPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddDocumentComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(NonDocumentSummaryComponent) nonDocumentSummary: NonDocumentSummaryComponent;
  @ViewChild(TemplateDocumentTagComponent) templateDocumentTagRef: TemplateDocumentTagComponent;
  @ViewChild(FormAttachmentComponent) formAttachment: FormAttachmentComponent;
  @ViewChild(DocumentLinkingTemplateComponent) documentLinkingTemplate: DocumentLinkingTemplateComponent;

  @ViewChild(VaultSelectionFormComponent) vaultSelectionForm: VaultSelectionFormComponent;
  @ViewChild(AddAssetFormAssociationComponent) addAssetFormAssociation: AddAssetFormAssociationComponent;
  @ViewChild(AddEntityFormAssociationComponent) addEntityFormAssociation: AddEntityFormAssociationComponent;
  @ViewChild(NgxEditorFieldComponent) NgxEditorField: NgxEditorFieldComponent;

  @ViewChildren(FileExtensionPreviewComponent) fileExtensionComponentchild: QueryList<FileExtensionPreviewComponent>;
  // @ViewChild('childTransactionAttribute') addFinacialAttributeComponent: AddFinacialAttributeComponent;
  @ViewChild(AddFinancialAttributeComponent) AddFinancialAttribute: AddFinancialAttributeComponent;
  @ViewChild('childPerformanceSummary') addPerformanceSummaryComponent: AddPerformanceSummaryComponent;

  @ViewChild('childFinacialAttribute') addTransactionAttributeComponent: AddTransactionAttributeComponent;
  @ViewChild('childInsuranceAttribute') insuranceAttribute: InsuranceAttributesComponent;
  @ViewChild('notesComponent') notesComponent: NotesComponent;
  @ViewChild('manageActivityComponent') manageActivityComponent: ManageActivityComponent;

  @ViewChild('ItemsToSetUpAttribute', { static: false }) itemsToSetUp: ItemsToSetUpComponent;
  @ViewChild('AddApiRapidMotorAttribute') AddApiRapidMotorValue: AddApiRapidMotorValueComponent;
  @ViewChild('AddApiKeyManagedAttribute') AddApiKeyManaged: AddApiKeyManagedComponent;
  @ViewChild('AddApiRapidPropertyValueAttribute') AddApiRapidPropertyValue: AddApiRapidPropertyValueComponent;

  @ViewChild('ReminderV2Attribute') ReminderV2Value: ReminderV2Component;

  @ViewChild('LocationLinkedTemplatesPhysicalAttribute') LocationLinkedPhysicalValue: LocationLinkedTemplatesComponent;
  @ViewChild('LocationLinkedTemplatesPasswordAttribute') LocationLinkedPasswordValue: LocationLinkedTemplatesComponent;
  @ViewChild(NonDocumentLinkingTemplateComponent) nonDocumentLinkingTemplate: NonDocumentLinkingTemplateComponent;
  @ViewChildren(LinkedTemplateMethodComponent) linkedTemplateMethodComponents: QueryList<LinkedTemplateMethodComponent>;
  @ViewChildren(LocationLinkedTemplatesComponent) locationLinkedTemplatesComponents: QueryList<LocationLinkedTemplatesComponent>;
  @ViewChild(LinkedOwnershipPositionsComponent) linkedOwnershipPositions: LinkedOwnershipPositionsComponent;
  @ViewChildren(RolePlayersAssociationCardComponent) rolePlayersAssociationCardComponents: QueryList<RolePlayersAssociationCardComponent>;
  @ViewChild(NonDocumentAttachmentComponent) nonDocumentAttachmentComponent: NonDocumentAttachmentComponent;
  @ViewChild('rolePlayersInFormComponent') rolePlayersInFormComponent: RolePlayersCardInFormComponent;
  @ViewChild('templateDrawer') public templateSidenav: MatSidenav;
  @ViewChild(AddSecurityKeyComponent) addSecurityKeyComponent: AddSecurityKeyComponent;
  @ViewChild('sslEncryptionBadge') sslEncryptionBadge: ElementRef;

  private addApiRapidPropertyValueService = inject(AddApiRapidValueService);
  private attributeSubject = inject(FetchAttributeDataSubject);

  ai_is_loading = false;
  private previousComboKey: string | null = null;

  documentFiles$ = new BehaviorSubject<any[]>([]);
  already_saved_data = null;
  stateObject;
  defaultFolders;
  is_linked_form_id = -1;
  forms = [];
  selectedSecurity_key;
  ignore_ai_suggestion = [];
  notificationLoading = true;
  enable_template_linking_filter = false;
  openDataExtraction = false;
  itemsToSetUpListAttachment = [];
  setupFormTags = [];
  isGeneralSectionResolve = false;
  date = new UntypedFormControl(moment());
  fId;
  loaderItems = [{ id: 1 }, { id: 2 }, { id: 3 }];
  showRightSideSection = false;
  root_currentValue;
  hideManageButton = false;
  root_has_balance;
  has_death_benefit;
  auto_naming_disabled = false;
  root_title;
  enableEditingFormName = false;
  saveResponse;
  editor: Editor;
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['code', 'blockquote'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  isLocalOrTest = true;
  eventListData;
  hideSharedAndMoreVertBtn = false;
  transaction_register_disabled;
  eventFormListData;

  // Worker references for proper cleanup
  private checkAIWorker: Worker | undefined;
  private checkStatusWorker: Worker | undefined;
  private aiCheckTimeoutId: any;
  private statusCheckTimeoutId: any;
  root_currentDate;
  formImage: any;
  hideLocationSection = false;
  imageChangedEvent: any;
  ScanFiles: any = {};
  ScanFileList: any = {};
  templateData: any;
  ai_type: string;
  has_document: any = false;
  suggested_documents: any = [];
  isConnectingWithDataType: boolean;
  isReconnectingWithDataType: boolean;
  hasZillowVehicleDatabaseConnection = false;
  lastConnectedAddressData: any = null;
  lastConnectedVehicleData: any = null;
  addressVehicleFieldsSubscription: Subscription;
  itemsToSetupList: any;
  isSecutityModalOpen: boolean;
  @HostListener('drop', ['$event']) public onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.uploadFile(evt.dataTransfer.files);
  }
  countList = 0;
  hideShareButton = false;
  isDataLoading = true;
  LocationEnable = false;
  value_field_required = false;
  @ViewChild(ReminderNotificationListComponent) child: ReminderNotificationListComponent;
  @ViewChild('childReference') childReference: any;

  isSecurityKeyAdded = false;
  todayDate = new Date();
  isCheeckListForm = false;
  ischeckListFomrId;
  formEncryptionKey;
  documentForm: UntypedFormGroup;
  itemsToSetup: UntypedFormGroup;
  isLottieOn = false;
  currentFolderId;
  submitted = false;
  showAddNoteTextbox = false;
  showNoPreview = false;
  showPdfViewer = true;
  impersonateUserIdForReport = false;
  mode;
  vault_user_folder_id = '-1';
  lastUpdated;
  currecntCurrecySymbol = 'US$';
  fileType;
  filesize;
  selectOfficeSaveFolderData = -1;
  isfileListLoad;
  isTemplateDocumentTagLoading = false;
  isBlueOutlinTextbox = false;
  defaultFoldersList = [];
  isViewEditMode = false;
  arrayItems;
  formIsLoaded = false;
  showNotesitems;
  buttonDisplayText = '';
  showCopyDataButton = false;
  loadingAllElement = true;
  folderList = [];
  EsateList = [];
  fulassetList: Array<any> = [];
  currenciesList: Array<any> = [];
  officefolderList = [];
  isInformationWorkSpace = false;
  selectedParentLable;
  HideAddinationInfo = false;
  subfolderList = [];
  fullSubFolderList = [];
  officesubfolderList = [];
  fullOfficeFolderList = [];
  subchildfolderList = [];
  showFolderList = true;
  showInformationtabFolderList = true;
  showLocationSection = true;
  parent_vault_user_location_id;
  showEstateList = true;
  hideForloderSelection = false;
  showIcon = false;
  typeList = [];
  disablesingleFielFormValidator = false;
  beneFicaryForm: any[] = [];
  filelist = [];
  screenHeight;
  currentFormId;
  vaultFormId;
  currentFormName;
  fileUploadCount = 0;
  subscription = new Subscription();
  CurrentTempletTypeList;
  root_form_type_template = '';
  hasLinkedPositions = false;
  hasBeneficialOwnership = false;
  makeSelectDivDisabel = false;
  files: any = [];
  AllDownloadfiles: any = [];
  Form1 = [];
  myFolderListData;
  editEstate = false;
  mainareaContenHeight;
  moveTonextStepData;
  showEstateChildList = false;
  showESubstateChildList = false;
  isSavedData = false;
  user: any = {};
  shareTypeData;
  ShareTypeDataNewFlow;
  fileTypeData;
  existingUsers;
  vaultStateObject;
  isRemoveEditSaveSharing;
  showButton = false;
  isFormSealed = false;
  has_location = false;
  has_item_location = false;
  has_password_location = false;
  has_sublocation = false;
  has_owns_assets = false;
  has_owns_entities = false;
  has_additional_notes = false;
  has_api_source = false;
  has_api_source_motor = false;
  has_real_estate_value_estimate = false;
  formsRolePlayers = [];
  has_assets = false;
  has_entity = false;
  currfolderName;
  selectedFileList = [];
  showStoragePopup = false;
  currFolderTypeDoc;
  uploadCount = 0;
  recordAssociationCount = 0;
  formsHasLinkedPositions = [46, 2072, 2181];
  formsHasBeneficialOwnership = [1241, 1242, 1864];
  fileManagerRelationshipSharedUser: any[] = [];
  FileUploadedLimit = FileTypeListSizeEnum.FileUploadedLimit;
  FileUploadedLimitExtension = FileUploadedLimitExtension;

  fileCount = 0;
  sharingMode;
  currentuserId;
  markSelectOfficeWorspaceDisable = false;
  currentValutUserId;
  styleElement: HTMLStyleElement;
  sharedUsers;
  nameSaveInDB;
  active = false;
  urlLinks = [];
  viewer = 'google';
  screenWidth: number;
  loginStateObject: any;
  isEstate = false;
  iframeLoaded = false;
  premium_status;
  manageSecuritykey = null;
  iSGetLottieOn;
  isBasicForm;
  sk;
  security_key;
  isClicked = false;
  currentWorkSpaceId;
  currentWorkSpaceFolderId;
  mobile_estate_tab_group_id;
  isOficeWorkSpace = false;
  currentWorkspaceOwner;
  notification_status;
  origin = 'vault';
  isReport = false;
  isBasic = true;
  ai_is_upload_Running = false;
  connected_to_institution = false;

  fullMyInformationList = [];
  currectMyInformationList = [];
  notes = 'If you are adding information about a physical document, where is it located?';
  securityStateObject;
  vaultUserID$ = this.store.pipe(select(vaultSelectors.getcurrentVaultUserId()));
  formUserPublicKey;
  sharedVaultEnable = false;
  attributeSectionList = [];
  reminderNotificationList = [];
  taskNotificationList = [];

  reminderList = [];
  assignedBeneficiaryUser = [];
  rapidAPISetupData = [];
  getAnimationOptions: AnimationOptions = {
    path: 'assets/lottie/lock-basic-new.json',
  };
  animation: AnimationOptions = {
    path: '/assets/lottie/animation-4.json',
  };

  resizeObservable$: Observable<Event>;

  counter = 0;
  fileId;
  updatedFormUrl = null;
  saveFormValueInDb: any;
  savedDynamicFieldsFormValueInDb: any = null;

  saveBeneficiaryFormValueInDb: any;
  formsList;
  formName = '';
  enable_Institution = false;
  isEnableGeneralInformation = false;
  isEnableDescription = false;

  enable_linked_cryptocurrency = false;

  enable_linked_cryptocurrency_wallets = false;
  enable_linked_exchange_wallets = false;
  enable_linked_exchange_accounts = false;

  enable_financial_account = false;
  enable_holdings = false;

  receivedPropertyData;
  reminder_list_array = [];
  transactionData = {};
  isTransactionRegisterOpened: boolean = false;
  itemsToSetupSharingStatus: boolean = false;
  vault_id;
  isUserHasVault = false;
  vault_list = [];
  isHovering: boolean = false;
  isStarHovering: boolean = false;
  isDocumentStarred: boolean = false;
  isActive: boolean = true;
  templateType;
  autocomplete;
  newAISuggestedFormName;
  vaultUserInboxSuggestionId;
  templateId: string;
  nonVaultFormsOrigins = ['contact', 'password'];
  nonVaultOrganizations = ['Accounts & Credentials', 'Contacts'];
  vaultName;
  linkedAssetsEnabled;
  linkedLiabilitiesEnabled;
  linkedEntitiesEnabled;
  isDistributionRegisterOpened: boolean = false;
  isRolePlayersRegisterOpened: boolean = false;
  currentRolePlayerData: any;
  hasCapitalCommitmentLink = signal(false);
  analyzeWithAi: boolean = false;
  currentTemplate;
  linkDocuments: any[] = [];
  categories;

  multi_item_extraction_categories = [];
  showLinkedPaymentMethod = false;
  get isDownloadable() {
    return this.data?.fid == 1 || this.data?.vault_folder_id == 1 || this.data?.vault_form_id == 1 || this.fId == 1;
    // || this.data?.file?.vault_folder_id == 1 || this.data?.file?.vault_form_id == 1;
  }
  apiIndicators = signal('');
  isIpadOrTabletScreenWidth = signal(false);
  apiMotorValueList = [];
  isDataFeedConnected = signal(false);
  isLoadingTrimData = false;
  trimList = [];
  isTrimOptionsNotAvailable = false;
  isTrimDataFound = false;
  vehicleResponse: any;
  vehiclePayload: any;

  templateStatuses = [
    {
      type: 'Not Started',
      status: TemplateStatus.notStarted,
    },
    {
      type: 'Working on it',
      status: TemplateStatus.workingOnIt,
    },
    {
      type: 'Review',
      status: TemplateStatus.review,
    },
    {
      type: 'Needs Attention',
      status: TemplateStatus.needsAttention,
    },
    {
      type: 'Complete',
      status: TemplateStatus.complete,
    },
  ];
  private readonly templateStatusMenuClassMap: Record<string, string> = {
    [TemplateStatus.notStarted]: 'status-menu-item status-menu-item-notStarted',
    [TemplateStatus.workingOnIt]: 'status-menu-item status-menu-item-workingOnIt',
    [TemplateStatus.review]: 'status-menu-item status-menu-item-review',
    [TemplateStatus.needsAttention]: 'status-menu-item status-menu-item-needsAttention',
    [TemplateStatus.complete]: 'status-menu-item status-menu-item-complete',
  };

  private readonly templateStatusLabels: Record<string, string> = {
    notStarted: 'Not Started',
    workingOnIt: 'Working on it',
    review: 'Review',
    needsAttention: 'Needs Attention',
    complete: 'Complete',
  };

  getTemplateStatusLabel(status: string | null | undefined): string {
    if (!status) {
      return this.templateStatusLabels['notStarted'];
    }
    return this.templateStatusLabels[status] ?? status;
  }

  isTemplateStatus(statusToCheck: string): boolean {
    const currentStatus = this.templateData?.template_status || 'notStarted';
    return currentStatus === statusToCheck;
  }

  get generalInformationHasAnyValue() {
    return (this.dynamicFieldsForm() as any)?.some((value) => Object.values(value).some((v) => v != null && v != '')) ?? false;
  }
  get descriptionHasAnyValue() {
    return (this.dynamicFieldsForm() as any)?.some((value) => Object.values(value).some((v) => v != null && v != '')) ?? false;
  }

  private globalSelectionsMap = new Map<string, number>();
  globalSelections: Array<{
    source:
      | 'document_tags'
      | 'document_linked_templates'
      | 'role_players'
      | 'non_document_linked_templates'
      | 'linked_template_methods'
      | 'location_linked_templates'
      | 'linked_ownership_positions'
      | 'role_player_associations'
      | 'non_document_attachments';
    type: string;
    tag?: string;
    template?: any;
    rolePlayer?: any;
    suggestion?: any;
    templateSuggestion?: any;
    category?: string;
    linkType?: string;
    locationType?: string;
    categoryKey?: string;
    record?: any;
    file?: any;
    isBeneficialOwnership?: boolean;
    index: number;
    data: any;
  }> = [];

  constructor(
    private jsonDiffPipe: jsonDiffPipe,
    private actions$: Actions,
    private _fileUploadService: FileUploadService,
    private _notifyDocumentCreatedAddAsLocation: NotifyDocumentCreatedAddAsLocation,
    private MxconnectionService: MxconnectionService,
    private loginService: LoginStoreEffects,
    private commonService: CommonService,
    private closedSideNavTemplate: ClosedSideNavTemplate,
    private dataExtractionToggleSubject: DataExtractionToggle,
    private notifySummaryUpdateService: NotifySummaryUpdateService,
    private formBuilder: UntypedFormBuilder,
    private cd: ChangeDetectorRef,
    private _notifyWorkSpaceUpdate: NotifyWorkSpaceUpdate,
    private _notifyLinkedItemsUpdateService: NotifyLinkedItemsUpdateService,
    private _notifyRolePlayersUpdateService: NotifyRolePlayersUpdateService,
    private _notifySharingUpdateService: NotifySharingUpdateService,
    private toastr: ToastrService,
    private loaderService: LoaderService,
    @Inject(MAT_DIALOG_DATA) public data,
    private NotifyDocumentUpdate: NotifyDocumentUpdate,
    private _inboxService: InboxSettingsService,
    private documentService: DocumentService,
    private notifyEstateActiveTabUpdate: NotifyEstateActiveTabUpdate,
    private userService: UserService,
    private router: Router,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<AddDocumentComponent>,
    private store$: Store<RootStoreState.State>,
    private vaultService: VaultStoreEffects,
    private checklistUpdate: ChecklistUpdate,
    private cryptoService: CryptoService,
    private el: ElementRef,
    private googleMapsService: GoogleMapsAutocompleteService,
    private PaymentDoneService: PaymentDoneService,
    private addApiRapidValueService: AddApiRapidValueService,
    private vaultShareService: ShareService,
    private store: Store,
    private authService: AuthService,
    private vaultSideNavService: VaultSideNavService,
    private sharedVaultService: SharedVaultService,
    private http: HttpClient,
    private _notifyAPIUpdateService: NotifyAPIUpdateService,
    private vaultUserService: SharedVaultService,
    private notifyUpdateItemToResolve: NotifyUpdateItemToResolve,
    private dialogEventService: DialogEventService,
    private vaultSelectionBroadcastService: VaultSelectionBroadcastService
  ) {
    // this.subscription.add(
    //   this.PaymentDoneService.getMessage().subscribe((message) => {
    //     if (message) {
    //       this.toastr.success('File has been protected with Security key');
    //       this.isSecurityKeyAdded = true;
    //       this.subscription.add(
    //         this.documentService.getSecurityKeyWidhId(this.currentValutUserId).subscribe(
    //           (res) => {
    //             this.isClicked = false;
    //             this.manageSecuritykey = res.Items;
    //             if (res.Items != undefined && res.Items.length) {
    //               this.isSecurityKeyAdded = true;
    //               this.manageSecuritykey = res.Items;
    //               this.cd.detectChanges();
    //             }
    //           },
    //           (error) => {
    //             this.isSecurityKeyAdded = false;
    //             this.isClicked = false;
    //           }
    //         )
    //       );
    //       this.cd.detectChanges();
    //     }
    //   })
    // );
    this.templateId = `template-${uuidv4()}`;
    this.templateType = data.type_template;
    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.vaultStateObject = state;
        this.vault_list = state.vaults;
        this.categories = state.categories;
        this.formsList = state.forms;
        if (this.vault_id && this.vault_list.length > 0 && this.isUserHasVault) {
          this.vaultName = this.vault_list.find((vault) => vault.id === this.vault_id)?.name;
        }
        if (state.vaultId) {
          this.sharedVaultEnable = true;
        } else {
          this.sharedVaultEnable = false;
        }
      })
    );

    this.subscription.add(
      this.vaultUserID$.subscribe(async (userId) => {
        if (!userId) {
          //this code is giving us error at
          // this.securityStateObject = null;
        } else if (this.securityStateObject?.userId != userId && (await this.authService.isAuthenticated())) {
        }
      })
    );

    this.subscription.add(
      this.addApiRapidValueService.copyDataFromLiveFeedsSubjectData.subscribe((value) => {
        if (value) {
          this.getInitApiConnectedData();
        }
      })
    );
  }
  reminderStatusUpdateEvent(event) {
    this.itemsToSetUp.getItemSetupList();
  }
  drop(ev) {
    this.cd.detectChanges();
  }
  itemsToSetUpListCompleteAllEvent(event) {
    this.itemsToSetUpListAttachment = [];
    try {
      this.itemsToSetup.controls.generalSection.setValue('true');
      this.itemsToSetup.controls.descriptionSection.setValue('true');
    } catch (error) {}
  }
  updateList(event) {
    this.reminderNotificationList = event;
    const itemsToSetUpListAttachmentArr = [];
    this.itemsToSetUpListAttachment.forEach((elementItem, index) => {
      if (
        elementItem.action == undefined ||
        event.findIndex((x) => x.description == elementItem.description && x.action == elementItem.action) >= 0
      ) {
        itemsToSetUpListAttachmentArr.push(elementItem);
      }
    });
    this.itemsToSetUpListAttachment = itemsToSetUpListAttachmentArr;
  }

  onToggleClick(event: Event) {
    const dialogRef = this.dialog.open(TemplateActiveConformationPopupComponent, {
      width: '386px',
      panelClass: 'create-share-link-dialog',
      data: {
        isActive: this.isActive,
        currentFormId: this.currentFormId,
      },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((data) => {
        if (data.data == 'you cancelled') {
          this.isActive = !this.isActive;

          dialogRef.close();
        } else {
          // this.getFormStatus(this.data.id ? this.data.id : this.data.vufid ? this.data.vufid : this.currentFormId);
        }
      })
    );
  }

  toggleDocumentStar() {
    this.isDocumentStarred = !this.isDocumentStarred;

    // Save starred status to API
    if (this.currentFormId) {
      this.subscription.add(
        this.documentService
          .updateFormIsStarred(
            {
              id: this.currentFormId,
              is_starred: this.isDocumentStarred,
            },
            false
          )
          .subscribe(
            (res) => {
              // Successfully updated
              this.cd.detectChanges();
            },
            (error) => {
              // Revert on error
              this.isDocumentStarred = !this.isDocumentStarred;
              this.toastr.error('Failed to update starred status');
              this.cd.detectChanges();
            }
          )
      );
    }
  }

  private updateSelectedVault(id: any, name?: string) {
    this.vault_id = id;
    this.isUserHasVault = !!this.vault_list.find((x) => x.id == id);
    if (name !== undefined) {
      this.vaultName = name;
    }
    if (id === undefined || id === null) {
      this.vaultSelectionBroadcastService.setSelectedVault(null);
      return;
    }
    this.vaultSelectionBroadcastService.setSelectedVault({
      id,
      name: name ?? this.vaultName,
    });
  }

  vaultSelected(event) {
    this.updateSelectedVault(event?.id, event?.name);
    this.cd.detectChanges();
  }
  itemsToSetUpListAttachmentEvent(event) {
    const list = [];

    event?.list.forEach((element) => {
      list.push({
        ...element,
        showBtn: false,
      });
    });
    this.itemsToSetUpListAttachment = list;
    this.reminder_list_array?.forEach((element, index) => {
      if (element.action == 'attach') {
        if (this.itemsToSetUpListAttachment.findIndex((x) => x.sub_type.toLowerCase() == element.description.toLowerCase()) == -1) {
          this.itemsToSetUpListAttachment.push({
            ...element,
            sub_type: element.description,
            is_new: true,
          });
        }
      }
    });
    this.cd.detectChanges();
  }

  itemsToSetUpListRapidAPIEvent(event) {
    this.rapidAPISetupData = event;
  }

  itemsToSetUpListSharingEvent(event) {
    this.itemsToSetupSharingStatus = event[0].status;
  }

  rolePlayersItemInSetUpList(event) {
    this.rolePlayersInFormComponent.rolePlayersItemInSetUpList(event);
  }

  reminder_list(reminder_list) {
    this.reminder_list_array = reminder_list;
    this.reminder_list_array.forEach((element, index) => {
      if (element.action == 'attach') {
        if (this.itemsToSetUpListAttachment.findIndex((x) => x.sub_type.toLowerCase() == element.description.toLowerCase()) == -1) {
          this.itemsToSetUpListAttachment.push({
            ...element,
            sub_type: element.description,
            is_new: true,
          });
        }
      }
    });
  }
  addAtachment(index = -1, sub_type = '') {
    const dialogRef = this.dialog.open(CreateAttachemntPopupComponent, {
      height: '100%',
      width: '735px',
      maxWidth: '90%',
      data: {
        formEncryptionKey: this.formEncryptionKey,
        currentFormId: this.currentFormId,
        origin: this.origin,
        new: sub_type == '' ? true : false,
        showToggle: this.has_document && this.itemsToSetUp?.itemsToSetUpList?.findIndex((x) => x.type == 'attach') >= 0 ? true : false,
        manageSecuritykey: this.manageSecuritykey,
        formUserPublicKey: this.formUserPublicKey,
        isSecurityKeyAdded: this.isSecurityKeyAdded,
        currentWorkspaceOwner: this.currentWorkspaceOwner,
        sk: this.sk,
        sub_type: sub_type,
        mark_complete: this.itemsToSetUp?.itemsToSetUpList?.find((x) => x.type == 'attach')?.status == 'complete' ? true : false,
        security_key: this.security_key,
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        if (this.has_document) {
          this.setupComplete(res.mark_complete);
        }
        if (res?.nothingChange) {
          return;
        }

        if (res?.isRefresh) {
          this.getfileliseForCurrentForms();
        }
        if (res.files?.length) {
          this.files = this.files.concat(res.files);
        }
        this.cd.detectChanges();
      })
    );
  }
  removeItemsToSetUpListAttachment(event) {
    if (this.itemsToSetUpListAttachment.findIndex((x) => x.vault_user_form_reminder_id == event.id) >= 0) {
      const index = this.itemsToSetUpListAttachment.findIndex((x) => x.vault_user_form_reminder_id == event.id);
      this.itemsToSetUp.callActionUpdate(this.itemsToSetUpListAttachment[index].id, 'complete');
      this.itemsToSetUpListAttachment.splice(index, 1);
    } else if (this.itemsToSetUpListAttachment.findIndex((x) => x.id == event.id) >= 0) {
      const index = this.itemsToSetUpListAttachment.findIndex((x) => x.id == event.id);
      this.itemsToSetUpListAttachment.splice(index, 1);
    }
    this.cd.detectChanges();
  }
  itmeSetMark(event) {
    this.itemsToSetUp.callActionUpdate(event.findItemSetup.id, event.is_marked ? 'complete' : 'created');
  }

  createAttachmentSetup(itemToSetup, index) {
    try {
      if (itemToSetup?.is_new) {
        this.addAtachment(index, itemToSetup.sub_type);
        return;
      }
    } catch (error) {}
    const dialogRef = this.dialog.open(CreateAttachemntPopupComponent, {
      height: '100%',
      width: '735px',
      maxWidth: '90%',
      data: {
        formEncryptionKey: this.formEncryptionKey,
        itemToSetup: itemToSetup,
        currentFormId: this.currentFormId,
        origin: this.origin,
        manageSecuritykey: this.manageSecuritykey,
        formUserPublicKey: this.formUserPublicKey,
        isSecurityKeyAdded: this.isSecurityKeyAdded,
        currentWorkspaceOwner: this.currentWorkspaceOwner,
        mark_complete: this.itemsToSetUp.itemsToSetUpList.find((x) => x.type == 'attach').status == 'complete' ? true : false,
        sk: this.sk,
        sub_type: itemToSetup.sub_type,
        security_key: this.security_key,
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        this.setupComplete(res.mark_complete);
        if (res?.nothingChange) {
          return;
        }
        if (res.isRefresh) {
          this.getfileliseForCurrentForms();
        }
        if (res.files?.length) {
          this.files = this.files.concat(res.files);
        }

        this.itemsToSetUp.callActionUpdate(itemToSetup.id, 'complete', res.vault_user_form_uploads_id);
        this.itemsToSetUpListAttachment.splice(index, 1);
        this.cd.detectChanges();
      })
    );
  }
  closeAttachment(event: MouseEvent, itemToSetup, index) {
    event.stopPropagation();
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '500px',
      data: {
        title: 'Remove Suggestion',
        materialIcon: 'remove-info',
        text: `Are you sure you want to remove the suggestion for ${itemToSetup.sub_type}? This action cannot be undone.`,
        proceedTitle: 'Remove',
        showCancelBtn: true,
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((res) => {
        if (res?.nothingChange) {
          return;
        }
        if (res.isRefresh) {
          this.getfileliseForCurrentForms();
        }
        if (res.files?.length) {
          this.files = this.files.concat(res.files);
        }
        this.itemsToSetUp.callActionUpdate(itemToSetup.id, 'complete');
        this.itemsToSetUpListAttachment.splice(index, 1);
        this.cd.detectChanges();
      })
    );
  }
  updateTaskList(event) {
    const eventList = [];
    if (event?.length) {
      event.forEach((element) => {
        if (element.due_date) {
          element.due_date = new Date(element.due_date);
        }
        eventList.push(element);
      });
    }
    this.taskNotificationList = eventList;
  }
  setupComplete(mark_complete) {
    this.itemsToSetUp.updateAttachment(mark_complete);
  }
  updateCountList(event) {
    this.countList = event;
  }
  afterLoadComplete(event) {
    this.loaderService.hide();
  }
  onError(event) {
    this.showPdfViewer = false;
    this.showNoPreview = true;
    this.cd.detectChanges();
    this.loaderService.hide();
  }
  onProgress(event) {
    this.loaderService.show();
  }
  pageRendered(event) {}
  dropleave(ev) {
    this.active = false;
    this.cd.detectChanges();
  }

  allowDrop(ev) {
    this.active = true;
    ev.preventDefault();
  }

  onEnter(event) {
    document.getElementById('document-form-nameTextbox').blur();
    let nummber = this.documentForm.controls.documentName.value.length * 12;
    nummber = nummber + 72;
    if (nummber > 520) {
      nummber = 520;
    }
    // eval(`document.getElementById("document-form-nameTextbox").style.width='${nummber}px'`);
  }

  updateMarkComplete(vault_user_form_setup_ids) {
    this.subscription?.add(
      this.documentService
        .updateMarkComplete({
          vault_user_form_setup_ids: vault_user_form_setup_ids,
        })
        .subscribe(() => {})
    );
  }

  sharedocument() {
    //ensure that id is passed in as vault_user_form_id
    const passingFile = JSON.parse(JSON.stringify(this.data));
    passingFile.vault_user_form_id = this.data.id;
    passingFile.currentFormId = this.currentFormId;
    passingFile.form_name = this.formName ? this.formName : this.documentForm.controls['documentName'].value;

    const modalRef2 = this.dialog.open(FileManagerComponent, {
      data: { file: passingFile, showMarkAsComplete: true, markAsCompleteStatus: this.itemsToSetupSharingStatus },
      panelClass: 'full-window-dialog-2',
      autoFocus: false,
    });
    this.subscription.add(
      modalRef2.afterClosed().subscribe((data) => {
        if (this.fId === 1) {
          this.updateMarkComplete(this.itemsToSetupList[0]?.id);
        }
        this.data.sharedUsers = data.map((obj) => ({
          first_name: obj.user_first_name,
          last_name: obj.user_last_name,
          profile_image_url: obj.user_profile_image_url,
        }));

        this.cd.detectChanges();
      })
    );
  }

  saveFromName() {
    this.subscription.add(
      this.documentService
        .saveFormNameInDb({
          form_name: this.documentForm.controls.documentName.value,
          id: this.currentFormId,
          form_name_updated_by_user: true,
        })
        .subscribe(
          (res) => {
            this.nameSaveInDB = this.documentForm.controls.documentName.value;
            this.cd.detectChanges();
          },
          (error) => {}
        )
    );
  }
  clearFormName() {
    this.documentForm.controls.documentName.setValue(this.nameSaveInDB);
    this.cd.detectChanges();
  }
  onBookAdded(event) {
    this.documentForm.controls.dynamicFieldsForm['controls'][0]['controls'][event.formControlName].setValue(event.value);
    this.cd.detectChanges();
  }
  saveFormName() {
    const current_template = this.formsList.find((x) => x.id == (this.data.fid ? this.data.fid : this.data.form_id));
    let filterData = this.Form1[0].singleFieldForm.map((x) => {
      return {
        ...x,
        record_default: x?.record_default ? +x.record_default : -1,
      };
    });
    filterData = filterData.sort(function (a, b) {
      const keyA = a['record_default'],
        keyB = b['record_default'];
      // Compare the 2 dates
      if (keyA < keyB) {
        return -1;
      }
      if (keyA > keyB) {
        return 1;
      }
      return 0;
    });

    const filterArrayItems = filterData.filter((x) => x.record_default > 0);
    this.subscription.add(
      this.documentService
        .saveNameWithAction(
          {
            form_name: this.documentForm.controls.documentName.value,
            id: this.data.id ? this.data.id : this.currentFormId,
            naming_convention: current_template.naming_convention,
            dynamicFieldsForm: this.documentForm.controls.dynamicFieldsForm.value[0],
            user_id: this.currentuserId,
            current_template: current_template,
            documentName: this.documentForm.controls.documentName.value,
            filterArrayItems: filterArrayItems,
            vault_id: this.vault_id,
            vault_list: this.vault_list,
          },
          true
        )
        .subscribe((res) => {
          if (res.payload.form_name != '' && res.payload.form_name != null && res.payload.form_name != undefined) {
            if (!this.auto_naming_disabled) {
              this.documentForm.controls.documentName.setValue(res.payload.form_name);
            }
            this.nameSaveInDB = res.payload.form_name;
          }
          this.cd.detectChanges();
        })
    );
  }
  onChange(item) {
    const list = this.itemsToSetUp.itemsToSetUpList;
    const itemsToSetUp = list.find((x) => x.type == 'general');
    if (itemsToSetUp) {
      this.itemsToSetUp.callActionUpdate(itemsToSetUp.id, this.itemsToSetup.controls[item].value ? 'complete' : 'created');
    }
    this.cd.detectChanges();
  }
  saveDescription(item) {
    const list = this.itemsToSetUp.itemsToSetUpList;
    const itemsToSetUp = list.find((x) => x.type == 'description');
    if (itemsToSetUp) {
      this.itemsToSetUp.callActionUpdate(itemsToSetUp.id, this.itemsToSetup.controls['descriptionSection'].value ? 'complete' : 'created');
    }
  }

  getItemSetupList() {
    this.subscription.add(
      this.documentService.getItemsToSetUpList(this.currentuserId, this.currentFormId).subscribe((res) => {
        this.itemsToSetupList = res;
        this.cd.detectChanges();
      })
    );
  }

  ngOnInit() {
    this.currentTemplate = this.formsList.find(
      (x) => x.id == (this.data.fid ? this.data.fid : this.data.form_id ? this.data.form_id : this.data?.file?.fid)
    );
    const category = this.categories.find((x) => x?.name == this.currentTemplate?.organization_section);
    this.ai_type = category?.ai_type;

    try {
      this.ai_is_loading = this.data.ai_is_loading ? this.data.ai_is_loading : false;
    } catch (error) {}
    try {
      this.fId = this.data.fid ? this.data.fid : this.data.form_id ? this.data.form_id : this.data?.file?.fid;
    } catch (error) {}
    this.itemsToSetup = this.formBuilder.group({
      generalSection: [false, Validators.required],
      descriptionSection: [false, Validators.required],
    });
    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.forms = state.forms;
        this.categories = state.categories;
        this.stateObject = state;
        this.cd.markForCheck();
      })
    );
    this.editor = new Editor();
    if (this.data?.isLinked) {
    }
    if (this.data?.enable_template_linking_filter) {
      this.enable_template_linking_filter = this.data?.enable_template_linking_filter;
    }

    if (this.data?.isReport) {
      this.isReport = this.data?.isReport;
    }
    this.parent_vault_user_location_id = this.data?.parent_vault_user_location_id;
    try {
      if (this.data?.file?.form_name) {
        this.nameSaveInDB = this.data?.file?.form_name;
        this.cd.detectChanges();
      }
    } catch (error) {}
    try {
      if (this.data?.isGeneralSectionResolve) {
        this.isEnableGeneralInformation = this.data?.isGeneralSectionResolve;
        this.cd.detectChanges();
      }
    } catch (error) {}

    try {
      if (this.data?.isDescriptionSectionResolve) {
        this.isEnableDescription = this.data?.isDescriptionSectionResolve;
        this.cd.detectChanges();
      }
    } catch (error) {}

    this.todayDate.setHours(23, 59, 59);
    if (!this.data.isLinked) {
      $('body').css('overflow', 'hidden');
    }

    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    this.subscription.add(
      this._notifyRolePlayersUpdateService.getMessage().subscribe((data) => {
        const list = this.itemsToSetUp.itemsToSetUpList;
        const itemsToSetUp = list.find((x) => x.type == 'role_players' && x.sub_type == data.rolePlayerCategory);
        if (itemsToSetUp) {
          this.itemsToSetUp.callActionUpdate(itemsToSetUp.id, data.status);
        }
      })
    );

    this.subscription.add(
      this._notifySharingUpdateService.getMessage().subscribe((data) => {
        const list = this.itemsToSetUp.itemsToSetUpList;
        const itemsToSetUp = list.find((x) => x.type == 'share');
        if (itemsToSetUp) {
          this.itemsToSetUp.callActionUpdate(itemsToSetUp.id, data.status);
        }
      })
    );

    this.subscription.add(
      this.sharedVaultService.getNoteMessage.subscribe((data) => {
        const list = this.itemsToSetUp.itemsToSetUpList;
        const itemsToSetUp = list.find((x) => x.type == 'note' && x.id == data.id);
        if (itemsToSetUp) {
          this.itemsToSetUp.callActionUpdate(itemsToSetUp.id, data.status ? 'complete' : 'created');
        }
      })
    );

    this.subscription.add(
      this._notifyAPIUpdateService.getAPIData().subscribe((data) => {
        const list = this.itemsToSetUp.itemsToSetUpList;
        const itemsToSetUp = list.find((x) => x.type == 'api' && x.sub_type == data.subtype);
        if (itemsToSetUp) {
          this.itemsToSetUp.callActionUpdate(itemsToSetUp.id, data.status);
        }
      })
    );

    this.subscription.add(
      this.commonService.transactionRegisterToggleSubject.subscribe((data) => {
        if (this.isTransactionRegisterOpened && !data.open) {
          this.commonService.fetchTransactionCountData(true);
        }
        this.isTransactionRegisterOpened = data.open;
        this.transactionData = data.data;
      })
    );
    this.commonService.toggleDataExtractionToggleSubject(this.data?.sideNavOpen ?? false);
    if (!this.data?.sideNavOpen) {
      this.subscription.add(
        this.commonService.dataExtractionToggleSubject.subscribe((data) => {
          if (data) {
            this.openDataExtraction = true;
          } else {
            this.closeSideNav();
          }
        })
      );
    }

    this.subscription.add(
      this.commonService.distributionRegisterToggleSubject.subscribe((data) => {
        this.isDistributionRegisterOpened = data.open;
      })
    );

    this.subscription.add(
      this.commonService.rolePlayersRegisterToggleSubject.subscribe((data) => {
        if (data.templateId === this.templateId) {
          this.isRolePlayersRegisterOpened = data.open;
          this.currentRolePlayerData = data.data;
        }
      })
    );

    if (this.data.origin) {
      this.origin = this.data.origin;
    }

    if (this.data?.estate_tab_group_id) {
      this.editEstate = true;
    }
    if (this.router.url.includes('office/search-results')) {
      this.showLocationSection = true;
    }
    if (this.router.url.includes('collaboration/shared-with-me')) {
      this.hideShareButton = true;
    }

    if (this.data?.estate_asset_tab_id == -1) {
      this.editEstate = true;
    }
    if (this.router.url.includes('my-information')) {
      this.isInformationWorkSpace = true;
    }
    const url = this.router.url.split('/');
    if (this.router.url.includes('my-workspace') || this.router.url.includes('admin-workspace')) {
      this.origin = 'workspace';
    }

    if (
      (url[2] == 'my-workspace' ||
        url[1] == 'office' ||
        url[2] == 'admin-workspace' ||
        this.router.url.includes('/office-network/my-shared-workspace')) &&
      !this.router.url.includes('my-information')
    ) {
      this.currentWorkSpaceId = url[3];
      if (this.data?.isintelligent == true || this.data?.mode == 'add') {
        this.subscription.add(
          this.documentService.getworkSpaceFolder(this.currentWorkSpaceId).subscribe(
            (res) => {
              if (url.length > 5) {
                const finalList = [];
                res.forEach((element) => {
                  const data = Object.assign(element, { isChildAvailable: false });
                  // parent_office_vault_folder_id
                  if (res.findIndex((x) => x.parent_office_workspace_folder_id == element.id) != -1) {
                    data.isChildAvailable = true;
                  }
                  finalList.push(data);
                });

                this.fullOfficeFolderList = finalList;
                this.documentForm.controls.selectOfficeSaveFolder.setValue(+url[5]);
                const CurrentElement = this.fullOfficeFolderList.find((x) => x.id == +url[5]);
                this.officesubfolderList = finalList.filter(
                  (x) => x.parent_office_workspace_folder_id == CurrentElement.parent_office_workspace_folder_id
                );
                this.currectMyInformationList = this.fullOfficeFolderList.filter(
                  (x) => x.parent_office_workspace_folder_id == CurrentElement.parent_office_workspace_folder_id
                );
                this.showFolderList = false;

                this.cd.detectChanges();
              } else {
                this.officesubfolderList = res;
                this.fullOfficeFolderList = res;
                this.customCss();
                this.cd.detectChanges();
              }
            },
            (error) => {}
          )
        );
      }
    }
    if (url.length == 3 && url[1] == 'vault' && (url[2] == 'my-workspace' || url[2] == 'admin-workspace')) {
      this.isOficeWorkSpace = false;
    }

    if (
      this.data?.selectOfficeSaveFolderData != null &&
      this.data?.selectOfficeSaveFolderData != undefined &&
      this.data?.selectOfficeSaveFolderData
    ) {
      this.selectOfficeSaveFolderData = this.data.selectOfficeSaveFolderData;
    }

    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        this.loginStateObject = { ...state.data };

        if (state?.data) {
          this.currentuserId = state.data.id;
        }
      })
    );
    if (this.data['sharingMode'] == true) {
      this.sharingMode = true;
    }
    this.isfileListLoad = this.data['isfileListLoad'];
    if (this.data.file != undefined) {
      this.sharedUsers = this.data.file['sharedUsers'] ? this.data.file['sharedUsers'] : [];
      this.fileId = this.data.file.id;
    }
    this.screenHeight = window.innerHeight;
    this.mainareaContenHeight = +(this.screenHeight - 296);
    $(document).ready(function () {
      $(document).on('keypress', '#target', function (evt) {
        if ((evt.which != 8 && evt.which != 0 && evt.which < 48) || evt.which > 57) {
          evt.preventDefault();
        }
      });
    });

    $(document).ready(function () {
      $(document).on('keypress', '#targetNumber', function (evt) {
        if (evt.target.value.length >= 17) {
          evt.preventDefault();
        } else {
          if (evt.which == 44 || evt.which == 46) {
            if (evt.target.value.includes('.') && evt.which == 46) {
              evt.preventDefault();
            }
          } else if ((evt.which != 8 && evt.which != 0 && evt.which < 48) || evt.which > 57) {
            evt.preventDefault();
          }
        }
      });
    });
    if (this.router.url.includes('my-information')) {
      this.isInformationWorkSpace = true;
      this.showLocationSection = true;
    }
    if (this.data.isFromChecklist) {
      this.subscription.add(
        this.loginService.loginObject.subscribe((state) => {
          if (state && state.data && state.data.id) {
            this.currentuserId = state.data.id;
          }
        })
      );
    }
    this.subscription.add(
      this.vaultService.vaultObject.subscribe(
        (state) => {
          if (state?.userId || (this.data?.isReport && this.data.vault_user_form_user_id)) {
            this.currentValutUserId = this.data?.isReport && this.data.vault_user_form_user_id ? this.data.vault_user_form_user_id : state?.userId;

            const res = this.userService.checkUserIsPremium(this.loginStateObject?.premium_status);
            this.premium_status = !res;
            if (this.router.url.includes('my-information')) {
              this.isInformationWorkSpace = true;
              if (this.data?.isintelligent == true || this.data?.mode == 'add') {
                this.subscription.add(
                  this.documentService.getFolderListForMyInformation(this.currentValutUserId).subscribe(
                    (res) => {
                      const finalList = [];
                      res.forEach((element) => {
                        const data = Object.assign(element, { isChildAvailable: false });
                        // parent_office_vault_folder_id
                        if (res.findIndex((x) => x.parent_office_vault_folder_id == element.id) != -1) {
                          data.isChildAvailable = true;
                        }
                        finalList.push(data);
                      });
                      this.fullMyInformationList = finalList;
                      const url = this.router.url.split('/');
                      if (url.length > 5) {
                        this.documentForm.controls.selectOfficeSaveFolder.setValue(+url[5]);

                        this.documentForm.controls.selectSaveFolder.setValue(+url[5]);
                        const findActiveNode = this.fullMyInformationList.find((x) => x.id == url[5]);
                        this.showInformationtabFolderList = false;
                        this.currectMyInformationList = this.fullMyInformationList.filter(
                          (x) => x.parent_office_vault_folder_id == findActiveNode.parent_office_vault_folder_id
                        );
                        this.cd.detectChanges();
                      } else {
                        this.documentForm.controls.selectOfficeSaveFolder.setValue('-1');

                        this.documentForm.controls.selectSaveFolder.setValue('-1');
                      }
                      this.cd.detectChanges();
                    },
                    (errior) => {}
                  )
                );
              }
            }
          }
          if ((this.data?.isintelligent == true || this.data?.mode == 'add') && this.currentFormId == undefined) {
            const data = {
              user_id: state.userId,
              vault_form_id: this.data.form_id ? this.data.form_id : null,
              url: this.router.url.replace('/vault/', ''),
              vault_user_folder_id: null,
              vaultId: this.vaultStateObject.vaultId,
              ...(this.currentWorkSpaceId && { workspace_id: this.currentWorkSpaceId }),
            };
            if (this.origin == 'vault') {
              const url = this.router.url.split('/');
              const id = url?.length > 6 ? url[6] : url[4];
              data['vault_user_folder_id'] = id;
            }

            if (this.data?.checklist_id) {
              data['vault_user_folder_checklist_id'] = this.data?.checklist_id;
            }

            //check to see if this form is part of a workspace, if so use workspace owner for form creation
            if (this.origin == 'workspace') {
              data.user_id = this.currentWorkspaceOwner.id;
            }

            if (this.data.estate_tab_group_id) {
              data['estate_asset_tab_group_id'] = this.data?.estate_tab_group_id;
              this.hideForloderSelection = true;
              this.mobile_estate_tab_group_id = this.data.estate_tab_group_id;
              this.EstateFolderList(this.data?.estate_tab_group_id);
            }
            if (this.data?.estate_asset_tab_id == -1) {
              this.EstateFolderList(-1);
            }
            if (this.data.is_filter_name == 'Location') {
              this.LocationEnable = true;
              this.hideLocationSection = true;
              data['origin'] = 'location';
              if (this.data.vault_user_form_user_id) {
                data['user_id'] = this.data.vault_user_form_user_id;
              }

              data['parent_vault_user_location_id'] = this.data?.parent_vault_user_location_id;
              this.parent_vault_user_location_id = this.data?.parent_vault_user_location_id;
            }

            delete data.vault_user_folder_id;
            if (this.data.vaultId) {
              data.vaultId = this.data.vaultId;
            }

            if (this.data.origin) {
              data['origin'] = this.data.origin;
            }

            if (this.data.workspace_id && this.data.workspace_user_id) {
              data.workspace_id = this.data.workspace_id;
              data['workspace_user_id'] = this.data.workspace_user_id;
            }

            this.subscription.add(
              this.documentService.getforIdForFirstUploadDocument(data).subscribe(
                (res) => {
                  this.vaultName = res['vault_user_form_id'].vault_name;
                  this.templateData = res['vault_user_form_id'];
                  this.linkedAssetsEnabled = res['vault_user_form_id'].linked_assets_enabled;
                  this.linkedLiabilitiesEnabled = res['vault_user_form_id'].linked_liabilities_enabled;
                  try {
                    this.updateSelectedVault(res['vault_user_form_id'].vault_id, res['vault_user_form_id'].vault_name);
                    this.securityStateObject = res['vault_user_form_id'].public_key;
                  } catch (error) {}

                  if (!!!this.data?.file || !!!this.data?.id) {
                    this.getSetupTag(res?.vault_user_form_id?.vault_user_form_id);
                  }

                  try {
                    const fromData = this.forms.find((x) => x.id == this.data.form_id);
                    this.has_document = fromData.has_document;
                    this.suggested_documents = fromData.suggested_documents;
                  } catch (error) {}
                  this.showRightSideSection = true;
                  if (res.vault_user_form_id?.save_to_location_id) {
                    this.isCheeckListForm = true;
                    this.ischeckListFomrId = res.vault_user_form_id?.save_to_location_id;
                  }
                  if (this.data == null || this.data == undefined) {
                    return;
                  }
                  this.currentFormId = res['vault_user_form_id']['vault_user_form_id'];
                  // this.getFormStatus(this.currentFormId);
                  this.getItemSetupList();

                  this.enableEditingFormName = true;
                  this.formName = res['vault_user_form_id']['form_name'];
                  this.getExistingUser();
                  res?.vault_user_form_id.profile_image_url ? (this.formImage = res?.vault_user_form_id.profile_image_url) : '';
                  if (this.mode != 'edit' && this.mode != 'view' && !this.isRemoveEditSaveSharing) {
                    try {
                      // this.addFinacialAttributeComponent.getUpdateList(this.currentFormId, this.data.form_id);
                      // this.addPerfomanceSummaryComponent.getUpdateList(this.currentFormId, this.data.form_id);
                      this.addTransactionAttributeComponent.getUpdateList(this.currentFormId, this.data.form_id);
                      this.insuranceAttribute.getUpdateList(this.currentFormId, this.data.form_id);
                    } catch (error) {}
                  }

                  this.documentForm.get('documentName').setValue(res['vault_user_form_id']['form_name']);

                  if (this.data != undefined && this.data['filelistAdded']) {
                    this.uploadFile(this.data.filelistAdded);
                    this.formIsLoaded = true;
                  }
                  this.subscription.add(
                    this.vaultService.vaultObject.subscribe((state) => {
                      this.defaultFoldersList = state['defaultFolders'];
                      const folderList = state['defaultFolders'];
                      const vault_user_folder_id = res['vault_user_form_id']['vault_user_folder_id'];
                      this.vault_user_folder_id = res['vault_user_form_id']['vault_user_folder_id'];
                      if (vault_user_folder_id != null && vault_user_folder_id != 'checklist') {
                        folderList.forEach((element, index) => {
                          const subfolders = element.subfolders;
                          if (element.vault_user_folder_id == undefined) {
                            if (element.id > 10 && element.id == vault_user_folder_id) {
                              if (!this.editEstate) {
                                this.documentForm.controls['selectSaveFolder'].setValue(element.id);
                                this.documentForm.controls['formSelection'].setValue(element.id);
                              }
                            }
                          } else {
                            if (element.vault_user_folder_id == vault_user_folder_id) {
                              if (!this.editEstate) {
                                this.documentForm.controls['selectSaveFolder'].setValue(element.id);
                                this.documentForm.controls['formSelection'].setValue(element.id);
                                const test = [];
                                element.subfolders.forEach((childelement, index) => {
                                  const newelement = {
                                    ...childelement,
                                    ...{ isChildAvailable: false },
                                  };
                                  if (element.subfolders.findIndex((x) => x.parent_vault_user_folder_id == childelement.vault_user_folder_id) != -1) {
                                    newelement.isChildAvailable = true;
                                  }
                                  test.push(newelement);
                                });
                                this.fullSubFolderList = test;
                              }
                            }
                          }
                          if (element.subfolders != undefined) {
                            element.subfolders.forEach((element, index) => {
                              if (element.vault_user_folder_id == vault_user_folder_id) {
                                this.showFolderList = false;
                                const test = [];

                                subfolders.forEach((element) => {
                                  const newelement = {
                                    ...element,
                                    ...{ isChildAvailable: false },
                                  };
                                  if (subfolders.findIndex((x) => x.parent_vault_user_folder_id == element.vault_user_folder_id) != -1) {
                                    newelement.isChildAvailable = true;
                                  }
                                  test.push(newelement);
                                });
                                this.fullSubFolderList = test;
                                this.subfolderList = this.fullSubFolderList.filter(
                                  (x) => x.parent_vault_user_folder_id == element.parent_vault_user_folder_id
                                );
                                this.documentForm.controls['selectSaveFolder'].setValue(element.vault_user_folder_id);
                                this.documentForm.controls['formSelection'].setValue(element.vault_user_folder_id);
                              }
                            });
                          }
                        });
                        if (this.documentForm.controls['formSelection'].value == '') {
                          this.setFormDataWithCurrentID();
                        }
                      } else {
                        this.defaultfolders();
                      }
                      if (this.isCheeckListForm) {
                        if (this.isOficeWorkSpace) {
                          this.documentForm.controls['selectOfficeSaveFolder'].setValue(this.ischeckListFomrId);
                          if (this.officefolderList['id'] == this.ischeckListFomrId) {
                          } else {
                            //the sub folders for office workspace come from here
                            const memberList = this.officefolderList['officeWorkspaceMembers'].filter(
                              (item) => item.user_id == this.currentuserId && item.workspace_folder_id
                            );
                            const folderIdListWithAccess = memberList.map((item) => item.workspace_folder_id);
                            const subFolderList = this.officefolderList['officeWorkspaceFolders'].filter((item) =>
                              folderIdListWithAccess.includes(item.id)
                            );

                            this.officesubfolderList = subFolderList;

                            //this.officesubfolderList = this.officefolderList['officeWorkspaceFolders'];

                            this.showFolderList = false;
                          }
                        } else {
                          const folderList = state['defaultFolders'];

                          this.documentForm.controls['selectSaveFolder'].setValue(this.ischeckListFomrId);
                          folderList.forEach((element, index) => {
                            const subfolders = element.subfolders;
                            if (element.id == this.ischeckListFomrId) {
                              this.showFolderList = true;
                            }
                            if (element.subfolders != undefined) {
                              element.subfolders.forEach((element, index) => {
                                if (element.vault_user_folder_id == this.ischeckListFomrId) {
                                  this.showFolderList = false;
                                  this.subfolderList = subfolders;
                                }
                              });
                            }
                          });
                        }
                        this.cd.detectChanges();
                      }
                    })
                  );
                  if (this.origin == 'vault') {
                    this.SelectFirstGroup();
                  }

                  this.cd.detectChanges();
                },
                (error) => {
                  this.toastr.error(error.error.response.message);
                }
              )
            );
          }
        },
        (error) => {
          this.toastr.error(error.error.response.message);
        }
      )
    );
    if (this.data != null) {
      this.subscription.add(
        this.store
          .select(vaultSelectors.getCurrentFormsById(this.data.form_id ?? this.data.file.fid ?? this.data.file.vault_form_id))
          .subscribe((response) => {
            const { financial_attributes, insurance_attributes } = response;
            if (!!financial_attributes?.trim()) {
              if (financial_attributes?.trim() == 'has_holdings') {
              } else {
                this.hasFinancialAttributes.set(!!response?.financial_attributes);
                this.has_transaction = !!response?.financial_attributes?.split(',').includes('has_transactions');
              }
              if (!!insurance_attributes?.trim()) {
                this.hasInsuranceAttribute.set(true);
              }
            }

            const hasCapitalCommitmentLink = response.has_links === 'Capital Commitment';
            this.hasCapitalCommitmentLink.set(hasCapitalCommitmentLink);
          })
      );
      // this.cd.detectChanges();
      if (this.data['mode'] == 'add') {
        this.filelist = this.data['filelist'];
        this.isViewEditMode = false;
        this.documentForm = this.formBuilder.group(
          {
            documentType: [this.data?.form_id ? this.data?.form_id : '', Validators.required],
            documentName: ['', Validators.required],
            status_progress: ['need to add', Validators.required],

            formSelection: ['', Validators.required],
            selectSaveFolder: ['', Validators.required],
            selectOfficeSaveFolder: ['', Validators.required],
            dynamicFieldsForm: new UntypedFormArray([]),
            beneFicaryForm: new UntypedFormArray([]),
            attributeFormsList: new UntypedFormArray([]),
            showNotes: [''],
            physicalLocation: [''],
            notes: [''],

            expiration_date: [''],
            expiration_notification: [''],

            review_notification: [''],
            review_date: [''],

            renewal_notification: [''],
            renewal_date: [''],

            recurring_expiration: [''],

            value_currency: ['USD'],
            value_current_currency: [''],
            value_is_appraisal: [''],
            value_appraisal_date: [''],
          },
          {
            validators: [this.relationshipTypeThreeConditionallyRequiredValidator.bind(this)],
          }
        );
        this.defaultfolders();
      } else if (this.data?.isintelligent) {
        this.isViewEditMode = false;
        this.documentForm = this.formBuilder.group(
          {
            documentType: [this.data.form_id ? this.data.form_id : 1, Validators.required],
            documentName: ['', Validators.required],
            status_progress: ['need to add', Validators.required],
            formSelection: ['', Validators.required],
            selectSaveFolder: ['', Validators.required],
            selectOfficeSaveFolder: ['', Validators.required],
            dynamicFieldsForm: new UntypedFormArray([]),
            beneFicaryForm: new UntypedFormArray([]),
            attributeFormsList: new UntypedFormArray([]),
            showNotes: [''],
            physicalLocation: [''],
            notes: [''],

            expiration_date: [''],
            expiration_notification: [''],

            review_date: [''],
            review_notification: [''],

            renewal_notification: [''],
            renewal_date: [''],

            recurring_expiration: [''],

            value_currency: ['USD'],
            value_current_currency: [''],
            value_is_appraisal: [''],
            value_appraisal_date: [''],
          },
          {
            validators: [this.relationshipTypeThreeConditionallyRequiredValidator.bind(this)],
          }
        );

        this.defaultfolders();
      } else {
        this.isSavedData = true;
        this.isViewEditMode = true;
        this.mode = this.data['mode'];
        if (this.mode == 'edit') {
          this.isBlueOutlinTextbox = true;
        }
        this.data = this.data['file'];
        this.fileTypeData = this.data['form_name'];
        this.lastUpdated = this.data['updated_at'];
        this.fileType = this.data['type'];
        this.filesize = this.data['size'];
        this.documentForm = this.formBuilder.group(
          {
            documentType: [this.data.vault_form_id, Validators.required],
            documentName: [this.data.form_name, Validators.required],
            status_progress: ['need to add', Validators.required],
            formSelection: [this.data.vault_user_folder_id, Validators.required],
            selectSaveFolder: [this.data.vault_user_folder_id, Validators.required],
            selectOfficeSaveFolder: ['', Validators.required],
            dynamicFieldsForm: new UntypedFormArray([]),
            beneFicaryForm: new UntypedFormArray([]),
            attributeFormsList: new UntypedFormArray([]),
            showNotes: [''],
            physicalLocation: [''],
            notes: [''],

            expiration_date: [''],
            expiration_notification: [''],

            review_date: [''],
            review_notification: [''],

            renewal_notification: [''],
            renewal_date: [''],

            recurring_expiration: [''],

            value_currency: ['USD'],
            value_current_currency: [''],
            value_is_appraisal: [''],
            value_appraisal_date: [''],
          },
          {
            validators: [this.relationshipTypeThreeConditionallyRequiredValidator.bind(this)],
          }
        );
        this.currentFormId = this.data.id ? this.data.id : this.data.vufid;
        this.getItemSetupList();
        this.fId = this.data?.fid;
        this.currentFormName = this.data.form_name;
        this.currentFolderId = this.data.vault_folder_id;
        this.checkFileIsGettingDataFromAI(true);
        this.setEdittempletdataform();
      }
    } else {
      this.isViewEditMode = false;
      this.documentForm = this.formBuilder.group(
        {
          documentType: ['', Validators.required],
          documentName: ['', Validators.required],
          status_progress: ['need to add', Validators.required],
          formSelection: ['', Validators.required],
          selectSaveFolder: ['', Validators.required],
          selectOfficeSaveFolder: ['', Validators.required],
          dynamicFieldsForm: new UntypedFormArray([]),
          beneFicaryForm: new UntypedFormArray([]),
          attributeFormsList: new UntypedFormArray([]),
          showNotes: [''],
          physicalLocation: [''],
          notes: [''],

          expiration_date: [''],
          expiration_notification: [''],

          review_date: [''],
          review_notification: [''],

          renewal_notification: [''],
          renewal_date: [''],

          recurring_expiration: [''],

          value_currency: ['USD'],
          value_current_currency: [''],
          value_is_appraisal: [''],
          value_appraisal_date: [''],
        },
        {
          validators: [this.relationshipTypeThreeConditionallyRequiredValidator.bind(this)],
        }
      );

      this.defaultfolders();
    }

    this.subscription.add(
      this.documentForm.get('formSelection').valueChanges.subscribe((val) => {
        this.defaultfolders();
        if (!this.editEstate) {
          this.documentForm.get('selectSaveFolder').setValue(val);
        }
      })
    );

    this.subscription.add(
      this.documentForm.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe((data) => {
        Object.keys(this.documentForm.controls).forEach((field) => {
          const control = this.documentForm.get(field);
          if (control.dirty) {
            this.addApiRapidValueService.setPropertyDataFromGeneral(control.value[0], this.templateId);
          }
        });
      })
    );

    this.subscription.add(
      this.documentForm.get('documentType').valueChanges.subscribe((val) => {
        const selectedObj = this.typeList.findIndex((x) => x.value == val);
        if (selectedObj != -1) {
          // this.documentForm.get('documentName').setValue(this.typeList[selectedObj].name);
        } else {
          // this.documentForm.get('documentName').setValue('');
        }
        this.setformData(val);
      })
    );

    if (this.isfileListLoad == true) {
      this.getfileliseForCurrentForms();
    }
    if (this.currentWorkSpaceId) {
      this.showLocationSection = true;
      if (url[4] == 'folder') {
        this.currentWorkSpaceFolderId = url[5];
      }
      if (this.selectOfficeSaveFolderData != -1) {
        this.currentWorkSpaceId = this.selectOfficeSaveFolderData;
      }

      this.isOficeWorkSpace = true;
      if (this.currentuserId != this.currentValutUserId) {
        this.isOficeWorkSpace = false;
      }
      if (this.router.url.includes('my-workspace') || this.router.url.includes('admin-workspace')) {
        this.isOficeWorkSpace = true;
      }
    }
    if (this.router.url.includes('admin=true') && url[1] == 'office') {
      this.showLocationSection = true;
    }

    if (this.data.estate_tab_group_id || this.editEstate) {
      this.hideForloderSelection = true;
      if ((this.mode?.toLowerCase() == 'view' || this.mode?.toLowerCase() == 'edit') && this.data?.estate_asset_tab_group_id) {
        this.documentForm.controls.selectSaveFolder.setValue(this.data?.estate_asset_tab_group_id);
      }
    }
    this.subscription.add(
      this.documentForm.controls['value_currency'].valueChanges.subscribe((val) => {
        const finLemd = this.currenciesList.find((x) => x.cc == val);
        this.currecntCurrecySymbol = finLemd?.symbol;
      })
    );
    // this.documentForm.controls['value_current_currency'].valueChanges
    //   .pipe(startWith(1), pairwise()).subscribe(
    //     ([prevValue, selectedValue]) => {
    //       var total = parseFloat(selectedValue.replace(/,/g, ''));
    //       let decimalformattotal = total.toFixed(2).toString();

    //       let formattotal = decimalformattotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    //       if (formattotal == 'NaN') {
    //         this.documentForm.controls['value_current_currency'].setValue('');
    //       }
    //       else if (formattotal != selectedValue) {
    //         this.documentForm.controls['value_current_currency'].setValue(formattotal);
    //       }
    //       // if (+total % 1 != 0) {
    //       //   let result = formattotal.indexOf(".");
    //       //   formattotal = formattotal.substring(0, result + 3);
    //       //   if (formattotal != selectedValue) {
    //       //     this.documentForm.controls['value_current_currency'].setValue(formattotal);
    //       //   }
    //       // } else {

    //       //   if (selectedValue.includes('.')) {
    //       //     formattotal = formattotal + ".";
    //       //   }
    //       //   if (formattotal != selectedValue) {
    //       //     this.documentForm.controls['value_current_currency'].setValue(formattotal);
    //       //   }
    //       // }

    //     }
    //   );
    if (!!this.data?.id) {
      this.getSetupTag(this.currentFormId);
    }
    this.vaultSideNavService.handleModal(false);
    this.getFormUserPublicKey(this.currentFormId);
    this.getScanIndexFile({
      form_id: this.data.form_id ? this.data.form_id : this.data.id,
      fid: this.data?.fid ? this.data?.fid : this.data?.vault_form_id,
    });

    const formId = this.data?.form_id ?? this.data?.fid ?? this.data?.vault_form_id;
    this.subscription.add(
      this.store.select(vaultSelectors.getCurrentFormsById(formId)).subscribe((response) => {
        const hasLinks = response?.has_links?.split(',') || [];
        this.showLinkedPaymentMethod =
          hasLinks.includes('Payment Method') ||
          hasLinks.includes('Linked Payment Method') ||
          hasLinks.includes('Secured By') ||
          hasLinks.includes('Loans Secured');
        hasLinks.forEach((link) => {
          const trimmedLink = link.trim(); // optional: in case of spaces
          if (trimmedLink === 'Secured By') {
            this.paymentMethodTypes.push('Secured By');
          }
          if (trimmedLink === 'Loans Secured') {
            this.paymentMethodTypes.push('Loans Secured');
          }
          if (trimmedLink === 'Payment Method') {
            this.paymentMethodTypes.push('Linked Payment Method');
          }
          if (trimmedLink === 'Linked Payment Method') {
            this.paymentMethodTypes.push('Payment Method');
          }
        });
      })
    );
  }
  linkTypes: ('Payment Method' | 'Linked Payment Method' | 'Secured By' | 'Loans Secured')[] = [
    'Payment Method',
    'Linked Payment Method',
    'Secured By',
    'Loans Secured',
  ];
  paymentMethodTypes = [];
  updateFiles(newFiles: any[]) {
    this.documentFiles$.next(newFiles);
  }

  onEnterName(event: KeyboardEvent) {
    this.saveFromName();
    (event.target as HTMLElement).blur();
  }

  onFocusOut(event: FocusEvent) {
    this.saveFromName();
  }

  getScanIndexFile(ids: { form_id?: string; fid?: string }) {
    const { form_id, fid } = ids;
    this.ScanFiles = this.formsList.find((form) => form.id === form_id || form.id === fid);

    if (this.ScanFiles && this.ScanFiles.suggested_documents) {
      this.ScanFileList = this.ScanFiles.suggested_documents.split(',');
    } else {
      this.ScanFileList = [];
    }
  }

  // getFormStatus(currentFormId) {
  //   this.subscription.add(
  //     this.documentService.getformStatusById(this.currentuserId, currentFormId).subscribe(
  //       (res) => {
  //         this.notification_status = res.status;
  //         this.notificationLoading = false;
  //         this.cd.detectChanges();
  //       },
  //       (error) => {}
  //     )
  //   );
  // }

  vaultSelectionUpdateEvent(event) {
    if (event.action == 'update_vault_selection') {
      this.subscription.add(
        this.actions$.pipe(ofType<vaultStoreActions.GetVaultSuccessAction>(vaultStoreActions.ActionTypes.GET_VAULT_SUCCESS)).subscribe(() => {
          // 👉 This runs only after API success
          this.vaultSelectionForm.vaultSuggestion();
        })
      );
    }
  }

  aiRunningEvent(event: any) {
    this.analyzeWithAi = event;
    if (event) {
      this.refreshTemplateDocumentTag();
    }
  }
  async getExistingUser() {
    //get a list of existing users who have been shared this form
    await new Promise<void>((resolve) => {
      this.subscription.add(
        this.vaultShareService.getSharedFormUserList(this.currentFormId, this.vaultStateObject.userId).subscribe((results) => {
          const existingUsers = results;
          this.subscription.add(
            this.store.select(selectors.getrelationshipnameList(existingUsers)).subscribe((item) => {
              this.data.sharedUsers = item.map((obj) => ({
                first_name: obj.user_first_name,
                last_name: obj.user_last_name,
                profile_image_url: obj.user_profile_image_url,
              }));
              this.cd.detectChanges;
              // this.cd.markForCheck();
            })
          );
          resolve();
        })
      );
    });
  }

  getSetupTag(id: string) {
    this.subscription.add(
      this.sharedVaultService.getVaultSetupFormTag(this.currentuserId, id).subscribe((res) => {
        this.setupFormTags = res;
        this.cd.detectChanges();
      })
    );
  }

  mobileonFocusEvent(event: any) {
    this.showIcon = true;
    let nummber = event.target.value.length * 12;
    nummber = nummber + 72;
    if (nummber > 520) {
      nummber = 520;
    }
    // eval(`document.getElementById("document-form-nameTextbox").style.width='${nummber}px'`);
    this.cd.detectChanges();
  }
  EstateFolderList(Estateid) {}
  customCss() {
    this.styleElement = document.createElement('style');
    const head = document.getElementsByTagName('head')[0];
    let height = '0';
    let pannelheight = '0';
    if (this.folderList != null) {
      height = (this.folderList.length * 36 + 109).toString();
      pannelheight = (this.folderList.length * 36 + 50).toString();
      if (this.isOficeWorkSpace) {
        if (this.showFolderList) {
          height = (36 + 109).toString();
          pannelheight = (36 + 50).toString();
        } else {
          height = (this.officesubfolderList.length * 42 + 109).toString();
          pannelheight = (this.officesubfolderList.length * 42 + 50).toString();
        }
      }
      if (+pannelheight < 250) {
        pannelheight = '250';
        height = '304';
      }
      let css = '';
      if (this.data.isLinked) {
        css = `
        .cdk-overlay-container .cdk-overlay-pane .testClass-for-footer-menu{
          margin-top: -${height}px;
          left: 0px;
          height: ${pannelheight}px !important;
          max-height:none !important;
          border-radius: 0px !important;
          box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25) !important;
          }
        `;
      } else {
        css = `
        .cdk-overlay-container .cdk-overlay-pane .testClass-for-footer-menu{
          margin-top: 0px;
          left: -8px;
          height: ${pannelheight}px !important;
          max-height:none !important;
          border-radius: 0px !important;
          box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25) !important;
          }
        `;
      }
      // this.styleElement.textContent = '';
      // this.styleElement.type = 'text/css';
      // this.styleElement.appendChild(document.createTextNode(css));
      // head.appendChild(this.styleElement);
    } else {
      if (+pannelheight < 250) {
        pannelheight = '250';
        height = '304';
      }
      let css = '';
      if (this.data.isLinked) {
        css = `
        .cdk-overlay-container .cdk-overlay-pane .testClass-for-footer-menu{
          margin-top: -${height}px;
          left: 0px;
          height: ${pannelheight}px !important;
          max-height:none !important;
          border-radius: 0px !important;
          box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25) !important;
          }
        `;
      } else {
        css = `
        .cdk-overlay-container .cdk-overlay-pane .testClass-for-footer-menu{
          margin-top: 0px;
          left: -8px;
          height: ${pannelheight}px !important;
          max-height:none !important;
          border-radius: 0px !important;
          box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.25) !important;
          }
        `;
      }
      // this.styleElement.textContent = '';
      // this.styleElement.type = 'text/css';
      // this.styleElement.appendChild(document.createTextNode(css));
      // head.appendChild(this.styleElement);
    }
  }
  onPercentChange(percent: any) {
    let nummber = this.documentForm.controls.documentName.value.length * 12;
    nummber = nummber + 72;
    if (nummber > 520) {
      nummber = 520;
    }

    // eval(`document.getElementById("document-form-nameTextbox").style.width='${nummber}px'`);
  }
  mobileonFocusOutEventName(event: any) {
    this.showIcon = false;
    if (
      this.documentForm.get('documentName').value == '' ||
      this.documentForm.get('documentName').value == undefined ||
      this.documentForm.get('documentName').value == null
    ) {
      this.documentForm.get('documentName').setValue('Untitled File');
    }
    let nummber = this.documentForm.controls.documentName.value.length * 12;
    nummber = nummber + 72;
    if (nummber > 520) {
      nummber = 520;
    }

    // eval(`document.getElementById("document-form-nameTextbox").style.width='${nummber}px'`);
    this.cd.detectChanges();
  }
  currentFormDesign() {
    if (this.data?.isintelligent == true || this.data?.mode == 'add') {
      return 'add-automtic-form-desing';
    } else {
      if (this.mode == 'view') {
        return 'automtic-form-desing-form-only';
      } else {
        return this.isGeneralSectionResolve ? 'blue-border-color-automtic-form-desing' : 'automtic-form-desing-form-only';
      }
    }
  }

  itemsToSetUpAction(event) {
    if (event.type == 'location') {
      if (event.sub_type == 'Physical') {
        this.LocationLinkedPhysicalValue.openPopFromList(event);
      } else if (event.sub_type == 'Password') {
        this.LocationLinkedPasswordValue.openPopFromList(event);
      }
    }
    if (event.type == 'general') {
      this.isGeneralSectionResolve = true;
    }
    if (event.type == 'description') {
      this.NgxEditorField.changeBlueEditor();
    }
    if (event.type == 'attach') {
      const index = this.itemsToSetUpListAttachment.findIndex((x) => x.id == event.id);
      this.createAttachmentSetup(this.itemsToSetUpListAttachment[index], index);
    }

    if (event.type == 'api') {
      if (event.sub_type == 'VehicleDatabase') {
        this.AddApiRapidMotorValue.addEditMotorData();
      } else if (event.sub_type == 'MX') {
        this.AddApiKeyManaged.editDataFeedDate();
      } else if (event.sub_type == 'Zillow') {
        this.AddApiRapidPropertyValue.addEditMotorData();
      }
    }
    if (event.type == 'role_players') {
      this.rolePlayersInFormComponent.openManageRolePlayersDialog(event);
    }
    if (event.type == 'financial_atributes' || event.type == 'financial_attributes') {
      const attribute = this.AddFinancialAttribute.attributesList().find(
        (att) => att.value.vault_form_code?.toLowerCase() === event.sub_type?.toLowerCase()
      );
      // if (attribute?.value?.isDynamic) {
      //   this.appDynamicAttributes.attribute = attribute;
      //   this.appDynamicAttributes.openFormDialog();
      // } else {
      this.AddFinancialAttribute.openFormDialog(attribute?.getFormValues?.attribute, attribute, 'create');
      // }
    }
    if (event.type == 'insurance_attributes') {
      const attribute = this.insuranceAttribute
        .attributesList()
        .find((att) => att.value?.vault_form_code?.toLowerCase() === event?.sub_type?.toLowerCase());

      if (attribute?.value?.isDynamic) {
        // const { attribute, userId, attributes, title, currentFormId, attribute_type } = this.insuranceAttribute.appDynamicAttributes;
        // this.appDynamicAttributes.attribute = attribute;

        this.insuranceAttribute.appDynamicAttributes.openFormDialog();
      } else {
        this.insuranceAttribute?.openFormDialog(attribute.getFormValues?.attribute, attribute, 'create');
      }
    }
    if (event.type == 'share') {
      if (this.nonVaultFormsOrigins.includes(this.data.origin)) {
        this.managePermissionKey();
      } else {
        this.sharedocument();
      }
    }
    if (event.type == 'note') {
      this.notesComponent.openModal(event);
    }
    if (event.type == 'reminder') {
      this.ReminderV2Value.createReminder();
    }
    this.cd.detectChanges();
  }
  fileTriggerAI(fileId, file, fileName) {
    this.subscription.add(
      this.documentService
        .updateFileUploadTriggerAI(
          {
            id: fileId,
          },
          true
        )
        .subscribe((res) => {
          this.toastr.success(`${fileName} File processed with AI`);
          const indexOfArray = this.files.findIndex((x) => x == file);
          //return security key generated by worker process
          if (indexOfArray >= 0) {
            this.files[indexOfArray].ai_is_running = true;
          }

          this.cd.detectChanges();
        })
    );
  }
  getfileliseForCurrentForms() {
    this.isTemplateDocumentTagLoading = true;
    this.subscription.add(
      this.documentService.getUploadedFilesListbyformId(this.currentFolderId, this.currentFormId).subscribe(
        (res) => {
          this.files = [];
          res.files.forEach((element) => {
            const parsedTagData = JSON.parse(element.tag);
            this.files.push({
              status: 'Done',
              linked_location: element?.linked_location,
              form_name: element?.form_name,
              check_ai_running: false,
              file_name_without_extesion:
                element.display_file_name.split('.').length == 0
                  ? element.display_file_name
                  : element.display_file_name.split('.').slice(0, -1).join('.'),
              display_file_name: element.display_file_name,
              name: element.file_name,
              progressbar: 100,
              vault_user_form_uploads_id: element.id,
              vault_user_inbox_id: element.vault_user_inbox_id,
              delete_id: element.id,
              is_password_protected: element.is_password_protected,
              delete_upload_path: res.upload_path,
              created_at: element.created_at,
              isActive: false,
              year: parsedTagData?.year,
              vault_user_tag_id: element?.vaultUserTagId,
              document_type: parsedTagData?.document_type,
              document_suggestion_tag: element.document_suggestion_tag,
              version: element?.version,
              message_subject: element?.message_subject,
              message_textAsHtml: element?.message_textAsHtml,
              document_date: element?.document_date,
              from_name: element?.from_name,
              suggested_new_vault_name: element.suggested_new_vault_name,
              suggested_new_vault_type: element.suggested_new_vault_type,
              suggested_vault_id: element.suggested_vault_id,
              suggestion_type: element.suggestion_type,
              from_email: element?.from_email,
              new_form_name: element?.new_form_name,
              vault_user_inbox_suggestion_id: element?.vaultUserInboxSuggestionId,
              size: element?.size,
              file_type: element?.document_type,
            });
          });
          this.templateType = res.files[0].document_type;
          this.newAISuggestedFormName = res.files[0].new_form_name;
          this.vaultUserInboxSuggestionId = res.files[0].vaultUserInboxSuggestionId;
          this.isTemplateDocumentTagLoading = false;
          this.selectedFile = undefined;
          try {
            this.formAttachment.ngOnInit();
          } catch (error) {}
          this.cd.detectChanges();
          this.updateFiles(this.files);
        },

        (error) => {}
      )
    );
  }
  getFileExtensionOnly(fileName: string): string {
    if (!fileName) {
      return 'doc';
    }
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1) {
      return 'doc';
    }
    return fileName.substring(lastDotIndex + 1).toLowerCase();
  }
  summaryUpdate() {
    try {
      this.nonDocumentSummary.ngOnInit();
    } catch (error) {}
    try {
      this.attachDocument();
    } catch (error) {}
  }
  attachDocument() {
    this.ai_is_upload_Running = true;
    this.checkFileIsGettingDataFromAI();
  }
  async checkFileIsGettingDataFromAI(stopeEditTemplate = false) {
    // Terminate previous worker if exists
    if (this.checkAIWorker) {
      this.checkAIWorker.terminate();
    }

    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        this.checkAIWorker = new Worker(new URL('./check-ai-status-upload-file.worker', import.meta.url), { type: 'module' });

        const data = {
          token: '',
          url: `${environment.apiUrl}/api/vault/check-upload-file-ai-running`,
          vault_user_form_id: this.currentFormId,
        };
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        this.checkAIWorker.onmessage = async ({ data }) => {
          if (data.data.ai_is_running) {
            this.aiCheckTimeoutId = setTimeout(() => {
              this.checkFileIsGettingDataFromAI();
            }, 15000);
          } else {
            this.ai_is_upload_Running = false;
            if (this.rolePlayersInFormComponent) {
              this.rolePlayersInFormComponent.refreshAISuggestions();
            }

            try {
              this.nonDocumentSummary.ngOnInit();
            } catch (error) {}
            if (!stopeEditTemplate) {
              try {
                this.setEdittempletdataform();
              } catch (error) {}
            }
          }
          resolve(data);
        };
        this.checkAIWorker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generatecreateFileAfterS3UrlCrete(null));
      }
    });
  }

  generatecreateFileAfterS3UrlCrete(data: any): unknown {
    throw new Error('Method not implemented.');
  }

  classname(item) {
    if (item != 1 && item != 2 && item != 3 && item != 4 && item != 5 && item != 6 && item != 7 && item != 8 && item != 0) {
      item = 99;
    }
    if (this.isOficeWorkSpace && this.showFolderList) {
      item = 100;
    }
    if (this.isInformationWorkSpace && item != 1) {
      item = 99;
    }
    return 'option' + item;
  }
  uploadFile(event) {
    this.active = false;
    this.showStoragePopup = true;
    for (let index = 0; index < event.length; index++) {
      const element = event[index];

      const fileSizeInKB = element.size / 1024;
      const fileSizeInMB = fileSizeInKB / 1024;
      const extension = element['name'].split('?')[0].split('.').pop();
      if (this.FileUploadedLimitExtension.findIndex((item) => item == extension.toUpperCase()) == -1) {
        this.toastr.error(`This type of file is not supported : ${element['type']}`);
      } else if (fileSizeInMB > this.FileUploadedLimit) {
        this.toastr.error(`This file exceeds the limit of ${this.FileUploadedLimit} mb`);
      } else {
        this.uploadfileToserver(element['name'], element['size'], element, element['type'], this.files.length, this.counter++);
        this.cd.detectChanges();
      }
    }
  }
  moveAssetItem() {
    const dialogRef = this.dialog.open(AddFolderDialogWithVaultComponent, {
      // width: '300px',
      panelClass: 'attachment-move',
      data: { vaultObject: null, defaultFolders: this.defaultFolders, title: 'Move File To', includeSubfolders: true, hideGroup: false },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((data) => {
        if (data.confirmation && data.vault_id) {
          this.updateSelectedVault(data.vault_id, data.vault_name);
          this.moveFormToVault(this.currentFormId, data.vault_id);
        } else if (data.confirmation && data.subfolderSelected) {
          this.moveFormToGroup(this.currentFormId, data.subfolderSelected.vaultFolderId);
        }
      })
    );
  }
  moveFormToVault(formId, vault_id, user_id = null) {
    const data = {
      vault_id: vault_id,
      id: [formId],
      vault_user_id: user_id != null ? user_id : this.stateObject.userId,
    };
    this.subscription.add(
      this.documentService.updateFormGroupId(data).subscribe((res) => {
        this.updateUIWIthAPIData();
        this.toastr.success('File moved successfully');
      })
    );
  }
  moveFormToGroup(formId, groupId) {
    const data = {
      vault_user_group_id: groupId,
      id: [formId],
    };
    this.subscription.add(
      this.documentService.updateFormGroupId(data).subscribe((res) => {
        this.updateUIWIthAPIData();
        this.toastr.success('File moved successfully');
      })
    );
  }
  updateUIWIthAPIData() {
    const url = this.router.url.split('/');
    const getFilesModel = {
      folderId: url?.length > 6 ? url[6] : url[4],
      userId: this.stateObject.userId,
      mydata: this.router.url.includes('mydata') ? true : false,
    };

    this.store$.dispatch(new vaultStoreActions.PersonalFolderFilesRequest(getFilesModel));
    this.subscription.add(
      this.notifySummaryUpdateService.sendMessage({
        needToUpdateUI: true,
      })
    );
  }
  openActivityLogModel() {
    const modalRef2 = this.dialog.open(ActivityLogFileComponent, {
      disableClose: true,
      data: {
        isFile: true,
        Id: this.currentFormId,
        fileFolderName: this.documentForm.controls.documentName.value,
      },
      panelClass: 'full-window-dialog',
      autoFocus: false,
    });
  }

  openCreateShareLinkDialog() {
    const dialogRef = this.dialog.open(CreateShareLinkComponent, {
      panelClass: 'create-share-link-dialog',
      data: { vaultFormId: this.currentFormId, formName: this.documentForm.controls['documentName'].value },
    });

    this.subscription.add(dialogRef.afterClosed().subscribe((data) => {}));
  }

  openCannotShareWarningDilaog() {
    this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      height: '194px',
      data: {
        title: 'Cannot share link',
        materialIcon: 'warning',
        text: 'You cannot share link’s from a protected file',
        proceedTitle: 'Ok',
      },
    });
  }

  uploadfileToserver(fileName, size, file, type, index, currentIndex) {
    const data = {
      vault_user_form_id: this.currentFormId,
      user_id: this.securityStateObject.userId,
      name: fileName,
      file_name_without_extesion: fileName.split('.').slice(0, -1).length == 0 ? fileName : fileName.split('.').slice(0, -1).join('.'),
      display_file_name: fileName,
      size: size,
      type: file.type,
    };
    this.loaderService.show();
    this.subscription.add(
      this.documentService.postCreatePresignedUrl(data, false).subscribe(
        async (res) => {
          this.files.push({
            status: 'Uploading',
            file_name_without_extesion: fileName.split('.').slice(0, -1).length == 0 ? fileName : fileName.split('.').slice(0, -1).join('.'),
            display_file_name: fileName,
            progressbar: 0,
            name: fileName,
            created_at: res['created_at'],
            delete_id: res['id'],
            delete_upload_path: res['upload_path'],
          });
          this.loaderService.show();
          const xhr = new XMLHttpRequest();
          xhr.upload.onprogress = (progEvent: ProgressEvent) => {
            if (progEvent.lengthComputable) {
              const uploadedSoFar = (progEvent.loaded / progEvent.total) * 100;
              this.files[currentIndex]['progressbar'] = Math.trunc(uploadedSoFar);
              this.cd.detectChanges();
            }
          };

          let usersPk;
          //check to see if this form is part of a workspace, if so use workspace owner for file encryption work
          if (this.origin == 'workspace') {
            usersPk = this.currentWorkspaceOwner.public_key;
          } else {
            usersPk = this.public_key();
          }

          if (!this.formEncryptionKey) {
            //ensure we have a form encyprtion key incase a file is attached before the first form save
            this.formEncryptionKey = this.cryptoService.generateEncryptionKey(usersPk, null, null).plain;
          }

          let encryptedFile;
          if (this.isSecurityKeyAdded && this.manageSecuritykey != null && this.manageSecuritykey[0]['sk']) {
            //encrypt file before sending it to the server
            encryptedFile = await this.cryptoService.encryptFile(file, this.public_key(), this.formEncryptionKey, this.security_key, this.sk);
          } else {
            //encrypt file before sending it to the server
            encryptedFile = await this.cryptoService.encryptFile(file, usersPk, this.formEncryptionKey, null, null);
          }

          xhr.open('PUT', res['upload_url'], true);
          xhr.setRequestHeader('Content-Type', file.type);
          xhr.send(file);
          xhr.onload = () => {
            if (xhr.readyState === xhr.DONE) {
              const data = {
                id: this.files[currentIndex]['delete_id'],
                status: 'uploaded',
                encryption_key: null,
                premium_encrypted: null,
              };
              this.subscription.add(
                this.documentService.setFileuploadedStatus(data).subscribe(
                  (res) => {
                    this.files[currentIndex]['status'] = 'Done';
                    this.loaderService.hide();
                    this.fileExtensionComponentchild.forEach((FileExtensionComponent, index) => {
                      if (currentIndex == index) {
                        FileExtensionComponent.doSomething();
                      }
                    });

                    this.fileCount++;
                    this.cd.detectChanges();
                  },
                  (error) => {
                    this.loaderService.hide();
                    this.toastr.error('Error uploading File');
                  }
                )
              );
              this.cd.detectChanges();
              this.updateFiles(this.files);
            }
          };
        },
        (error) => {
          if (this.showStoragePopup) {
            const modalRef3 = this.dialog.open(PaymentErrorScreenComponent, {
              panelClass: 'full-window-dialog-2',
              autoFocus: false,
              disableClose: true,
              data: error?.error,
            });

            this.showStoragePopup = false;
          }
        }
      )
    );
  }
  makedocumentEdit() {
    this.isBlueOutlinTextbox = true;
    this.mode = 'edit';
    this.isSavedData = false;
    //this.documentForm.controls["documentType"].setValue("1");
    this.cd.detectChanges();
  }
  checkFormIsSAvedOrNot() {
    if (this.mode == 'view' && this.isRemoveEditSaveSharing == true) {
      this.dialogRef.close();
      return;
    }
    if (this.mode != 'edit' && this.mode != 'view' && !this.isRemoveEditSaveSharing) {
      const dynamicFieldsFormValue = this.documentForm.controls.dynamicFieldsForm.value[0];
      const beneFicaryForm = this.documentForm.controls.beneFicaryForm.value;
      const object_keylist = Object.keys(this.documentForm.controls.dynamicFieldsForm.value[0]);
      let value_updated = false;
      object_keylist.forEach((element) => {
        if (dynamicFieldsFormValue[element] != '' && dynamicFieldsFormValue[element] != null && dynamicFieldsFormValue[element] != undefined) {
          value_updated = true;
        }
      });
      if (value_updated) {
        this.checkValue(this.documentForm.value);
        this.saveFormName();
      } else {
        this.subscription.add(
          this.documentService.checkFormIsblank(this.currentFormId).subscribe((res) => {
            if (res) {
              const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
                width: '400px',

                data: {
                  title: 'Blank Template',
                  materialIcon: 'info_outline',
                  text: 'No information has been added to this template. Do you want to save it?',
                  proceedTitle: `Save`,
                  backBUttonTitle: `Don't Save`,
                  backButtonBold: true,
                  showCancelBtn: true,
                  hasThirdButton: true,
                  thirdButtonTitle: 'Cancel',
                  isFromAddDocument: true,
                },
              });
              this.subscription.add(
                dialogRef.afterClosed().subscribe((confirmationData) => {
                  const { isCancel, confirmation } = confirmationData;
                  if (isCancel) {
                    return;
                  }
                  // this.dialogRef.close();
                  if (confirmation) {
                    this.checkValue(this.documentForm.value);
                    this.saveFormName();
                    if (this.router.url.includes('/home')) {
                      this.notifyUpdateItemToResolve.sendMessage({ type: 'attach' });
                    }
                  } else {
                    this.dialogRef.close({ success: false });
                  }
                })
              );
            } else {
              this.checkValue(this.documentForm.value);
              this.saveFormName();
            }
          })
        );
      }
    } else {
      const findDiffData = this.jsonDiffPipe.transform(this.documentForm.controls.dynamicFieldsForm.value, this.savedDynamicFieldsFormValueInDb);
      if (findDiffData) {
        this.saveGeneralSetup();
        this.checkValue(this.documentForm.value, false);
        this.saveFormName();
      } else {
        this.is_linked_form_id = this.data?.is_linked_form_id ?? -1;
        if (this.is_linked_form_id == -1) {
          this.subscription.add(this.notifyEstateActiveTabUpdate.sendMessage('true'));
        }
        this.dialogRef.close();
      }
    }
  }
  closedialog() {
    if (this.data?.isintelligent == true || this.data?.mode == 'add' || this.mode == 'edit') {
      if (this.isSavedData) {
        this.subscription.add(
          this.checkFileEncryption().subscribe(() => {
            if (this.isOficeWorkSpace) {
              this.subscription.add(this._notifyWorkSpaceUpdate.sendMessage('true'));
            }
            if (this.router.url.includes('/vault/my-checklist')) {
              this.subscription.add(this.checklistUpdate.sendMessage('true'));
            }
            // Refresh home page components if on home page
            if (this.router.url.includes('/home')) {
              this.subscription.add(
                this.notifyUpdateItemToResolve.sendMessage({
                  type: 'attach',
                })
              );
            }
            this.removeCssFromPopUpWindow();
            this.dialogRef.close();
          })
        );
      } else {
        const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
          width: '400px',
          data: {
            title: 'Exit without saving?',
            materialIcon: 'warning',
            text: 'This template has not been saved. Closing without saving will delete this template and all information which has been added.',
            proceedTitle: 'Close',
          },
        });

        this.subscription.add(
          dialogRef.afterClosed().subscribe((confirmation) => {
            if (confirmation) {
              this.closedSideNavTemplate.sendMessage('true');
              const url = this.router.url.split('/');
              const getFilesModel = {
                folderId: url?.length > 6 ? url[6] : url[4],
                userId: this.currentValutUserId,
                mydata: this.router.url.includes('mydata') ? true : false,
              };

              if (this.router.url.includes('collaboration') && !this.router.url.includes('admin=true')) {
                getFilesModel['userId'] = this.currentuserId;
              }
              this.subscription.add(this.notifyEstateActiveTabUpdate.sendMessage('true'));
              this.subscription.add(
                this.notifySummaryUpdateService.sendMessage({
                  needToUpdateUI: true,
                })
              );
              if (
                this.router.url.includes('network/checklist?admin=true') ||
                this.router.url.includes('/network/admin-vault?admin=true') ||
                this.router.url.includes('network/admin-vault/search-results-data?q=')
              ) {
              } else {
                if (!this.data?.is_linked_form_id) {
                  if (getFilesModel.folderId && getFilesModel.userId) {
                    this.store$.dispatch(new vaultStoreActions.PersonalFolderFilesRequest(getFilesModel));
                  }
                }
              }
              if (this.isOficeWorkSpace) {
                this.subscription.add(this._notifyWorkSpaceUpdate.sendMessage('true'));
              }
              if (this.router.url.includes('/vault/my-checklist')) {
                this.subscription.add(this.checklistUpdate.sendMessage('true'));
              }
              // Refresh home page components if on home page
              if (this.router.url.includes('/home')) {
                this.subscription.add(
                  this.notifyUpdateItemToResolve.sendMessage({
                    type: 'attach',
                  })
                );

                this.subscription.add(
                  this.notifySummaryUpdateService.sendMessage({
                    needToUpdateUI: true,
                  })
                );
              }
              this.removeCssFromPopUpWindow();
              this.dialogRef.close();
            }
          })
        );
      }
    } else {
      this.subscription.add(
        this.checkFileEncryption().subscribe(() => {
          if (this.isOficeWorkSpace) {
            this.subscription.add(this._notifyWorkSpaceUpdate.sendMessage('true'));
          }
          if (this.router.url.includes('/vault/my-checklist')) {
            this.subscription.add(this.checklistUpdate.sendMessage('true'));
          }
          // Refresh home page components if on home page
          if (this.router.url.includes('/home')) {
            this.subscription.add(
              this.notifyUpdateItemToResolve.sendMessage({
                type: 'attach',
              })
            );
          }
          this.removeCssFromPopUpWindow();
          this.dialogRef.close();
        })
      );
    }
  }
  removeCssFromPopUpWindow() {
    //alert(this.data?.isLinked);
    try {
      if ($('.full-window-dialog-add-document').length == 1 && !this.data?.isLinked) {
        $('.full-window-dialog-add-document').remove();
      }
    } catch (error) {}
  }
  openAutoNaming() {
    if (this.mode == 'view') {
      return;
    }
    const dialogRef = this.dialog.open(AutoNamingFormModelComponent, {
      width: '480px',
      data: {
        auto_naming_disabled: this.auto_naming_disabled,
        currentFormId: this.currentFormId,
      },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation && confirmation.success) {
          this.auto_naming_disabled = confirmation.auto_naming_disabled;
          this.cd.detectChanges();
        }
      })
    );
  }
  deleteAttachment(index, id, display_file_name) {
    const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: { title: 'Delete File', materialIcon: 'delete', text: `Are you sure you want to delete ${display_file_name}?`, proceedTitle: 'Delete' },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this.documentService.deletUserUploadedFile(this.securityStateObject.userId, id).subscribe(
              (res) => {
                this.files.splice(index, 1);
                this.toastr.success(`${display_file_name} deleted`);
                this.fileUploadCount--;
                this.cd.detectChanges();
              },
              (error) => {
                this.toastr.error('Error deleting File');
              }
            )
          );
        }
      })
    );
  }

  // =============== initial security key implementation =================
  // setValue(event) {
  //   if (!this.isClicked) {
  //     this.isClicked = true;
  //     this.isSecurityKeyAdded = !this.isSecurityKeyAdded;
  //     if (this.isSecurityKeyAdded) {
  //       this.getSecurityKey(event, true);
  //     } else {
  //       event.source.checked = false;
  //       this.isSecurityKeyAdded = false;
  //       this.isClicked = false;
  //       this.cd.detectChanges();
  //     }
  //   }
  // }
  // openSecurityKeyDialog(event) {
  //   const dialogRef = this.dialog.open(SecurityComponent, {
  //     panelClass: 'full-window-dialog',
  //     data: { securityKeyFirstStep: true },
  //   });
  //   this.subscription.add(
  //     dialogRef.afterClosed().subscribe((res) => {
  //       if (res && res['openNextStep']) {
  //         const dialogRef2 = this.dialog.open(SecurityStepperComponent, {
  //           panelClass: 'full-window-dialog',
  //           disableClose: true,
  //           data: { showkeyName: true, showSecurityKey: true, showHint: true, showSafeguardKey: true },
  //         });
  //         this.subscription.add(
  //           dialogRef2.afterClosed().subscribe((res) => {
  //             if (res != undefined) {
  //               if (res?.confirmation) {
  //                 // this.toastr.success('File has been protected with Security key');
  //                 event.source.checked = true;
  //                 this.getSecurityKey(event, true);
  //                 this.cd.detectChanges();
  //               } else if (res?.isSkip) {
  //                 event.source.checked = false;
  //                 this.isSecurityKeyAdded = false;
  //                 this.cd.detectChanges();
  //               }
  //             }
  //           })
  //         );
  //       } else {
  //         event.source.checked = false;
  //         this.isSecurityKeyAdded = false;
  //         this.cd.detectChanges();
  //       }
  //     })
  //   );
  // }
  // getSecurityKey(event, showToast) {
  //   this.subscription.add(
  //     this.documentService.getSecurityKeyWidhId(this.currentValutUserId).subscribe(
  //       (res) => {
  //         this.isClicked = false;
  //         this.manageSecuritykey = res.Items;
  //         if (res.Items != undefined && res.Items.length) {
  //           this.isSecurityKeyAdded = true;
  //           this.manageSecuritykey = res.Items;
  //           this.toastr.success('File has been protected with Security key');
  //           this.cd.detectChanges();
  //         } else {
  //           event.source.checked = false;
  //           this.isSecurityKeyAdded = false;
  //           this.cd.detectChanges();
  //           if (this.currentuserId == this.currentValutUserId) {
  //             this.openSecurityKeyDialog(event);
  //           }
  //         }
  //       },
  //       (error) => {
  //         this.isSecurityKeyAdded = false;
  //         this.isClicked = false;
  //         event.source.checked = false;
  //         this.isSecurityKeyAdded = false;
  //         this.cd.detectChanges();
  //       }
  //     )
  //   );
  // }

  checkIfImage(fileName) {
    if (fileName != undefined) {
      const fileNameFormated = fileName.toLowerCase();
      if (
        fileNameFormated.includes('svg') ||
        fileNameFormated.includes('jpeg') ||
        fileNameFormated.includes('png') ||
        fileNameFormated.includes('jpg') ||
        fileNameFormated.includes('giff')
      ) {
        return true;
      }
      return false;
    }
    return false;
  }

  checkIfPdf(fileName) {
    if (fileName != undefined) {
      const fileNameFormated = fileName.toLowerCase();
      if (fileNameFormated.includes('pdf')) {
        return true;
      }
      return false;
    }
    return false;
  }

  getUrl(id, index, fileName) {
    this.subscription.add(
      this.documentService.downloadVaultFile(this.securityStateObject.userId, id, null).subscribe(async (res) => {
        this.loaderService.show();

        this.showNoPreview = false;
        this.showPdfViewer = true;
        if (res.data.premium_encrypted == 'url' && res.data.data.includes('https://s3.amazonaws.com/')) {
          const xhr = new XMLHttpRequest();

          xhr.open('GET', res.data.data, true);
          xhr.responseType = 'blob';
          xhr.onload = () => {
            const reader = new FileReader();
            reader.onload = (event: any) => {
              this.showPDFImageProcess(res, index, fileName, event.target.result);
            };
            const file1 = xhr.response;

            reader.readAsText(file1);
          };
          xhr.send();
        } else {
          this.showPDFImageProcess(res, index, fileName, res.data.data);
        }
      })
    );
  }
  showPDFImageProcess(res, index, fileName, filedata) {
    let decrypted_file;
    let decryption_key;

    if (res.data.premium_encrypted == null) {
      decrypted_file = filedata; //file is not encrypted
    } else if (res.data.premium_encrypted == 'encrypted' || res.data.premium_encrypted == 'pending_decryption') {
      //decrypt file using user's security key
      decryption_key = this.cryptoService.decryptDataKey(res.data.key, this.security_key, this.sk);
      decrypted_file = this.cryptoService.decryptFile(filedata, decryption_key);
    } else {
      //get key to decrypt file
      decryption_key = this.cryptoService.decryptWithPassword(res.data.key, environment.encryption_mask_id);
      decrypted_file = this.cryptoService.decryptFile(filedata, decryption_key);
    }

    //set data for pdf viewer
    if (decrypted_file.includes('https://s3.us-east-1.amazonaws.com')) {
      const file = this.files[index];
      file['file_name'] = file.name;
      this.dialog.open(SharedDocViewerDialogComponent, {
        width: '100%',
        height: '100%',
        panelClass: 'shared-doc-view-dialog',
        data: {
          index: index,
          file: file,
          urlLink: decrypted_file,
        },
      });
      return;
    } else if (this.checkIfImage(fileName)) {
      this.urlLinks[index] = `data:image/${fileName.split('.').pop()};base64,${toBase64(decrypted_file)}`;
    } else {
      this.urlLinks[index] = { data: decrypted_file };
    }

    setTimeout(() => {
      const iframe = document.getElementById('iframe-doc-viewer');
      if (iframe) {
        this.iframeLoaded = true;
      }
    }, 500);

    this.loaderService.hide();

    this.cd.markForCheck();
  }

  hideDocViewer(index) {
    this.urlLinks[index] = '';
    this.iframeLoaded = false;
  }
  apiConnectedData = signal(false);

  getInitApiConnectedData() {
    this.subscription.add(
      this.addApiRapidValueService.getPropertyDataFromLiveFeeds(this.templateId).subscribe((data) => {
        this.receivedPropertyData = data;
        const propertyDataExist =
          data && Object.keys(data).length > 0 && Object.values(data).some((value) => value !== null && value !== undefined && value !== '');
        if (data?.type == 'vehicleDatabase') {
          this.buttonDisplayText = 'Vehicle Database';
        } else if (data?.type == 'zillow') {
          this.buttonDisplayText = 'Zillow';
        }

        if (this.apiIndicators() == 'vb' || this.apiIndicators() == 'zillow') {
          if (propertyDataExist) {
            this.showCopyDataButton = false;
            this.copyDataFromLiveFeeds();
          } else {
            this.showCopyDataButton = true;
          }
        }
      })
    );
  }

  ngAfterViewInit() {
    // Function to handle API indicator data
    const handleApiIndicatorData = (data: any) => {
      this.apiIndicators.set(data);
      this.getInitApiConnectedData();
      if (data) {
        this.getApiConnectedData();
      }
      this.cd.detectChanges();
    };

    // Subscribe once to the initial API indicator data
    this.subscription.add(this.addApiRapidValueService.apiIndicatorsSubjectData.subscribe(handleApiIndicatorData));

    // Subscribe to refresh$ and re-subscribe to API indicator data
    this.subscription.add(
      this.dialogEventService.refresh$.subscribe(() => {
        // console.log('refresh$');
        this.subscription?.unsubscribe();

        this.AddFinancialAttribute.currentBalanceCardComponent.ngOnInit();
        const attriibute = this.AddFinancialAttribute.currentBalanceCardComponent.attribute;
        const liveDataFeed = attriibute?.value?.live_data_feed?.toLowerCase();
        const apiSource = attriibute?.value?.api_source?.toLowerCase();

        const apiIndicators =
          (liveDataFeed === 'zillow' && apiSource === 'zillow') || apiSource === 'zillow'
            ? 'zillow'
            : (liveDataFeed === 'vehicle database' && apiSource === 'vehicledatabase') || apiSource === 'vehicle-database'
            ? 'vb'
            : (liveDataFeed === 'mx_account_balance' && apiSource === 'mx') || apiSource === 'mx'
            ? 'mx'
            : '';
        // this.addApiRapidValueService.apiIndicatorsSubjectData.next(apiIndicators);
        this.subscription.add(this.addApiRapidValueService.apiIndicatorsSubjectData.subscribe(handleApiIndicatorData));
      })
    );

    let nummber = this.documentForm.controls.documentName.value.length * 12;
    nummber = nummber + 72;
    if (nummber > 520) {
      nummber = 520;
    }
    // eval(`document.getElementById("document-form-nameTextbox").style.width='${nummber}px'`);
    this.loadingAllElement = false;
  }
  manageApiConnectedData() {
    this.AddFinancialAttribute.currentBalanceCardComponent.manageLiveDataFeed();
  }

  getApiConnectedData() {
    // get api connected data
    if (this.apiIndicators() == 'mx') {
      this.subscription.add(
        this.addApiRapidValueService.mxAccountBalanceSubjectData.subscribe((data) => {
          this.apiConnectedData.set(!data || data?.length == 0 ? false : true);
          this.cd.detectChanges();
        })
      );
    } else if (this.apiIndicators() == 'vb') {
      this.subscription.add(
        this.addApiRapidValueService.vehicleDataSubjectData.subscribe((data) => {
          this.apiConnectedData.set(!data || data?.length == 0 ? false : true);
          this.cd.detectChanges();
        })
      );
    } else if (this.apiIndicators() == 'zillow') {
      this.subscription.add(
        this.addApiRapidValueService.propertyDataSubjectData.subscribe((data) => {
          this.apiConnectedData.set(!data || data?.length == 0 ? false : true);
          this.cd.detectChanges();
        })
      );
    }
  }
  relationshipTypeThreeConditionallyRequiredValidator(formGroup: UntypedFormGroup) {
    if (this.loadingAllElement == true) {
      this.disablesingleFielFormValidator = false;
      return null;
    }
    if (this.Form1 == null || this.Form1.length == 0) {
      return null;
    }
    if (formGroup.controls.dynamicFieldsForm['controls'].length > 0) {
      const data = Object.keys(formGroup.controls.dynamicFieldsForm['controls'][0].value);
      const formValue = this.Form1[0]['singleFieldForm'];
      this.disablesingleFielFormValidator = false;
      data.forEach((element) => {
        const data = formGroup.controls.dynamicFieldsForm['controls'][0]['value'][element];
        const currentFOrm = formValue.find((obj) => obj.formControlName == element);
        if (formValue.findIndex((obj) => obj.formControlName == element) != -1) {
          if (currentFOrm['type'] == 'email') {
            const mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if (data != '' && !mailformat.test(data)) {
              this.disablesingleFielFormValidator = true;
              return { invalidCustom: true };
            }
          }
          if (currentFOrm['isRequired']) {
            if (data == '') {
              this.disablesingleFielFormValidator = true;
              return { invalidCustom: true };
            }
          }
        } else {
          const AllMultiDropDownList = formValue.filter((obj) => obj.type == 'MultiPleDropDown');
          let dropDownList = [];

          AllMultiDropDownList.forEach((multidropDownList) => {
            multidropDownList['data'].forEach((list) => {
              dropDownList = dropDownList.concat(list['template']);
            });
          });
          const data = formGroup.controls.dynamicFieldsForm['controls'][0]['value'][element];
          if (dropDownList.findIndex((obj) => obj.formControlName == element) != -1) {
            const currentFOrm = dropDownList.find((obj) => obj.formControlName == element);
            const parentformDat = formGroup.controls.dynamicFieldsForm['controls'][0]['value'][currentFOrm['parentformControlName']];
            if (parentformDat == currentFOrm['parentformControlValue']) {
              if (currentFOrm['type'] == 'email') {
                const mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                if (data != '' && !mailformat.test(data)) {
                  this.disablesingleFielFormValidator = true;
                  return { invalidCustom: true };
                }
              }
              if (currentFOrm['isRequired']) {
                if (data == '') {
                  this.disablesingleFielFormValidator = true;
                  return { invalidCustom: true };
                }
              }
            }
          }
        }
      });
      return null;
    }
  }
  // convenience getters for easy access to form fields
  get f() {
    return this.documentForm.controls;
  }
  get t() {
    return this.f.dynamicFieldsForm as UntypedFormArray;
  }

  selectCategory($event, itemName) {
    if ($event.source.selected) {
      this.currfolderName = itemName;
    }
  }

  selectCategoryType($event, itemName) {
    if ($event.source.selected) {
      this.currFolderTypeDoc = itemName;
    }
  }

  getUploadedDocument(uploadCountVal) {
    this.uploadCount = uploadCountVal;
  }

  getrecordassociationCount(associationCount) {
    this.recordAssociationCount = associationCount;
  }

  isSecurityKeyAddedToTheFom(isSecurityKeyAdded) {
    if (isSecurityKeyAdded.key_added == true && isSecurityKeyAdded.selectedSecurity_key != null) {
      this.isSecurityKeyAdded = true;
      this.selectedSecurity_key = isSecurityKeyAdded.selectedSecurity_key;
    } else {
      this.isSecurityKeyAdded = false;
    }
    this.cd.detectChanges();
    try {
      this.notesComponent.saveAllNotes(this.isSecurityKeyAdded ? isSecurityKeyAdded.selectedSecurity_key : null);
    } catch (error) {}

    try {
      this.manageActivityComponent.saveAllNotes(this.isSecurityKeyAdded ? isSecurityKeyAdded.selectedSecurity_key : null);
    } catch (error) {}
    if (this.mode != 'edit' && this.mode != 'view' && !this.isRemoveEditSaveSharing) {
      return;
    }
    this.checkValue(this.documentForm.value, true, null, true);
    this.cd.detectChanges();
  }
  sharedRelationshipUser(rlship) {
    this.fileManagerRelationshipSharedUser = rlship;
  }

  convertIntoMV(filesize) {
    filesize = filesize / 1024;
    filesize = filesize / 1024;
    return filesize.toFixed(2);
  }
  // this.LocationEnable condition removed
  passFormListForSearch(event) {
    this.eventFormListData = event;
    if (this.has_entity) {
      try {
        this.addEntityFormAssociation.processFullList(event);
      } catch (error) {}
    }
    if (this.has_assets) {
      try {
        this.addAssetFormAssociation.processFullList(event);
      } catch (error) {}
    }

    if (this.has_location) {
      try {
        // this.addLocationListV2.processFullList(event);
      } catch (error) {}
    }
  }
  passFormList(event) {
    this.eventListData = event;

    if (this.has_location) {
      try {
        // this.addLocationListV2.precesslistData(event);
      } catch (error) {}
    }
    if (this.has_assets) {
      try {
        this.addAssetFormAssociation.precesslistData(event);
      } catch (error) {}
    }
    if (this.has_entity) {
      try {
        this.addEntityFormAssociation.precesslistData(event);
      } catch (error) {}
    }
  }

  deletePhone(event) {
    let needToPassCurrntUserId = this.currentValutUserId;
    if (this.router.url.includes('collaboration') && !this.router.url.includes('admin=true')) {
      needToPassCurrntUserId = this.currentuserId;
    }
    this.subscription.add(
      this.documentService
        .getformConnectionStatusById(needToPassCurrntUserId, this.data.id ? this.data.id : this.data.vufid ? this.data.vufid : this.currentFormId)
        .subscribe(
          (res) => {
            if (res.data?.length > 0 && res.data[0].connected_to_institution) {
              this.connected_to_institution = res.data[0].connected_to_institution;
            } else {
              this.connected_to_institution = null;
            }
            // this.connected_to_institution = res['data']['vaultFormData'][0]?.connected_to_institution;
            // this.addFinacialAttributeComponent.getList();
            this.cd.detectChanges();
          },
          (error) => {}
        )
    );
  }
  setEdittempletdataform() {
    this.iSGetLottieOn = true;
    this.isBasicForm = true;
    let needToPassCurrntUserId = this.currentValutUserId;
    if (this.router.url.includes('collaboration') && !this.router.url.includes('admin=true')) {
      needToPassCurrntUserId = this.currentuserId;
    }
    try {
      // this.getFormStatus(this.data.id ? this.data.id : this.data.vufid ? this.data.vufid : this.currentFormId);
    } catch (error) {}
    this.subscription.add(
      this.documentService
        .getformTempletByid(needToPassCurrntUserId, this.data.id ? this.data.id : this.data.vufid ? this.data.vufid : this.currentFormId)
        .subscribe(
          (res) => {
            try {
              if (this.isReport && res?.data?.viewStatus?.relations_of_user_id != this.currentuserId) {
                this.impersonateUserIdForReport = true;
                this.store$.dispatch(new relationshipStoreActions.impersonateUserRelationships(res.data.viewStatus.relations_of_user_id));
              }
            } catch (error) {}
            // PROFILE IMAGE
            this.formImage = res.data.vaultFormData[0].profile_image_url;
            this.templateType = res.data.vaultFormData[0].type;
            this.vaultName = res.data.vaultFormData[0].vault_name;
            this.templateData = res.data.vaultFormData[0];
            this.linkedAssetsEnabled = res.data.vaultFormData[0].linked_assets_enabled;
            this.linkedLiabilitiesEnabled = res.data.vaultFormData[0].linked_liabilities_enabled;
            this.linkedEntitiesEnabled = res.data.vaultFormData[0].linked_entities_enabled;
            if (this.templateData.ignore_ai_suggestion) {
              this.ignore_ai_suggestion = JSON.parse(this.templateData.ignore_ai_suggestion);
            }
            try {
              this.updateSelectedVault(res.data.vaultFormData[0].vault_id, res.data.vaultFormData[0].vault_name);
            } catch (error) {}
            this.iSGetLottieOn = false;
            this.isBasicForm = true;

            // set Status Of Active Inactive
            const deactiveDate = res?.data?.vaultFormData[0]?.deactivation_date ? res?.data?.vaultFormData[0]?.deactivation_date : null;
            this.isActive = deactiveDate ? false : true;

            // Load starred status
            this.isDocumentStarred = res?.data?.vaultFormData[0]?.is_starred === true || res?.data?.vaultFormData[0]?.is_starred === 1;

            // this.cd.detectChanges();
            res = res['data'];
            this.securityStateObject = res.publicKey;
            try {
              this.documentForm.controls.documentName.setValue(res.vaultFormData[0].form_name);
            } catch (error) {}
            try {
              this.setInternalLiksSection(res['vaultFormData'][0].fid);
            } catch (error) {}

            this.fId = res['vaultFormData'][0]?.fid;
            try {
              if (res['vaultFormData'][0]?.origin == 'location') {
                this.LocationEnable = true;
                this.hideLocationSection = true;
              }
            } catch (error) {}

            this.has_death_benefit = res['vaultFormData'][0]?.has_death_benefit;

            this.connected_to_institution = res['vaultFormData'][0]?.connected_to_institution;
            this.transaction_register_disabled = res['vaultFormData'][0]?.transaction_register_disabled;
            this.setValurfileedCurrentID(res['vaultFormData'][0]?.fid);
            if (res['vaultFormData'][0] && res['vaultFormData'][0]['template']) {
              if (!(res['vaultFormData'][0].origin == 'vault' || res['vaultFormData'][0].origin == 'asset')) {
                this.showLocationSection = true;
              } else {
                this.showLocationSection = true;
              }
            }

            this.documentForm.controls.selectSaveFolder.setValue('-1');
            this.ShareTypeDataNewFlow = res['viewStatus']['sharetype'];
            if (this.ShareTypeDataNewFlow == 'now') {
              this.hideSharedAndMoreVertBtn = true;
            }
            if (res['vaultFormData'][0] && res['vaultFormData'][0]['template']) {
              this.documentForm.controls['physicalLocation'].setValue(res['vaultFormData'][0].physical_location);
              this.documentForm.controls['notes'].setValue(res['vaultFormData'][0].notes);
              this.documentForm.controls['status_progress'].setValue(res['vaultFormData'][0].status_progress);

              if (res['vaultFormData'][0].expiration_date != undefined && res['vaultFormData'][0].expiration_date != null) {
                const tempdate = res['vaultFormData'][0].expiration_date.split('-');
                if (tempdate.length > 2) {
                  const date = new Date();
                  date.setDate(tempdate[2]);
                  date.setMonth(tempdate[1] - 1);
                  date.setFullYear(tempdate[0]);
                  this.documentForm.controls['expiration_date'].setValue(date);
                }
              }

              if (res['vaultFormData'][0].value_appraisal_date != undefined && res['vaultFormData'][0].value_appraisal_date != null) {
                const tempdate = res['vaultFormData'][0].value_appraisal_date.split('-');
                if (tempdate.length > 2) {
                  const date = new Date();
                  date.setDate(tempdate[2]);
                  date.setMonth(tempdate[1] - 1);
                  date.setFullYear(tempdate[0]);
                  this.documentForm.controls['value_appraisal_date'].setValue(date);
                }
              }

              if (res['vaultFormData'][0].renewal_date != undefined && res['vaultFormData'][0].renewal_date != null) {
                const tempdate = res['vaultFormData'][0].renewal_date.split('-');
                if (tempdate.length > 2) {
                  const date = new Date();
                  date.setDate(tempdate[2]);
                  date.setMonth(tempdate[1] - 1);
                  date.setFullYear(tempdate[0]);
                  this.documentForm.controls['renewal_date'].setValue(date);
                }
              }

              if (res['vaultFormData'][0].review_date != undefined && res['vaultFormData'][0].review_date != null) {
                const tempdate = res['vaultFormData'][0].review_date.split('-');
                if (tempdate.length > 2) {
                  const date = new Date();
                  date.setDate(tempdate[2]);
                  date.setMonth(tempdate[1] - 1);
                  date.setFullYear(tempdate[0]);
                  this.documentForm.controls['review_date'].setValue(date);
                }
              }

              this.documentForm.controls['expiration_notification'].setValue(
                res['vaultFormData'][0].expiration_notification == true
                  ? 'true'
                  : res['vaultFormData'][0].expiration_notification == false
                  ? 'false'
                  : ''
              );
              this.documentForm.controls['value_is_appraisal'].setValue(
                res['vaultFormData'][0].value_is_appraisal == true ? 'true' : res['vaultFormData'][0].value_is_appraisal == false ? 'false' : ''
              );
              this.documentForm.controls['value_currency'].setValue(
                res['vaultFormData'][0].value_currency ? res['vaultFormData'][0].value_currency : ''
              );

              this.documentForm.controls['value_current_currency'].setValue(
                res['vaultFormData'][0].value_current_currency ? res['vaultFormData'][0].value_current_currency : ''
              );

              this.documentForm.controls['review_notification'].setValue(
                res['vaultFormData'][0].review_notification == true ? 'true' : res['vaultFormData'][0].review_notification == false ? 'false' : ''
              );

              this.documentForm.controls['renewal_notification'].setValue(
                res['vaultFormData'][0].renewal_notification == true ? 'true' : res['vaultFormData'][0].renewal_notification == false ? 'false' : ''
              );
              this.documentForm.controls['recurring_expiration'].setValue(res['vaultFormData'][0].recurring_expiration);
              if (this.ShareTypeDataNewFlow != '' && this.ShareTypeDataNewFlow != 'now') {
                this.isFormSealed = true;
              } else {
                this.isFormSealed = false;
              }
              // this.isFormSealed = false;
              try {
                this.auto_naming_disabled = res.vaultFormData[0].auto_naming_disabled == 1 ? true : false;
              } catch (error) {}

              if (res['viewStatus']['viewmode'] == 'write') {
                this.isRemoveEditSaveSharing = false;
                this.showButton = true;
                this.hideManageButton = res['viewStatus'].sharetype == 'now' ? true : false;
              } else {
                this.mode = 'view';
                this.isRemoveEditSaveSharing = true;
              }
              this.loadDatawithTamplet(res);
            } else {
              if (this.ShareTypeDataNewFlow != '' && this.ShareTypeDataNewFlow != 'now') {
                this.isFormSealed = true;
              } else {
                this.isFormSealed = false;
              }

              this.shareTypeData = String(res['viewStatus']['sharetype']).replace('on ', '');
              this.cd.detectChanges();
            }
            this.templateTypeToBeUpdated = '';
            this.cd.detectChanges();
          },
          (error) => {
            this.iSGetLottieOn = false;
            this.isBasicForm = true;
            this.cd.detectChanges();
          }
        )
    );
  }
  openSecurityPopup(res) {
    if (this.isSecutityModalOpen) {
      return;
    }
    this.isSecutityModalOpen = true;
    this.cd.detectChanges();
    const modalRef2 = this.dialog.open(AskSecurityKeyPasswordComponent, {
      data: {
        isRemoveEditSaveSharing: this.isRemoveEditSaveSharing,
        currentuserId: this.currentuserId,
        currentValutUserId: this.currentValutUserId,
        vaultFormId: this.currentFormId,
        data: res['vaultFormData'][0],
        security_key: res['vaultFormData'][0].security_key,
      },
      disableClose: true,
      panelClass: 'full-window-dialog-2',
      autoFocus: false,
    });

    this.subscription.add(
      modalRef2.afterClosed().subscribe((result) => {
        this.isSecutityModalOpen = false;
        this.cd.detectChanges();
        if (result?.isVerify) {
          //decrypt form data
          this.sk = result.sk;
          this.selectedSecurity_key = result.security_key;

          this.security_key = result.security_key;
          this.fileExtensionComponentchild.forEach((FileExtensionComponent) => {
            FileExtensionComponent.doSomething();
          });

          this.manageSecuritykey = [result.security_key];

          if (res['vaultFormData'][0]['form_data'] != null && res['vaultFormData'][0]['form_data'] != undefined) {
            res['vaultFormData'][0]['form_data'] = this.cryptoService.decryptData(
              JSON.parse(res['vaultFormData'][0]['form_data']),
              result.security_key,
              result.sk
            );
          }
          if (res['vaultFormData'][0]['notes'] != '' && res['vaultFormData'][0]['notes'] != null && res['vaultFormData'][0]['notes'] != undefined) {
            res['vaultFormData'][0]['notes'] = this.cryptoService.decryptData(
              JSON.parse(res['vaultFormData'][0]['notes']),
              result.security_key,
              result.sk
            );
          }
          // res['vaultFormData'][0]['physical_location'] = this.cryptoService.decryptData(
          //   JSON.parse(res['vaultFormData'][0]['physical_location']),
          //   result.security_key,
          //   result.sk
          // );

          //ensure UI notes and physical location are updated with decrypted values
          this.documentForm.controls['physicalLocation'].setValue(res['vaultFormData'][0].physical_location);
          this.documentForm.controls['notes'].setValue(res['vaultFormData'][0].notes);
          this.iSGetLottieOn = true;
          this.isBasicForm = false;
          this.cd.detectChanges();

          if (res['vaultFormData'][0]['form_data'] != '') {
            //file uploads have no form data
            this.loadDataWithReady(res);
          } else {
            this.iSGetLottieOn = false;
            this.cd.detectChanges();
          }
        } else {
          this.closedialog();
        }
      })
    );
  }
  loadDataWithReady(res, transaction = null) {
    this.isGeneralSectionResolve = this.isEnableGeneralInformation;
    this.isEnableGeneralInformation = false;

    this.saveResponse = res;
    this.Form1 = [];
    this.HideAddinationInfo = false;
    const form_data = JSON.parse(res['vaultFormData'][0]['form_data']);
    this.already_saved_data = form_data;
    this.Form1 = JSON.parse(res['vaultFormData'][0]['template']);

    try {
      if (this.Form1[0]['singleFieldForm'].find((x) => x.type == 'largeText' && x.label == 'Description')) {
        const findElement = this.Form1[0]['singleFieldForm'].find((x) => x.type == 'largeText' && x.label == 'Description')
          ? this.Form1[0]['singleFieldForm'].find((x) => x.type == 'largeText' && x.label == 'Description')
          : null;
        if (findElement) {
          try {
            const json_description = JSON.parse(form_data.dynamicFieldsForm[findElement.formControlName]);
            if (json_description.is_atob) {
              form_data.dynamicFieldsForm[findElement.formControlName] = decodeURIComponent(atob(json_description.value));
            }
          } catch (error) {}
        }
      }
    } catch (error) {}
    if (transaction == 'Save General Section') {
      const dynamicFieldsForm = form_data.dynamicFieldsForm;
      const findElement = this.arrayItems?.find((x) => x.type == 'largeText' && x.label == 'Description')
        ? this.arrayItems?.find((x) => x.type == 'largeText' && x.label == 'Description')
        : null;

      if (findElement) {
        dynamicFieldsForm[findElement.formControlName] = this.NgxEditorField.name.value;
      }
      form_data.dynamicFieldsForm = dynamicFieldsForm;
      const resetData = JSON.parse(res['vaultFormData'][0]['form_data']);
      this.savedDynamicFieldsFormValueInDb = [resetData.dynamicFieldsForm];
    } else if (transaction == 'Description Section') {
      const dynamicFieldsForm = this.documentForm.controls.dynamicFieldsForm.value[0];
      const findElement = this.arrayItems?.find((x) => x.type == 'largeText' && x.label == 'Description')
        ? this.arrayItems?.find((x) => x.type == 'largeText' && x.label == 'Description')
        : null;

      if (findElement) {
        dynamicFieldsForm[findElement.formControlName] = form_data.dynamicFieldsForm[findElement.formControlName];
        this.NgxEditorField.name.setValue(form_data.dynamicFieldsForm[findElement.formControlName]);
      }
      form_data.dynamicFieldsForm = dynamicFieldsForm;
      const resetData = JSON.parse(res['vaultFormData'][0]['form_data']);
      this.savedDynamicFieldsFormValueInDb = [resetData.dynamicFieldsForm];
    }
    this.iSGetLottieOn = false;

    this.showRightSideSection = true;

    this.saveFormValueInDb = form_data;
    this.bindFormDataFromDb(form_data, transaction);
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  };
  bindFormDataFromDb(form_data, transaction = null) {
    // this.documentForm.removeControl('dynamicFieldsForm');
    // this.documentForm.removeControl('beneFicaryForm');
    this.documentForm.setControl('beneFicaryForm', new UntypedFormArray([]));
    this.documentForm.setControl('dynamicFieldsForm', new UntypedFormArray([]));

    this.arrayItems = [];
    if (this.Form1 == null) {
      this.iSGetLottieOn = false;
      return;
    }
    this.arrayItems = JSON.parse(JSON.stringify(this.Form1[0]['singleFieldForm']));
    if (this.currentTemplate?.type === 'Automobile') {
      this.arrayItems.map((item) => {
        if (item.label.includes('Trim')) {
          item.type = 'text';
        }
      });

      this.arrayItems.map((item) => {
        if (item.label.includes('Condition')) {
          item.options = [
            {
              label: 'Outstanding',
              value: 'Outstanding',
            },
            {
              label: 'Clean',
              value: 'Clean',
            },
            {
              label: 'Average',
              value: 'Average',
            },
            {
              label: 'Rough',
              value: 'Rough',
            },
          ];
        }
      });
    }
    this.showNotesitems = [];
    this.showNotesitems = this.Form1[0]['showNotes'];
    if (this.showNotesitems != undefined && this.showNotesitems.length > 0) {
      this.documentForm.addControl('showNotes', this.formBuilder.control(''));
      this.documentForm.controls.showNotes.setValue(form_data['showNotes'] ? form_data['showNotes'] : '');
    } else {
      this.documentForm.removeControl('showNotes');
    }
    this.t.clear();
    const test = this.formBuilder.group({});
    this.arrayItems.forEach(function (value) {
      if (value['type'] === 'MultiPleDropDown') {
        test.addControl(value.formControlName, new UntypedFormControl(''));
        value['data'].forEach((childcontrols) => {
          childcontrols['template'].forEach((child) => {
            test.addControl(child.formControlName, new UntypedFormControl(''));
          });
        });
      } else if (value['type'] === 'Section') {
      } else if (value['type'] == 'email') {
        test.addControl(value.formControlName, new UntypedFormControl(''));
      } else {
        test.addControl(value.formControlName, new UntypedFormControl(''));
      }
    });
    this.t.push(test);
    this.documentForm.removeControl('beneFicaryForm');
    this.documentForm.addControl('beneFicaryForm', new UntypedFormArray([]));
    if (this.Form1[0]['multiFieldForm'].length) {
      this.beneFicaryForm = [];
      this.beneFicaryForm = this.Form1[0]['multiFieldForm'];
      this.Form1[0]['multiFieldForm'].forEach((element) => {
        const temporary = new UntypedFormGroup({});
        temporary.addControl(element.formControlName, new UntypedFormArray([]));
        const test = new UntypedFormGroup({});
        element.template.forEach((childelement) => {
          // if (childelement['type'] == 'email') {
          //   if (childelement['isRequired']) {
          //     test.addControl(childelement.formControlName, new FormControl('', [Validators.required, Validators.email]));
          //   } else {
          //     test.addControl(childelement.formControlName, new FormControl('', [Validators.email]));
          //   }
          // } else {
          //   if (childelement['isRequired']) {
          //     test.addControl(childelement.formControlName, new FormControl('', Validators.required));
          //   } else {
          //     test.addControl(childelement.formControlName, new FormControl(''));
          //   }
          // }
        });
        // const ffff = temporary.controls[element.formControlName] as FormArray;
        // ffff.push(test);
        const items = this.documentForm.controls['beneFicaryForm'] as UntypedFormArray;
        items.push(temporary);
      });
    } else {
      this.beneFicaryForm = [];
    }
    const multiDropMainStack = this.Form1[0]['singleFieldForm'].filter((x) => x.type == 'MultiPleDropDown');
    let multidropDownFomllist = [];
    multiDropMainStack.forEach((element) => {
      if (element && element['data']) {
        element['data'].forEach((childelement) => {
          if (childelement && childelement['template']) {
            multidropDownFomllist = multidropDownFomllist.concat(childelement['template']);
          }
        });
      }
    });

    if (form_data != null && form_data?.dynamicFieldsForm != null) {
      Object.keys(form_data['dynamicFieldsForm']).forEach((element) => {
        const tempIndex = this.Form1[0]['singleFieldForm'].findIndex((x) => x.formControlName == element);
        if (tempIndex != -1) {
          const currnetTmplateObj = this.Form1[0]['singleFieldForm'][tempIndex];
          if (currnetTmplateObj && currnetTmplateObj['type'] == 'date') {
            const originalData = form_data['dynamicFieldsForm'][element];
            if (originalData == '' || originalData == null || originalData == undefined) {
              this.documentForm.controls.dynamicFieldsForm['controls'][0]['controls'][element].setValue(form_data['dynamicFieldsForm'][element]);
            } else {
              const tempData = new Date(form_data['dynamicFieldsForm'][element]);
              this.documentForm.controls.dynamicFieldsForm['controls'][0]['controls'][element].setValue(tempData);
            }
          } else {
            this.documentForm.controls.dynamicFieldsForm['controls'][0]['controls'][element].setValue(form_data['dynamicFieldsForm'][element]);
          }
        } else {
          if (multidropDownFomllist.length > 0) {
            const tempIndex = multidropDownFomllist.findIndex((x) => x.formControlName == element);
            if (tempIndex != -1) {
              const currnetTmplateObj = multidropDownFomllist[tempIndex];
              if (currnetTmplateObj && currnetTmplateObj['type'] == 'date') {
                const tempData = new Date(form_data['dynamicFieldsForm'][element]);
                this.documentForm.controls.dynamicFieldsForm['controls'][0]['controls'][element].setValue(tempData);
              } else {
                this.documentForm.controls.dynamicFieldsForm['controls'][0]['controls'][element].setValue(form_data['dynamicFieldsForm'][element]);
              }
            } else {
              this.documentForm.controls.dynamicFieldsForm['controls'][0]['controls'][element].setValue(form_data['dynamicFieldsForm'][element]);
            }
          } else {
            try {
              this.documentForm.controls.dynamicFieldsForm['controls'][0]['controls'][element].setValue(
                form_data['dynamicFieldsForm'][element] ? form_data['dynamicFieldsForm'][element] : ''
              );
            } catch (error) {}
          }
        }
      });
    }
    if (form_data?.beneFicaryForm?.length > 0) {
      form_data['beneFicaryForm'].forEach((element, index) => {
        element[Object.keys(element)[0]].forEach((childElement, childIndex) => {
          const newelement = this.Form1[0]['multiFieldForm'][index];
          const test = new UntypedFormGroup({});
          newelement.template.forEach((newchildelement) => {
            if (newchildelement['type'] == 'email') {
              if (newchildelement['isRequired']) {
                test.addControl(newchildelement.formControlName, new UntypedFormControl('', [Validators.required, Validators.email]));
              } else {
                test.addControl(newchildelement.formControlName, new UntypedFormControl('', [Validators.email]));
              }
            } else {
              if (newchildelement['isRequired']) {
                test.addControl(newchildelement.formControlName, new UntypedFormControl('', Validators.required));
              } else {
                test.addControl(newchildelement.formControlName, new UntypedFormControl(''));
              }
            }
            // test.addControl(newchildelement.formControlName, new FormControl('', Validators.required));
          });
          const items = this.documentForm.controls['beneFicaryForm']['controls'][index]['controls'][Object.keys(element)[0]] as UntypedFormArray;
          if (items != undefined) {
            items.push(test);
            this.cd.detectChanges();
          }

          const currentTamplet = this.Form1[0]['multiFieldForm'].find((x) => x.formControlName == Object.keys(element)[0]);
          if (currentTamplet != undefined) {
            currentTamplet.template.forEach((fillData) => {
              if (this.documentForm.controls.beneFicaryForm['controls'][index] != undefined) {
                if (fillData.type == 'date') {
                  const tempData = new Date(childElement[fillData.formControlName]);
                  this.documentForm.controls.beneFicaryForm['controls'][index]['controls'][Object.keys(element)[0]]['controls'][childIndex][
                    'controls'
                  ][fillData.formControlName].setValue(tempData);
                } else {
                  this.documentForm.controls.beneFicaryForm['controls'][index]['controls'][Object.keys(element)[0]]['controls'][childIndex][
                    'controls'
                  ][fillData.formControlName].setValue(childElement[fillData.formControlName]);
                }
              }
            });
          }
        });
      });
    }
    if (transaction == null) {
      this.savedDynamicFieldsFormValueInDb = this.documentForm.controls.dynamicFieldsForm.value;
    }

    this.saveBeneficiaryFormValueInDb = this.documentForm.controls.beneFicaryForm.value;

    this.addApiRapidValueService.setPropertyDataFromGeneral(this.savedDynamicFieldsFormValueInDb[0], this.templateId);

    this.userService
      .loadGoogleMapsApi()
      .then(() => {
        setTimeout(() => {
          if (typeof (window as any).google !== 'undefined') {
            this.initializeAddresseAutocomplete();
          }
        }, 0);
      })
      .catch((error) => console.error('Error loading Google Maps API:', error));

    if (this.isEnableDescription) {
      try {
        setTimeout(() => {
          this.NgxEditorField.changeBlueEditor();
        }, 3000);
      } catch (error) {}
      this.isEnableDescription = false;
    }

    if (this.has_real_estate_value_estimate || this.has_api_source_motor) {
      this.subscribeToAddressAndVehicleFieldChanges();
    }
    this.cd.detectChanges();
  }

  diff(a, b) {
    return JSON.stringify(a) != JSON.stringify(b);
  }

  loadDatawithTamplet(res) {
    const form_data = JSON.parse(res['vaultFormData'][0]['form_data']);

    this.Form1 = JSON.parse(res['vaultFormData'][0]['template']);
    this.formEncryptionKey = res['vaultFormData'][0]['encryption_key'];
    if (res['vaultFormData'][0]['security_key'] != null && res['vaultFormData'][0]['security_key'] != undefined) {
      this.HideAddinationInfo = true;
      this.isSecurityKeyAdded = true;
      this.openSecurityPopup(res);
    } else {
      this.iSGetLottieOn = true;
      this.isBasicForm = true;
      this.already_saved_data = form_data;
      this.loadDataWithReady(res);
    }
    if (this.ai_is_loading) {
      this.ai_is_loading = false;
      setTimeout(() => {
        this.analyzeWithAi = true;
        this.isTemplateDocumentTagLoading = true;
        this.cd.detectChanges();
        this.checkStatusTemplateSummary();
        try {
          this.documentLinkingTemplate?.checkStatus();
        } catch (error) {}

        try {
          this.formAttachment?.updateStatusWorking();
        } catch (error) {}
        this.getfileliseForCurrentForms();
        this.refreshTemplateDocumentTag();
      }, 0);
    }
  }

  backtoParetnEstate(ev: Event, option) {
    this.documentForm.controls.selectSaveFolder.setValue('');
    ev.stopPropagation();
    ev.preventDefault();
    this.showEstateList = true;
    this.showEstateChildList = false;
    this.showESubstateChildList = false;
    this.EsateList = this.fulassetList;
  }
  backtoParetn(ev: Event, option) {
    ev.stopPropagation();
    ev.preventDefault();
    this.showFolderList = true;
    this.customCss();
  }
  backtoEstateChildList(ev: Event, option) {
    this.documentForm.controls.selectSaveFolder.setValue('');
    ev.stopPropagation();
    ev.preventDefault();
    this.showEstateList = false;
    this.showEstateChildList = true;
    this.showESubstateChildList = false;
    this.fulassetList.forEach((element, index) => {
      element?.estateAssetTabs.forEach((childdelement, cildindex) => {
        childdelement.estateAssetTabGroups.forEach((subchildelement, subchildindex) => {
          if (subchildelement.id == option[0].id) {
            this.subfolderList = this.fulassetList[index].estateAssetTabs;
            this.customCss();
          }
        });
      });
    });
    this.customCss();
  }
  backtoChildList(ev: Event, option) {
    ev.stopPropagation();
    ev.preventDefault();
    this.subfolderList = option.estateAssetTabs;
    this.showEstateList = true;
    this.showEstateChildList = true;
    this.showESubstateChildList = false;
    this.customCss();
  }

  backtoParetnoffice(ev: Event, officesubfolderList) {
    this.documentForm.controls.selectOfficeSaveFolder.setValue('');
    ev.stopPropagation();
    ev.preventDefault();
    const parentData = officesubfolderList.find((x) => x.parent_office_workspace_folder_id != null);
    if (parentData?.parent_office_workspace_folder_id == null || parentData?.parent_office_workspace_folder_id == undefined) {
      this.showFolderList = true;
    } else {
      // const memberList = option.officeWorkspaceMembers?.filter((item) => item.user_id == this.currentuserId && item.workspace_folder_id);
      // const folderIdListWithAccess = memberList.map((item) => item.workspace_folder_id);
      // const subFolderList = option.officeWorkspaceFolders?.filter((item) => folderIdListWithAccess.includes(item.id));

      const subFolderList = this.fullOfficeFolderList;
      const officeSubList = [];
      let tempOfficeSubFolderList = this.fullOfficeFolderList.find((x) => x.id == parentData.parent_office_workspace_folder_id);
      tempOfficeSubFolderList = this.fullOfficeFolderList.filter(
        (x) => x.parent_office_workspace_folder_id == tempOfficeSubFolderList?.parent_office_workspace_folder_id
      );

      tempOfficeSubFolderList.forEach((element, index) => {
        let tElement = element;
        if (subFolderList.findIndex((x) => x.parent_office_workspace_folder_id == element.id) != -1) {
          tElement = Object.assign({}, tElement, { isChildAvailable: true });
        } else {
          tElement = Object.assign({}, tElement, { isChildAvailable: false });
        }
        officeSubList.push(tElement);
      });
      this.officesubfolderList = officeSubList;
      this.showFolderList = false;
      // this.selectedParentLable = option.name;
    }

    this.customCss();
  }

  MoveToInformationParentFolder(ev) {
    this.documentForm.controls.selectSaveFolder.setValue('');
    this.documentForm.controls.selectOfficeSaveFolder.setValue('');

    ev.stopPropagation();
    ev.preventDefault();
    const findIndex = this.currectMyInformationList.findIndex((x) => x.parent_office_vault_folder_id != null);
    if (findIndex == -1) {
      this.showInformationtabFolderList = true;
    } else {
      const currentNode = this.currectMyInformationList[findIndex];
      const CurrentElement = this.fullMyInformationList.find((x) => x.id == currentNode.parent_office_vault_folder_id);
      this.currectMyInformationList = this.fullMyInformationList.filter(
        (x) => x.parent_office_vault_folder_id == CurrentElement.parent_office_vault_folder_id
      );
    }
  }
  MoveToInformationSubFolder(ev: Event, item) {
    this.documentForm.controls.selectSaveFolder.setValue('');
    this.documentForm.controls.selectOfficeSaveFolder.setValue('');
    ev.stopPropagation();
    ev.preventDefault();
    this.currectMyInformationList = this.fullMyInformationList.filter((x) => x.parent_office_vault_folder_id == item.id);
  }

  moveToPrevious(ev: Event, item) {
    const filterItem = item.find((x) => x.parent_vault_user_folder_id != null);
    if (filterItem?.parent_vault_user_folder_id) {
      const filertDate = this.fullSubFolderList.find((x) => x.vault_user_folder_id == filterItem.parent_vault_user_folder_id);
      if (filertDate == undefined || filertDate == null) {
        this.showFolderList = true;
        this.subfolderList = this.fullSubFolderList.filter((x) => x.parent_vault_user_folder_id == null);
      } else {
        this.showFolderList = false;
        this.subfolderList = this.fullSubFolderList.filter((x) => x.parent_vault_user_folder_id == filertDate.parent_vault_user_folder_id);
      }
    }
    this.documentForm.controls.selectSaveFolder.setValue('');

    ev.stopPropagation();
    ev.preventDefault();
  }

  moveToSub(ev: Event, item) {
    this.documentForm.controls.selectSaveFolder.setValue('');
    this.subfolderList = this.fullSubFolderList.filter((x) => x.parent_vault_user_folder_id == item.vault_user_folder_id);
    ev.stopPropagation();
    ev.preventDefault();
  }
  MoveToSubFolder(ev: Event, item) {
    this.documentForm.controls.selectOfficeSaveFolder.setValue('');
    ev.stopPropagation();
    ev.preventDefault();
    // const memberList = option.officeWorkspaceMembers?.filter((item) => item.user_id == this.currentuserId && item.workspace_folder_id);
    // const folderIdListWithAccess = memberList.map((item) => item.workspace_folder_id);
    // const subFolderList = option.officeWorkspaceFolders?.filter((item) => folderIdListWithAccess.includes(item.id));
    const officeSubList = [];
    const subFolderList = this.fullOfficeFolderList;
    const tempOfficeSubFolderList = this.fullOfficeFolderList.filter((x) => x.parent_office_workspace_folder_id == item.id);
    tempOfficeSubFolderList.forEach((element, index) => {
      let tElement = element;
      if (subFolderList.findIndex((x) => x.parent_office_workspace_folder_id == element.id) != -1) {
        tElement = Object.assign({}, tElement, { isChildAvailable: true });
      } else {
        tElement = Object.assign({}, tElement, { isChildAvailable: false });
      }
      officeSubList.push(tElement);
    });
    this.officesubfolderList = officeSubList;
    this.showFolderList = false;
    // this.selectedParentLable = option.name;
    this.customCss();
  }
  deleteofficeOption(ev: Event, option) {
    this.documentForm.controls.selectOfficeSaveFolder.setValue('');
    ev.stopPropagation();
    ev.preventDefault();

    //the sub folders for office workspace come from here
    // const memberList = option.officeWorkspaceMembers?.filter((item) => item.user_id == this.currentuserId && item.workspace_folder_id);
    // const folderIdListWithAccess = memberList.map((item) => item.workspace_folder_id);
    // const subFolderList = option.officeWorkspaceFolders?.filter((item) => folderIdListWithAccess.includes(item.id));
    const subFolderList = this.fullOfficeFolderList;
    const officeSubList = [];
    const tempOfficeSubFolderList = this.officesubfolderList.filter((x) => x.parent_office_workspace_folder_id == null);
    tempOfficeSubFolderList.forEach((element, index) => {
      let tElement = element;
      if (subFolderList.findIndex((x) => x.parent_office_workspace_folder_id == element.id) != -1) {
        tElement = Object.assign({}, tElement, { isChildAvailable: true });
      } else {
        tElement = Object.assign({}, tElement, { isChildAvailable: false });
      }
      officeSubList.push(tElement);
    });

    this.officesubfolderList = officeSubList;
    this.showFolderList = false;
    this.selectedParentLable = option.name;
    this.customCss();
  }
  ShowSubChildOptionEstate(ev: Event, option) {
    ev.stopPropagation();
    ev.preventDefault();
    this.showEstateChildList = false;
    this.showESubstateChildList = true;
    this.subchildfolderList = option.estateAssetTabGroups;
    this.showEstateList = false;
    this.selectedParentLable = option.name;
    this.customCss();
  }

  ShowChildOptionEstate(ev: Event, option) {
    ev.stopPropagation();
    ev.preventDefault();
    this.showEstateChildList = true;
    this.subfolderList = option.estateAssetTabs;
    this.showEstateList = false;
    this.selectedParentLable = option.name;
    this.customCss();
  }
  moveToSubFolderList(ev: Event) {
    ev.stopPropagation();
    ev.preventDefault();
    this.documentForm.controls.selectSaveFolder.setValue('');
    this.showInformationtabFolderList = false;
    this.currectMyInformationList = this.fullMyInformationList.filter((x) => x.parent_office_vault_folder_id == null);
    this.cd.detectChanges();
  }
  deleteOption(ev: Event, option) {
    ev.stopPropagation();
    ev.preventDefault();

    const test = [];

    option.subfolders.forEach((element) => {
      const newelement = {
        ...element,
        ...{ isChildAvailable: false },
      };
      if (option.subfolders.findIndex((x) => x.parent_vault_user_folder_id == element.vault_user_folder_id) != -1) {
        newelement.isChildAvailable = true;
      }
      test.push(newelement);
    });

    this.fullSubFolderList = test;
    this.subfolderList = this.fullSubFolderList.filter((x) => x.parent_vault_user_folder_id == option.vault_user_folder_id);
    this.showFolderList = false;
    this.selectedParentLable = option.name;
    this.customCss();
  }
  getReminderData(event) {
    this.root_currentValue = event['currentValue'];
    this.root_has_balance = event['has_balance'];
    if (this.root_has_balance) {
      this.getLinkedMXAccount();
    } else {
      this.isDataLoading = false;
    }
    this.root_title = event['title'];
    this.root_currentDate = event['currentDate'];
  }

  getLinkedMXAccount() {
    this.subscription.add(
      this.MxconnectionService.getLinkedMXAccount(this.currentFormId).subscribe((res) => {
        this.selectedFileList = [];
        if (res) {
          this.selectedFileList.push(res);
        }
        const allConnectedAccounts = this.selectedFileList.filter((item) => item?.connection_status?.toLowerCase() == 'connected');
        allConnectedAccounts.length > 0 ? this.addApiRapidValueService.mxAccountBalanceSubjectData.next(allConnectedAccounts) : '';
        this.isDataLoading = false;
        this.cd.detectChanges();
      })
    );
  }
  getUpdatedImage(event?: any) {
    this.subscription.add(
      this._fileUploadService.getVaultFormImage(this.currentValutUserId, this.currentFormId).subscribe((res) => {
        this.updatedFormUrl = res;
      })
    );
  }
  updateActionItemProperty(event) {
    const list = this.itemsToSetUp.itemsToSetUpList;
    const itemsToSetUp = list.find((x) => x.type == 'api' && x.sub_type == 'Zillow');
    if (itemsToSetUp) {
      this.itemsToSetUp.callActionUpdate(itemsToSetUp.id, event);
    }
  }
  updateActionItemVehicle(event) {
    const list = this.itemsToSetUp.itemsToSetUpList;
    const itemsToSetUp = list.find((x) => x.type == 'api' && x.sub_type == 'VehicleDatabase');
    if (itemsToSetUp) {
      this.itemsToSetUp.callActionUpdate(itemsToSetUp.id, event);
    }
  }
  updateActionItemMx(event) {
    const list = this.itemsToSetUp.itemsToSetUpList;
    const itemsToSetUp = list.find((x) => x.type == 'api' && x.sub_type == 'MX');
    if (itemsToSetUp) {
      if (event) {
        this.itemsToSetUp.callActionUpdate(itemsToSetUp.id, 'complete');
      } else {
        this.itemsToSetUp.callActionUpdate(itemsToSetUp.id, 'created');
      }
    }
    this.commonService.fetchTransactionCountData(true);
  }
  getUpdatedListAPiManager(event) {
    this.AddFinancialAttribute.ngOnInit();
    this.getLinkedMXAccount();
  }

  defaultfolders() {
    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.vaultStateObject = state;
        this.folderList = state['defaultFolders'];

        this.customCss();
        this.cd.detectChanges();
      })
    );
    this.typeList = [];
    const currentFormType = this.documentForm.controls.formSelection.value;
    if (currentFormType != '') {
      this.setFormDataWithCurrentID();
    } else if (this.vault_user_folder_id == null || this.vault_user_folder_id == 'checklist') {
      this.setFormDataWithCurrentID();
    }

    this.userService
      .loadGoogleMapsApi()
      .then(() => {
        setTimeout(() => {
          if (typeof (window as any).google !== 'undefined') {
            this.initializeAddresseAutocomplete();
          }
        }, 0);
      })
      .catch((error) => console.error('Error loading Google Maps API:', error));

    setTimeout(() => {
      if (this.has_real_estate_value_estimate || this.has_api_source_motor) {
        this.subscribeToAddressAndVehicleFieldChanges();
      }
    }, 0);
  }
  setValurfileedCurrentID(id) {
    this.subscription.add(
      this.vaultService.vaultObject.subscribe(
        (state) => {
          const res = state.forms;
          this.CurrentTempletTypeList = res;
          if (res != null) {
            const findIndex = res.findIndex((x) => x.id == this.documentForm.controls.documentType.value);
            // if (findIndex == -1) {
            //   this.documentForm.controls.documentType.setValue(res[0]['id']);
            //   findIndex = res.findIndex(x => x.id == this.documentForm.controls.documentType.value);
            // }
            if (findIndex != -1 && res && res[findIndex] && res[findIndex]['template']['0']['singleFieldForm']) {
              // this.documentForm.get('documentName').setValue(res[findIndex].type);
              this.value_field_required = res[findIndex].value_field_required;
            } else {
            }
            this.cd.detectChanges();
          }
        },
        (error) => {
          this.toastr.error(error.error.response.message);
        }
      )
    );
  }
  setFormDataWithCurrentID() {
    this.subscription.add(
      this.vaultService.vaultObject.subscribe(
        (state) => {
          const res = state.forms;
          this.CurrentTempletTypeList = res;
          if (res != null) {
            for (let i = 0; i < res.length; i++) {
              if (res[0]['type']) {
                const test = {
                  name: res[i]['type'],
                  value: res[i]['id'],
                };
                this.typeList.push(test);
              }
            }
            const findIndex = res.findIndex((x) => x.id == this.documentForm.controls.documentType.value);
            // if (findIndex == -1) {
            //   this.documentForm.controls.documentType.setValue(res[0]['id']);
            //   findIndex = res.findIndex(x => x.id == this.documentForm.controls.documentType.value);
            // }
            if (findIndex != -1 && res && res[findIndex] && res[findIndex]['template']['0']['singleFieldForm']) {
              // this.documentForm.get('documentName').setValue(res[findIndex].type);
              this.Form1 = res[findIndex]['template'];

              try {
                this.setInternalLiksSection(res[findIndex].id);
              } catch (error) {}
              this.value_field_required = res[findIndex].value_field_required;
              this.has_death_benefit = res[findIndex].has_death_benefit;
              this.arrayItems = [];
              this.arrayItems = JSON.parse(JSON.stringify(this.Form1[0]['singleFieldForm']));
              this.showNotesitems = [];
              this.showNotesitems = this.Form1[0]['showNotes'];
              if (this.showNotesitems != undefined && this.showNotesitems.length > 0) {
                this.documentForm.addControl('showNotes', this.formBuilder.control(''));
              } else {
                this.documentForm.removeControl('showNotes');
              }
              this.createInitialPolicyform();
            } else {
              this.beneFicaryForm = [];
              this.Form1 = [];
              this.arrayItems = [];
              this.documentForm.controls.documentType.setValue('');
              this.showNotesitems = [];
            }
            this.cd.detectChanges();
          }
        },
        (error) => {
          this.toastr.error(error.error.response.message);
        }
      )
    );
  }
  hasFinancialAttributes = signal(false);
  has_transaction = false;
  hasInsuranceAttribute = signal(false);
  hasFetchedData = false;

  suggestedDocument() {
    const dialogRef = this.dialog.open(ShowSuggestionFormComponent, {
      height: '100%',
      width: '424px',
      maxWidth: '90%',
      data: {
        document_name: this.formName ? this.formName : this.documentForm.controls['documentName'].value,
        suggested_documents: this.suggested_documents,
        form_id: this.currentFormId,
        user_id: this.currentValutUserId,
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        this.cd.detectChanges();
      })
    );
  }
  setInternalLiksSection(fid) {
    this.subscription.add(
      this.store.select(vaultSelectors.getCurrentFormsById(fid)).subscribe((response) => {
        if (!!response?.financial_attributes?.trim()) {
          this.hasFinancialAttributes.set(!!response?.financial_attributes);
          this.has_transaction = !!response?.financial_attributes.split(',').includes('has_transactions');
        }
        if (!!response?.insurance_attributes.trim()) {
          this.hasInsuranceAttribute.set(true);
        }
        const formData = response;
        this.vaultFormId = formData.id;
        this.has_owns_assets = formData.owns_assets;
        this.has_owns_entities = formData.owns_entities;
        this.has_document = response.has_document;
        this.suggested_documents = response.suggested_documents;
        this.root_form_type_template = formData.type_template;
        this.hasLinkedPositions = this.formsHasLinkedPositions.includes(this.vaultFormId);
        this.hasBeneficialOwnership = this.formsHasBeneficialOwnership.includes(this.vaultFormId);
        // this.insurance_attributes = formData.insurance_attributes ? true : false;
        const rolePlayersFormData = formData.role_players.split(',').map((item) => item.trim());
        if (rolePlayersFormData.indexOf('assets_owner_with_title') != -1) {
          this.formsRolePlayers.push('assets_owner_with_title');
        }
        if (rolePlayersFormData.indexOf('entity_owner') != -1) {
          this.formsRolePlayers.push('entity_owner');
        }
        if (rolePlayersFormData.indexOf('account_owners') != -1) {
          this.formsRolePlayers.push('account_owners');
        }
        if (rolePlayersFormData.indexOf('policy_owner') != -1) {
          this.formsRolePlayers.push('policy_owner');
        }
        if (rolePlayersFormData.indexOf('sponsoring_organization') != -1) {
          this.formsRolePlayers.push('sponsoring_organization');
        }
        if (rolePlayersFormData.indexOf('manager') != -1) {
          this.formsRolePlayers.push('manager');
        }
        if (rolePlayersFormData.indexOf('grantor') != -1) {
          this.formsRolePlayers.push('grantor');
        }
        if (rolePlayersFormData.indexOf('creator') != -1) {
          this.formsRolePlayers.push('creator');
        }
        if (rolePlayersFormData.indexOf('testator') != -1) {
          this.formsRolePlayers.push('testator');
        }
        if (rolePlayersFormData.indexOf('intestate_decedent') != -1) {
          this.formsRolePlayers.push('intestate_decedent');
        }
        if (rolePlayersFormData.indexOf('beneficiaries_will') != -1) {
          this.formsRolePlayers.push('beneficiaries_will');
        }
        if (rolePlayersFormData.indexOf('beneficiaries_trust') != -1) {
          this.formsRolePlayers.push('beneficiaries_trust');
        }
        if (rolePlayersFormData.indexOf('beneficiaries_financial') != -1) {
          this.formsRolePlayers.push('beneficiaries_financial');
        }
        if (rolePlayersFormData.indexOf('beneficiaries_life_insurance') != -1) {
          this.formsRolePlayers.push('beneficiaries_life_insurance');
        }
        if (rolePlayersFormData.indexOf('beneficiaries_DAF') != -1) {
          this.formsRolePlayers.push('beneficiaries_DAF');
        }
        if (rolePlayersFormData.indexOf('designated_purchasers') != -1) {
          this.formsRolePlayers.push('designated_purchasers');
        }
        if (rolePlayersFormData.indexOf('contingent_beneficiaries_will') != -1) {
          this.formsRolePlayers.push('contingent_beneficiaries_will');
        }
        if (rolePlayersFormData.indexOf('contingent_beneficiaries_trust') != -1) {
          this.formsRolePlayers.push('contingent_beneficiaries_trust');
        }
        if (rolePlayersFormData.indexOf('contingent_beneficiaries_financial') != -1) {
          this.formsRolePlayers.push('contingent_beneficiaries_financial');
        }
        if (rolePlayersFormData.indexOf('contingent_beneficiaries_life_insurance') != -1) {
          this.formsRolePlayers.push('contingent_beneficiaries_life_insurance');
        }
        if (rolePlayersFormData.indexOf('contingent_beneficiaries_DAF') != -1) {
          this.formsRolePlayers.push('contingent_beneficiaries_DAF');
        }
        if (rolePlayersFormData.indexOf('heirs') != -1) {
          this.formsRolePlayers.push('heirs');
        }
        if (rolePlayersFormData.indexOf('trustee') != -1) {
          this.formsRolePlayers.push('trustee');
        }
        if (rolePlayersFormData.indexOf('executor') != -1) {
          this.formsRolePlayers.push('executor');
        }
        if (rolePlayersFormData.indexOf('administrators') != -1) {
          this.formsRolePlayers.push('administrators');
        }
        if (rolePlayersFormData.indexOf('digital_asset_owners') != -1) {
          this.formsRolePlayers.push('digital_asset_owners');
        }
        if (rolePlayersFormData.indexOf('guardian') != -1) {
          this.formsRolePlayers.push('guardian');
        }
        if (rolePlayersFormData.indexOf('conservator') != -1) {
          this.formsRolePlayers.push('conservator');
        }
        if (rolePlayersFormData.indexOf('pet_guardians') != -1) {
          this.formsRolePlayers.push('pet_guardians');
        }
        if (rolePlayersFormData.indexOf('advisors_DAF') != -1) {
          this.formsRolePlayers.push('advisors_DAF');
        }
        if (rolePlayersFormData.indexOf('sponsor_advisor') != -1) {
          this.formsRolePlayers.push('sponsor_advisor');
        }
        if (rolePlayersFormData.indexOf('board_members') != -1) {
          this.formsRolePlayers.push('board_members');
        }
        if (rolePlayersFormData.indexOf('corporate_advisors') != -1) {
          this.formsRolePlayers.push('corporate_advisors');
        }
        if (rolePlayersFormData.indexOf('lessee') != -1) {
          this.formsRolePlayers.push('lessee');
        }
        if (rolePlayersFormData.indexOf('insured') != -1) {
          this.formsRolePlayers.push('insured');
        }
        if (rolePlayersFormData.indexOf('trust_protector') != -1) {
          this.formsRolePlayers.push('trust_protector');
        }
        if (rolePlayersFormData.indexOf('trust_advisor') != -1) {
          this.formsRolePlayers.push('trust_advisor');
        }
        if (rolePlayersFormData.indexOf('financial_agent') != -1) {
          this.formsRolePlayers.push('financial_agent');
        }
        if (rolePlayersFormData.indexOf('medical_agent') != -1) {
          this.formsRolePlayers.push('medical_agent');
        }
        if (rolePlayersFormData.indexOf('general_agent') != -1) {
          this.formsRolePlayers.push('general_agent');
        }
        if (rolePlayersFormData.indexOf('healthcare_agent') != -1) {
          this.formsRolePlayers.push('healthcare_agent');
        }
        if (rolePlayersFormData.indexOf('authorized_representative') != -1) {
          this.formsRolePlayers.push('authorized_representative');
        }
        if (rolePlayersFormData.indexOf('direct_report') != -1) {
          this.formsRolePlayers.push('direct_report');
        }
        if (rolePlayersFormData.indexOf('reportee') != -1) {
          this.formsRolePlayers.push('reportee');
        }
        if (rolePlayersFormData.indexOf('account_holders') != -1) {
          this.formsRolePlayers.push('account_holders');
        }
        if (rolePlayersFormData.indexOf('plan_members') != -1) {
          this.formsRolePlayers.push('plan_members');
        }
        if (rolePlayersFormData.indexOf('policyholder') != -1) {
          this.formsRolePlayers.push('policyholder');
        }
        if (rolePlayersFormData.indexOf('authorized_person') != -1) {
          this.formsRolePlayers.push('authorized_person');
        }
        if (rolePlayersFormData.indexOf('responsible_party') != -1) {
          this.formsRolePlayers.push('responsible_party');
        }
        if (rolePlayersFormData.indexOf('parent_trust') != -1) {
          this.formsRolePlayers.push('parent_trust');
        }
        if (rolePlayersFormData.indexOf('sub_trust') != -1) {
          this.formsRolePlayers.push('sub_trust');
        }

        this.has_api_source = formData.api_source ? (formData.api_source?.toLowerCase().indexOf('mx') == -1 ? false : true) : false;
        this.has_location = formData.has_location ? formData.has_location : false;
        if (
          formData?.has_links &&
          formData?.has_links
            .toLowerCase()
            .split(',')
            .map((item) => item.trim())
            .includes('institution')
        ) {
          this.enable_Institution = true;
        }
        if (
          formData?.has_links &&
          formData?.has_links
            .toLowerCase()
            .split(',')
            .map((item) => item.trim())
            .includes('holdings')
        ) {
          this.enable_holdings = true;
        }
        this.has_additional_notes = formData.has_additional_notes;
        this.has_item_location =
          formData.type_template?.toLowerCase().indexOf('physical location') == -1 &&
          formData.type_template?.toLowerCase().indexOf('password location') == -1
            ? false
            : true;
        this.has_password_location = formData.has_password_location ? formData.has_password_location : false;
        this.has_api_source_motor = formData.api_source ? (formData.api_source.toLowerCase().indexOf('vehicledatabase') == -1 ? false : true) : false;
        this.has_real_estate_value_estimate = formData.api_source
          ? formData.api_source.toLowerCase().indexOf('zillow') == -1
            ? false
            : true
          : false;
        // this.has_api_source_motor = formData.api_source.toLowerCase().indexOf('vehicledatabase') == -1 ? false : true;
        // this.has_api_source = formData.api_source.toLowerCase().indexOf('mx') == -1 ? false : true;
        // this.has_location = formData.has_location ? true : false;
        // this.has_sublocation = formData.has_sublocation ? true : false;
        // this.has_assets = formData.has_assets ? true : false;
        // this.has_entity = formData.has_entity ? true : false;

        if (
          formData?.has_links &&
          formData?.has_links
            .toLowerCase()
            .split(',')
            .map((item) => item.trim())
            .includes('financial account')
        ) {
          this.enable_financial_account = true;
        }
        if (
          formData?.has_links &&
          formData?.has_links
            .toLowerCase()
            .split(',')
            .map((item) => item.trim())
            .includes('cryptocurrency')
        ) {
          this.enable_linked_cryptocurrency = true;
        }
        if (
          formData?.has_links &&
          formData?.has_links
            .toLowerCase()
            .split(',')
            .map((item) => item.trim())
            .includes('cryptocurrency wallet')
        ) {
          this.enable_linked_cryptocurrency_wallets = true;
        }
        if (
          formData?.has_links &&
          formData?.has_links
            .toLowerCase()
            .split(',')
            .map((item) => item.trim())
            .includes('exchange account')
        ) {
          this.enable_linked_exchange_accounts = true;
        }
        if (
          formData?.has_links &&
          formData?.has_links
            .toLowerCase()
            .split(',')
            .map((item) => item.trim())
            .includes('exchange wallet')
        ) {
          this.enable_linked_exchange_wallets = true;
        }

        this.formsRolePlayers = [...new Set(this.formsRolePlayers)];
      })
    );

    this.cd.detectChanges();
    this.passFormListForSearch(this.eventFormListData);
    this.passFormList(this.eventListData);
  }

  templateListCounter(empIndex: number, formControlName): UntypedFormArray {
    return this.documentForm.controls.beneFicaryForm['controls'][empIndex]['controls'][formControlName].value.length;
  }
  templateList(empIndex: number, formControlName): UntypedFormArray {
    return this.documentForm.controls.beneFicaryForm['controls'][empIndex]['controls'][formControlName];
  }
  setformData(val) {
    const myObj = this.CurrentTempletTypeList.find((obj) => obj.id == val);
    if (myObj && myObj['template']['0']['singleFieldForm']) {
      this.Form1 = myObj['template'];
      this.arrayItems = [];
      this.arrayItems = JSON.parse(JSON.stringify(this.Form1[0]['singleFieldForm']));
      this.showNotesitems = [];
      this.showNotesitems = this.Form1[0]['showNotes'];
      this.createInitialPolicyform();
    }
  }
  createInitialPolicyform() {
    this.arrayItems = [];
    this.arrayItems = JSON.parse(JSON.stringify(this.Form1[0]['singleFieldForm']));
    if (this.currentTemplate?.type === 'Automobile') {
      this.arrayItems.map((item) => {
        if (item.label.includes('Trim')) {
          item.type = 'text';
        }
      });

      this.arrayItems.map((item) => {
        if (item.label.includes('Condition')) {
          item.options = [
            {
              label: 'Outstanding',
              value: 'Outstanding',
            },
            {
              label: 'Clean',
              value: 'Clean',
            },
            {
              label: 'Average',
              value: 'Average',
            },
            {
              label: 'Rough',
              value: 'Rough',
            },
          ];
        }
      });
      // const conditionItem ={
      //   api_field_mapping: "condition",
      //   excludedFromOnboarding: false,
      //   formControlName: "automobileCondition",
      //   isRequired: false,
      //   label: "Condition",
      //   makeEyeField: false,
      //   options: [{
      //     label: "Outstanding",
      //     value: "Outstanding"
      //   },
      //   {
      //     label: "Clean",
      //     value: "Clean"
      //   },
      //   {
      //     label: "Average",
      //     value: "Average"
      //   },
      //   {
      //     label: "Rough",
      //     value: "Rough"
      //   }
      //   ],
      //   placeholder: "",
      //   record_default: null,
      //   row_num: 5,
      //   setDefaultEyeField: false,
      //   triggerType: null,
      //   type: "select",
      //   width: "33%",
      // }

      // const trimItem = this.arrayItems.findIndex(x => x.label.includes('Trim'));

      // if(trimItem){
      //   this.arrayItems.splice(trimItem + 1, 0, conditionItem);
      // }

      // this.arrayItems.forEach(element => {
      //   if(element.label.includes('Trim')){
      //     element.width = "66%";
      //   }
      //   if(element.label.includes('Inspection Expiration Date')){
      //     element.row_num = 6;
      //   }
      //   if(element.label.includes('Registration Expiration Date')){
      //     element.row_num = 6;
      //   }
      // });
    }
    this.showNotesitems = [];
    this.showNotesitems = this.Form1[0]['showNotes'];
    if (this.showNotesitems != undefined && this.showNotesitems.length > 0) {
      this.documentForm.addControl('showNotes', this.formBuilder.control(''));
    } else {
      this.documentForm.removeControl('showNotes');
    }
    this.t.clear();
    const test = this.formBuilder.group({});
    this.arrayItems.forEach(function (value) {
      if (value['type'] === 'MultiPleDropDown') {
        test.addControl(value.formControlName, new UntypedFormControl(''));
        value['data'].forEach((childcontrols) => {
          childcontrols['template'].forEach((child) => {
            test.addControl(child.formControlName, new UntypedFormControl(''));
          });
        });
      } else if (value['type'] === 'Section') {
      } else if (value['type'] == 'email') {
        test.addControl(value.formControlName, new UntypedFormControl(''));
      } else {
        test.addControl(value.formControlName, new UntypedFormControl(''));
      }
    });
    this.t.push(test);
    this.documentForm.removeControl('beneFicaryForm');
    this.documentForm.addControl('beneFicaryForm', new UntypedFormArray([]));
    if (this.Form1[0]['multiFieldForm'].length) {
      this.beneFicaryForm = [];
      this.beneFicaryForm = this.Form1[0]['multiFieldForm'];
      this.Form1[0]['multiFieldForm'].forEach((element) => {
        const temporary = new UntypedFormGroup({});
        temporary.addControl(element.formControlName, new UntypedFormArray([]));
        const test = new UntypedFormGroup({});
        const items = this.documentForm.controls['beneFicaryForm'] as UntypedFormArray;
        items.push(temporary);
      });
      for (let i = 0; i < this.Form1[0]['multiFieldForm'].length; i++) {}
    } else {
      this.beneFicaryForm = [];
    }

    this.cd.detectChanges();
  }
  removeBeneficary(formcontrolName, index, childIndex) {
    const items = this.documentForm.controls['beneFicaryForm']['controls'][index]['controls'][formcontrolName] as UntypedFormArray;
    items.removeAt(childIndex);
    this.cd.detectChanges();
  }
  addBeneficiarybyform(formcontrolName, index) {
    const element = this.Form1[0]['multiFieldForm'][index];
    const test = new UntypedFormGroup({});
    element.template.forEach((childelement) => {
      if (childelement['type'] == 'email') {
        if (childelement['isRequired']) {
          test.addControl(childelement.formControlName, new UntypedFormControl('', [Validators.required, Validators.email]));
        } else {
          test.addControl(childelement.formControlName, new UntypedFormControl('', [Validators.email]));
        }
      } else {
        if (childelement['isRequired']) {
          test.addControl(childelement.formControlName, new UntypedFormControl('', Validators.required));
        } else {
          test.addControl(childelement.formControlName, new UntypedFormControl(''));
        }
      }
    });
    const items = this.documentForm.controls['beneFicaryForm']['controls'][index]['controls'][formcontrolName] as UntypedFormArray;
    items.push(test);
    this.cd.detectChanges();
  }

  clearDate(event) {
    event.stopPropagation();
    // this.date = null;
  }
  addBeneficiary() {
    const preOrder = this.beneFicaryForm['0'][0];

    const temp = {};
    temp[this.beneFicaryForm.length.toString()] = preOrder;
    this.beneFicaryForm.push(temp);
    for (let i = 0; i < this.Form1[0]['multiFieldForm'].length && i < 1; i++) {
      const test = new UntypedFormGroup({});

      this.Form1[0]['multiFieldForm'][0][0].forEach(function (value) {
        test.addControl(value.formControlName, new UntypedFormControl('', Validators.required));
      });
      const items = this.documentForm.controls['beneFicaryForm'] as UntypedFormArray;

      items.push(test);
    }
    this.cd.detectChanges();
  }
  mobilecheckValue(data) {
    if (this.isOficeWorkSpace) {
      const modalRef2 = this.dialog.open(FolderRadioListComponent, {
        disableClose: true,
        data: {
          currentValutUserId: this.currentValutUserId,
          estate_tab_group_id: this.mobile_estate_tab_group_id,
          hideForloderSelection: this.hideForloderSelection ? this.hideForloderSelection : false,
          sleectedValue: this.documentForm.controls['selectOfficeSaveFolder'].value,
          folderList: this.officefolderList,
          subfolderList: this.fullOfficeFolderList,
          showFolderList: this.showFolderList,
          isOficeWorkSpace: this.isOficeWorkSpace,
          currentUserId: this.currentuserId,
        },
        panelClass: 'full-window-dialog-radiolist',
        autoFocus: false,
      });
      this.subscription.add(
        modalRef2.afterClosed().subscribe((res) => {
          if (res['save']) {
            this.documentForm.controls['selectOfficeSaveFolder'].setValue(res['saveto']);
            data['selectOfficeSaveFolder'] = res['saveto'];
            this.checkValue(data);
          }
        })
      );
    } else {
      const modalRef2 = this.dialog.open(FolderRadioListComponent, {
        disableClose: true,
        data: {
          currentValutUserId: this.currentValutUserId,
          estate_tab_group_id: this.mobile_estate_tab_group_id,
          hideForloderSelection: this.hideForloderSelection ? this.hideForloderSelection : false,
          sleectedValue: this.documentForm.controls['selectSaveFolder'].value,
          folderList: this.folderList,
          subfolderList: this.subfolderList,
          showFolderList: this.showFolderList,
          isOficeWorkSpace: this.isOficeWorkSpace,
        },
        panelClass: 'full-window-dialog-radiolist',
        autoFocus: false,
      });
      this.subscription.add(
        modalRef2.afterClosed().subscribe((res) => {
          if (res['save']) {
            this.documentForm.controls['selectSaveFolder'].setValue(res['saveto']);
            data['selectSaveFolder'] = res['saveto'];
            if (res['groupId']) {
              data['selectSaveFolder'] = res['groupId'];
            }
            this.checkValue(data);
          }
        })
      );
    }
  }

  saveGeneralSetup() {
    try {
      const list = this.itemsToSetUp.itemsToSetUpList;
      const itemsToSetUp = list.find((x) => x.type == 'general');
      if (itemsToSetUp) {
        this.itemsToSetUp.callActionUpdate(itemsToSetUp.id, this.itemsToSetup.controls['generalSection'].value ? 'complete' : 'created');
      }
    } catch (error) {}
  }
  compareDates(date1, date2) {
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    // check if both are valid dates
    if (!isNaN(d1.getTime()) && !isNaN(d2.getTime())) {
      // compare only date part (ignoring time)
      const sameDate = d1.toDateString() === d2.toDateString();
      return !sameDate; // equal -> false, not equal -> true
    }

    // if not valid dates -> return true
    return true;
  }
  async checkValue(data, closePopUp = false, transaction = null, key_updated = false) {
    this.isGeneralSectionResolve = false;
    this.loaderService.show();

    let dynamicFieldsForm = null;
    if (transaction == 'Save General Section') {
      dynamicFieldsForm = data['dynamicFieldsForm'][0];
      const findElement = this.arrayItems?.find((x) => x.type == 'largeText' && x.label == 'Description')
        ? this.arrayItems?.find((x) => x.type == 'largeText' && x.label == 'Description')
        : null;

      if (findElement) {
        try {
          dynamicFieldsForm[findElement.formControlName] = this.saveFormValueInDb.dynamicFieldsForm[findElement.formControlName];
        } catch (error) {}
      }
    } else if (transaction == 'Description Section') {
      try {
        dynamicFieldsForm = this.saveFormValueInDb.dynamicFieldsForm;
      } catch (error) {}

      const findElement = this.arrayItems?.find((x) => x.type == 'largeText' && x.label == 'Description')
        ? this.arrayItems?.find((x) => x.type == 'largeText' && x.label == 'Description')
        : null;

      if (findElement) {
        dynamicFieldsForm[findElement.formControlName] = this.NgxEditorField.name.value;
      }
    } else {
      dynamicFieldsForm = data['dynamicFieldsForm'][0];
    }
    if (this.Form1[0]['singleFieldForm']?.length > 0 && this.Form1[0]['singleFieldForm'].find((x) => x.type == 'largeText')) {
      const findElement = this.Form1[0]['singleFieldForm'].find((x) => x.type == 'largeText');
      if (findElement) {
        dynamicFieldsForm[findElement.formControlName] = JSON.stringify({
          is_atob: true,
          value: btoa(encodeURIComponent(dynamicFieldsForm[findElement.formControlName])),
        });
      }
    }

    let obj = {
      dynamicFieldsForm: dynamicFieldsForm,
      beneFicaryForm: data['beneFicaryForm'],
      showNotes: data['showNotes'],
      isEditBy: {},
    };
    Object.entries(dynamicFieldsForm).forEach(([key, value]) => {
      try {
        if (value !== '') {
          if (
            this.already_saved_data == null ||
            (this.already_saved_data.dynamicFieldsForm[key] != value && this.compareDates(this.already_saved_data.dynamicFieldsForm[key], value))
          ) {
            obj.isEditBy[key] = 'user';
          } else if (this.already_saved_data?.isEditBy[key]) {
            obj.isEditBy[key] = this.already_saved_data.isEditBy[key];
          }
        }
      } catch (error) {}
    });

    try {
      this.saveFormValueInDb.dynamicFieldsForm = obj.dynamicFieldsForm;
    } catch (error) {}
    let vault_user_folder_id;
    if (
      data['selectSaveFolder'] == 1 ||
      data['selectSaveFolder'] == 2 ||
      data['selectSaveFolder'] == 3 ||
      data['selectSaveFolder'] == 4 ||
      data['selectSaveFolder'] == 5 ||
      data['selectSaveFolder'] == 6 ||
      data['selectSaveFolder'] == 8 ||
      data['selectSaveFolder'] == 7
    ) {
      this.folderList.forEach((element) => {
        if (element.id == data['selectSaveFolder']) {
          vault_user_folder_id = element.vault_user_folder_id;
        }
      });
    } else {
      vault_user_folder_id = data['selectSaveFolder'];
    }
    this.is_linked_form_id = this.data?.is_linked_form_id ?? -1;
    const request = {
      user_id: this.securityStateObject.userId,
      user_pk: this.public_key(),
      vault_form_id: this.documentForm.controls['documentType'].value,
      vault_folder_id: data['selectSaveFolder'],
      vault_user_folder_id: vault_user_folder_id,
      form_data: obj,
      notes: this.documentForm.controls['notes'].value,
      physical_location: this.documentForm.controls['physicalLocation'].value,
      status_progress: this.documentForm.controls['status_progress'].value,
      is_linked_form_id: this.data?.is_linked_form_id,
    };
    request['id'] = this.currentFormId;
    if (this.Form1 != null && this.Form1.length != 0) {
      const multiDropMainStack = this.Form1[0]['singleFieldForm'].filter((x) => x.type == 'MultiPleDropDown');
      let multidropDownFomllist = [];
      multiDropMainStack.forEach((element) => {
        if (element && element['data']) {
          element['data'].forEach((childelement) => {
            if (childelement && childelement['template']) {
              multidropDownFomllist = multidropDownFomllist.concat(childelement['template']);
            }
          });
        }
      });
      for (const key of Object.keys(request['form_data']['dynamicFieldsForm'])) {
        const originalData = request['form_data']['dynamicFieldsForm'][key];

        const tempIndex = this.Form1[0]['singleFieldForm'].findIndex((x) => x.formControlName == key);
        if (tempIndex != -1) {
          const currnetTmplateObj = this.Form1[0]['singleFieldForm'][tempIndex];

          if (currnetTmplateObj['type'] == 'date') {
            if (originalData == '' || originalData == null || originalData == undefined) {
            } else {
              const date = new Date(request['form_data']['dynamicFieldsForm'][key]);
              if (Object.prototype.toString.call(date) === '[object Date]') {
                // it is a date
                if (isNaN(date.getTime())) {
                  // d.valueOf() could also work
                  // date is not valid
                } else {
                  const neddddDatae = date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
                  request['form_data']['dynamicFieldsForm'][key] = neddddDatae.toString();
                }
              } else {
                // not a date
              }
            }
          }
        } else {
          const CtempIndex = multidropDownFomllist.findIndex((x) => x.formControlName == key);
          if (CtempIndex != -1) {
            const currnetTmplateObj = multidropDownFomllist[CtempIndex];
            if (currnetTmplateObj['type'] == 'date') {
              if (originalData == '' || originalData == null || originalData == undefined) {
              } else {
                const date = new Date(request['form_data']['dynamicFieldsForm'][key]);
                if (Object.prototype.toString.call(date) === '[object Date]') {
                  // it is a date
                  if (isNaN(date.getTime())) {
                    // d.valueOf() could also work
                    // date is not valid
                  } else {
                    const neddddDatae = date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
                    request['form_data']['dynamicFieldsForm'][key] = neddddDatae.toString();
                  }
                } else {
                  // not a date
                }
              }
            }
          }
        }
      }

      let beneFicaryFormListStack = [];
      this.Form1[0]['multiFieldForm'].forEach((element) => {
        beneFicaryFormListStack = beneFicaryFormListStack.concat(element['template']);
      });
      request['form_data']['beneFicaryForm'].forEach((element, outerindex) => {
        Object.keys(element).forEach((Outerelementkey) => {
          request['form_data']['beneFicaryForm'][outerindex][Outerelementkey].forEach((element, inneIndex) => {
            for (const innerKey of Object.keys(element)) {
              const tempIndex = beneFicaryFormListStack.findIndex((x) => x.formControlName == innerKey);
              if (tempIndex != -1) {
                const currnetTmplateObj = beneFicaryFormListStack[tempIndex];
                if (currnetTmplateObj['type'] == 'date') {
                  const originalData = request['form_data']['beneFicaryForm'][outerindex][Outerelementkey][inneIndex][innerKey];
                  if (originalData == '' || originalData == null || originalData == undefined) {
                  } else {
                    const date = new Date(request['form_data']['beneFicaryForm'][outerindex][Outerelementkey][inneIndex][innerKey]);

                    if (Object.prototype.toString.call(date) === '[object Date]') {
                      // it is a date
                      if (isNaN(date.getTime())) {
                        // d.valueOf() could also work
                        // date is not valid
                      } else {
                        const neddddDatae = date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
                        request['form_data']['beneFicaryForm'][outerindex][Outerelementkey][inneIndex][innerKey] = neddddDatae.toString();
                      }
                    } else {
                      // not a date
                    }
                  }
                }
              }
            }
          });
        });
      });
    } else {
      delete request['form_data'];
      delete request['vault_form_id'];
    }

    let sk_value = null;
    // if (this.mode == 'edit') {
    if (!this.isSecurityKeyAdded) {
      request['security_key'] = null;
      this.saveFormData(request, sk_value, closePopUp, key_updated);
    } else {
      request['security_key'] = this.selectedSecurity_key['sk'];
      sk_value = this.selectedSecurity_key;
      this.saveFormData(request, sk_value, closePopUp, key_updated);
    }
    // }
    // else {
    //   if (this.isSecurityKeyAdded && this.manageSecuritykey != null && this.manageSecuritykey.length && this.manageSecuritykey[0]['sk']) {
    //     request['security_key'] = this.manageSecuritykey[0]['sk'];
    //     sk_value = this.manageSecuritykey[0];
    //   } else {
    //     request['security_key'] = null;
    //   }

    //   this.saveFormData(request, sk_value);
    // }
  }
  async saveFormData(request, sk_value, closePopUp = false, key_updated = false) {
    if (this.isOficeWorkSpace) {
      request.origin = VaultUserFormOrigin.workspace;
      request.vault_folder_id = null;
      request.vault_user_folder_id = null;
      if (this.currentWorkSpaceId == this.documentForm.controls.selectOfficeSaveFolder.value) {
        request.workspace_id = this.currentWorkSpaceId;
      } else {
        request.workspace_id = this.currentWorkSpaceId;
        request.workspace_folder_id = this.documentForm.controls.selectOfficeSaveFolder.value;
      }
    } else {
      request.origin = VaultUserFormOrigin.vault;
    }
    if (this.router.url.includes('my-information')) {
      request.origin = VaultUserFormOrigin.officeVault;

      if (this.documentForm.controls.selectOfficeSaveFolder.value != -1) {
        request.office_vault_folder_id = this.documentForm.controls.selectOfficeSaveFolder.value;
      }
    }

    if (request['security_key'] == null || request['security_key'] == null) {
      this.isBasic = true;
    } else {
      this.isBasic = false;
    }
    this.isLottieOn = true;
    this.cd.detectChanges();

    let last_used_sk_value;
    if (sk_value == null && this.security_key != null) {
      last_used_sk_value = this.security_key; //the form was opened with an sk, but was turned off
    }

    let sk_just_enabled = false;
    if (sk_value != null && this.security_key == null) {
      sk_just_enabled = true;
    }

    const date = new Date(this.documentForm.controls.expiration_date.value);
    const newFormatdate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    request['expiration_date'] = newFormatdate;
    if (!this.documentForm.controls.expiration_date.value) {
      request['expiration_date'] = null;
    }

    const value_appraisal_date = new Date(this.documentForm.controls.value_appraisal_date.value);
    const newFormatvalue_appraisal_date = `${value_appraisal_date.getFullYear()}-${
      value_appraisal_date.getMonth() + 1
    }-${value_appraisal_date.getDate()}`;
    request['value_appraisal_date'] = newFormatvalue_appraisal_date;
    if (!this.documentForm.controls.value_appraisal_date.value) {
      request['value_appraisal_date'] = null;
    }

    const review_date_date = new Date(this.documentForm.controls.review_date.value);
    const newreview_date_dateFormatdate = `${review_date_date.getFullYear()}-${review_date_date.getMonth() + 1}-${review_date_date.getDate()}`;
    request['review_date'] = newreview_date_dateFormatdate;
    if (!this.documentForm.controls.review_date.value) {
      request['review_date'] = null;
    }

    const renewal_date_date = new Date(this.documentForm.controls.renewal_date.value);
    const renewal_date_datedateFormatdate = `${renewal_date_date.getFullYear()}-${renewal_date_date.getMonth() + 1}-${renewal_date_date.getDate()}`;
    request['renewal_date'] = renewal_date_datedateFormatdate;
    if (!this.documentForm.controls.renewal_date.value) {
      request['renewal_date'] = null;
    }

    request['expiration_notification'] = this.documentForm.controls.expiration_notification.value == 'true' ? true : false;

    request['value_is_appraisal'] = this.documentForm.controls.value_is_appraisal.value == 'true' ? true : false;

    request['value_currency'] = this.documentForm.controls.value_currency.value;

    request['value_current_currency'] = this.documentForm.controls.value_current_currency.value;

    request['review_notification'] = this.documentForm.controls.review_notification.value == 'true' ? true : false;

    if (!this.documentForm.controls.review_notification.value) {
      request['review_notification'] = null;
    }

    request['renewal_notification'] = this.documentForm.controls.renewal_notification.value == 'true' ? true : false;

    if (!this.documentForm.controls.renewal_notification.value) {
      request['renewal_notification'] = null;
    }

    if (!this.documentForm.controls.value_is_appraisal.value) {
      request['value_is_appraisal'] = null;
    }
    if (
      this.documentForm.controls.value_current_currency.value == '' ||
      this.documentForm.controls.value_current_currency.value == undefined ||
      this.documentForm.controls.value_current_currency.value == null
    ) {
      request['value_current_currency'] = null;
    }

    if (
      this.documentForm.controls.value_currency.value == '' ||
      this.documentForm.controls.value_currency.value == undefined ||
      this.documentForm.controls.value_currency.value == null
    ) {
      request['value_currency'] = null;
    }

    if (!this.documentForm.controls.expiration_notification.value) {
      request['expiration_notification'] = null;
    }

    request['recurring_expiration'] = this.documentForm.controls.recurring_expiration.value;

    if (!this.documentForm.controls.recurring_expiration.value) {
      request['recurring_expiration'] = null;
    }
    //check to see if this form is part of a workspace, if so use workspace owner for form encryption work
    if (this.origin == 'workspace') {
      request.user_id = this.currentWorkspaceOwner.id;
      request.user_pk = this.currentWorkspaceOwner.public_key;
    }
    if (this.data?.estate_tab_group_id || this.data?.estate_asset_tab_group_id || this.data?.estate_asset_tab_id == -1) {
      request['estate_asset_tab_group_id'] = this.documentForm.controls.selectSaveFolder.value;
      request['origin'] = 'asset';
      delete request['vault_folder_id'];

      // delete request['vault_user_folder_id'];
    }
    if (this.isInformationWorkSpace) {
      if (this.documentForm.controls.selectSaveFolder.value != -1) {
        request['office_vault_folder_id'] = this.documentForm.controls.selectSaveFolder.value;
      }
      // delete request['vault_user_folder_id'];
      delete request['vault_folder_id'];
      delete request['workspace_folder_id'];
      delete request['workspace_id'];
    }
    if (request['vault_folder_id'] == -1) {
      delete request['vault_folder_id'];
    }
    // if (request['vault_user_folder_id'] == -1) {
    //   delete request['vault_user_folder_id'];
    // }
    if (request['office_vault_folder_id'] == null || request['office_vault_folder_id'] == '') {
      delete request['office_vault_folder_id'];
    }
    if (this.mode == 'edit') {
      delete request['origin'];
      delete request['user_id'];
      delete request['vault_form_id'];
      delete request['workspace_id'];
      delete request['vault_folder_id'];
      delete request['workspace_folder_id'];
    }
    if (request['estate_asset_tab_group_id'] == -1 || request['estate_asset_tab_group_id'] == null) {
      delete request['estate_asset_tab_group_id'];
    }
    // try {
    //   if (request['vault_user_folder_id']?.toString().includes('group_')) {
    //     let id = +request['vault_user_folder_id'].replace('group_', '');
    //     this.defaultFoldersList.forEach((rootelement) => {
    //       if (rootelement?.groups?.length) {
    //         rootelement?.groups.forEach((group) => {
    //           // if (group.id == id) {
    //           //   request['vault_user_group_id'] = group.id;
    //           //   request['vault_user_folder_id'] = group.vault_user_folder_id;
    //           // }
    //         });
    //       }
    //       if (rootelement?.subfolders?.length) {
    //         rootelement.subfolders.forEach((element) => {
    //           element.groups.forEach((group) => {
    //             // if (group.id == id) {
    //             //   request['vault_user_group_id'] = group.id;
    //             //   request['vault_user_folder_id'] = group.vault_user_folder_id;
    //             // }
    //           });
    //         });
    //       }
    //     });
    //   }
    // } catch (error) {}

    if (request['is_linked_form_id'] == -1) {
      delete request['is_linked_form_id'];
    }
    try {
      // this.AddReminderChild?.saveAllReminderList();
      // this.AddReminderChild?.saveSystemReminderList();
    } catch (error) {}

    if (this.vaultStateObject.vaultId) {
      request['vault_id'] = this.vaultStateObject.vaultId;
    }
    if (this.saveResponse != undefined) {
      this.saveResponse.vaultFormData[0].form_data = JSON.stringify(request.form_data);
      try {
        this.savedDynamicFieldsFormValueInDb = [JSON.parse(JSON.stringify(request.form_data)).dynamicFieldsForm];
      } catch (error) {}

      this.saveBeneficiaryFormValueInDb = this.documentForm.controls.beneFicaryForm.value;
    }
    if (request['vault_folder_id'] == '') {
      delete request['vault_folder_id'];
    }
    // if (request['vault_user_folder_id'] == '') {
    //   delete request['vault_user_folder_id'];
    // }

    if (this.LocationEnable) {
      request['origin'] = 'location';
      delete request['vault_folder_id'];
      // delete request['vault_user_folder_id'];
    }

    if (this.data.origin) {
      request['origin'] = this.data.origin;
    }

    delete request['vault_user_folder_id'];
    delete request['vault_user_group_id'];

    this.subscription.add(
      this.documentService
        .updateFormTampletData(request, sk_value, last_used_sk_value, this.formEncryptionKey, sk_just_enabled, this.sk, true)
        .subscribe(
          (res) => {
            const url = this.router.url.split('/');
            if (
              url.length > 2 &&
              url[1] == 'office' &&
              url[2] == 'my-admin?admin=true' &&
              this.securityStateObject.userId &&
              this.securityStateObject.public_key
            ) {
              if (!this.data?.is_linked_form_id) {
                this.store$.dispatch(new vaultStoreActions.UserFoldersRequest(this.securityStateObject.userId, false));
              }
            }

            this.loaderService.hide();
            this.isSavedData = true;
            this.currentFormId = res['id'];
            this.getItemSetupList();
            this.moveTonextStepData = res;
            this.currentFormName = res['form_name'];
            this.currentFolderId = res['vault_folder_id'];

            if (!closePopUp) {
              // this.formEncryptionKey = res['encryption_key'];
            }

            this.makeSelectDivDisabel = true;
            const lastItem = this.router.url.substring(this.router.url.lastIndexOf('/') + 1);
            const model = {
              folderId: res['vault_user_folder_id'],
              userId: this.securityStateObject.userId,
            };
            if (this.data?.isintelligent == true || this.data?.mode == 'add') {
              if (this.screenWidth < 600) {
                if (this.data?.is_linked_form_id) {
                  this.toastr.success(`File created and linked to ${this.data.Linked_form_name}`, '', {
                    positionClass: 'toast-bottom-center',
                  });
                } else {
                  this.toastr.success(`File saved successfully`, '', {
                    positionClass: 'toast-bottom-center',
                  });
                }
              } else {
                if (this.data?.is_linked_form_id) {
                  this.toastr.success(`File created and linked to ${this.data.Linked_form_name}`);
                } else {
                  this.toastr.success(`File saved successfully`);
                }
              }
              if (this.isOficeWorkSpace && !this.data?.is_linked_form_id) {
                this.subscription.add(this._notifyWorkSpaceUpdate.sendMessage('true'));
              }
              // this.vaultSideNavService.handleModal(true);
              if (!closePopUp) {
                this.removeCssFromPopUpWindow();
                if (!key_updated) {
                  this.dialogRef.close();
                }
              }
            } else {
              // this.mode = 'view';
              this.isBlueOutlinTextbox = false;
              if (this.screenWidth < 600) {
                this.toastr.success(`File updated successfully`, '', {
                  positionClass: 'toast-bottom-center',
                });
                if (!key_updated) {
                  this.removeCssFromPopUpWindow();
                  this.dialogRef.close();
                }
              } else {
                if (!key_updated) {
                  this.removeCssFromPopUpWindow();
                  this.dialogRef.close();
                }
                this.toastr.success(`File updated successfully`);
              }
              //this.cd.detectChanges();
            }
            this.isLottieOn = false;
            this.cd.detectChanges();
            if (this.is_linked_form_id == -1) {
              this.subscription.add(this.notifyEstateActiveTabUpdate.sendMessage('true'));
            }

            if (request['origin'] == 'location') {
              this.subscription.add(
                this._notifyDocumentCreatedAddAsLocation.sendMessage({
                  isUpdated: true,
                  id: this.currentFormId,
                  sub_location_Enable: this.data.sub_location_Enable,
                })
              );
            }
            const getFilesModel = {
              folderId: url?.length > 7 ? url[6] : url[4],
              userId: this.currentValutUserId,
              mydata: this.router.url.includes('mydata') ? true : false,
            };

            if (this.router.url.includes('vault') && this.router.url.includes('folder')) {
              getFilesModel['folderId'] = url?.length > 6 ? url[6] : url[4];
            }
            if (this.router.url.includes('collaboration') && !this.router.url.includes('admin=true')) {
              getFilesModel['userId'] = this.currentuserId;
            }
            this.subscription.add(
              this.notifySummaryUpdateService.sendMessage({
                needToUpdateUI: true,
                res,
              })
            );

            if (
              ((this.router.url.includes('/network/') || this.router.url.includes('/office-network/')) &&
                this.router.url.includes('/admin-vault') &&
                this.router.url.includes('?admin=true')) ||
              this.router.url.includes('admin-vault/search-results-data?q=')
            ) {
            }
            // if (this.data?.estate_asset_tab_id && this.data?.estate_asset_tab_id != -1) {
            //   this.store$.dispatch(new estateStoreActions.GetAssetTabFormRquestAction(this.data?.estate_asset_tab_id));
            // }
            this.closedSideNavTemplate.sendMessage('true');
            if (closePopUp) {
              //Sk COde
              // this.sk = null;
              // this.formEncryptionKey = null;
              // this.security_key = null;
              // this.setEdittempletdataform();
            }
          },
          (error) => {
            this.isLottieOn = false;
            this.toastr.error(error.error.response.message);
            this.loaderService.hide();
          }
        )
    );
  }

  openDataExtractionSideNav(event) {
    this.commonService.toggleDataExtractionToggleSubject(true);
    this.cd.detectChanges();
  }
  saveAllfiles() {
    this.loaderService.show();
    this.filelist.forEach((element, index) => {
      if (this.filelist.length - 1 == index) {
        this.saveFiletoDatabase(element, true);
      } else {
        this.saveFiletoDatabase(element, false);
      }
    });
  }
  saveFiletoDatabase(data, isStop) {
    const objData = {
      id: data['delete_id'],
      status: 'uploaded',
      vault_user_form_id: this.currentFormId,
    };
    this.subscription.add(
      this.documentService.setFileuploadedStatus(objData).subscribe(
        (res) => {
          if (isStop) {
            this.loaderService.show();
          }
          this.cd.detectChanges();
        },
        (error) => {
          this.toastr.error('Error uploading File.');
        }
      )
    );
    this.cd.detectChanges();
  }
  reloadFileEventEmitter(event) {
    this.getfileliseForCurrentForms();
    if (!event?.donotRefreshDocument) {
      this.refrechDocument();
    }
  }
  manageLocation(file) {
    const dialogRef = this.dialog.open(EditAddLinkedTemplatePopupComponent, {
      data: {
        icon_path: 'https://s3.amazonaws.com/kinnect.app.assets/sections/locations.svg',
        is_running: false,
        label: 'Physical Location',
        suggestion_icon_pth: 'assets/images/linked-folder/linked-suggestion.svg',
        template_list: [],
        type: 'Physical Location',
        allowedOne: true,
        getLinkedLocation: true,
        linkedLocation: false,
        type_template: 'Physical Locations',
        currentuserId: this.currentuserId,
        formsList: this.formsList,
        filter_with: 'type_template',
        formName: this.formName ? this.formName : this.documentForm.controls['documentName'].value,
        vault_user_form_uploads_id: file.delete_id,
        currentFormId: this.currentFormId,
        origin: 'location',
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        this.getfileliseForCurrentForms();
      })
    );
  }
  downloadAllAttachment() {
    this.loaderService.show();
    this.subscription.add(
      this.documentService.getUploadedFilesListbyformId(this.currentFolderId, this.currentFormId).subscribe(
        (res) => {
          this.AllDownloadfiles = [];
          res.files.forEach((element) => {
            this.AllDownloadfiles.push({
              status: 'Done',
              name: element.display_file_name,
              progressbar: 100,
              delete_id: element.id,
              delete_upload_path: res.upload_path,
              created_at: element.created_at,
            });
          });

          //insert a row for the form itself to be downloaded
          this.AllDownloadfiles.push({
            form_id: this.currentFormId,
            name: this.currentFormName,
          });

          if (this.AllDownloadfiles.length) {
            this.loaderService.show();
            this.AllDownloadfiles.forEach((element, index) => {
              if (element.form_id) {
                this.downloadAttachment(element.form_id, `${element.name}.pdf`, index == this.files.length - 1, true);
              } else {
                if (index == this.files.length - 1) {
                  this.downloadAttachment(element.delete_id, element.name, true);
                } else {
                  this.downloadAttachment(element.delete_id, element.name, false);
                }
              }
            });
          } else {
            this.loaderService.hide();
          }
        },
        (error) => {}
      )
    );
  }
  onmouseOutEvent(event: any, i) {
    this.files[i].isActive = false;
    this.cd.detectChanges();
  }
  onFocuEvent(event: any, i) {
    this.files[i].isActive = true;
    this.cd.detectChanges();
  }
  renameFolder(folder, i) {
    const dialogRef = this.dialog.open(AddSubfolderComponent, {
      width: '400px',
      maxWidth: this.screenWidth < 480 ? '90vw' : '80vw',
      data: {
        title: 'Rename Attachment',
        buttonName: 'Rename',
        currentFolderName: this.files[i].file_name_without_extesion ? this.files[i].file_name_without_extesion : 'Untitled File',
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((Resultdata) => {
        if (Resultdata && Resultdata.confirmation) {
          const extension =
            this.files[i].display_file_name.substring(this.files[i].display_file_name.lastIndexOf('.') + 1, this.files[i].display_file_name.length) ||
            this.files[i].display_file_name;
          const data = {
            display_file_name: Resultdata.subfolderName + '.' + extension,
            id: this.files[i]['delete_id'],
          };
          this.files[i].file_name_without_extesion = Resultdata.subfolderName;
          this.subscription.add(
            this.documentService.setFileuploadedStatus(data).subscribe((res) => {
              this.files[i].display_file_name = this.files[i].file_name_without_extesion + '.' + extension;
              this.cd.detectChanges();
            })
          );
        }
      })
    );
  }
  onFocusOutEvent(event: any, i) {
    this.files[i].isActive = false;
    if (
      this.files[i].file_name_without_extesion == '' ||
      this.files[i].file_name_without_extesion == undefined ||
      this.files[i].file_name_without_extesion == null
    ) {
      this.files[i].file_name_without_extesion = 'Untitled File';
    }
    const extension =
      this.files[i].display_file_name.substring(this.files[i].display_file_name.lastIndexOf('.') + 1, this.files[i].display_file_name.length) ||
      this.files[i].display_file_name;
    const data = {
      display_file_name: this.files[i].file_name_without_extesion + '.' + extension,
      id: this.files[i]['delete_id'],
    };
    this.subscription.add(
      this.documentService.setFileuploadedStatus(data).subscribe((res) => {
        this.files[i].display_file_name = this.files[i].file_name_without_extesion + '.' + extension;
      })
    );
  }
  onKeypressEvent(event: any, i) {
    this.files[i].isActive = true;
    const keycode = event.keyCode ? event.keyCode : event.which;
    if (keycode == '13') {
      const extension =
        this.files[i].display_file_name.substring(this.files[i].display_file_name.lastIndexOf('.') + 1, this.files[i].display_file_name.length) ||
        this.files[i].display_file_name;
      const data = {
        display_file_name: this.files[i].file_name_without_extesion + '.' + extension,
        id: this.files[i]['delete_id'],
      };
      this.subscription.add(
        this.documentService.setFileuploadedStatus(data).subscribe((res) => {
          this.files[i].display_file_name = this.files[i].file_name_without_extesion + '.' + extension;
        })
      );
    }
  }

  downloadAttachment(id, name, isStop, is_form_download = false) {
    this.loaderService.show();
    this.documentService.downloadDocumentOrAttachment(
      this.securityStateObject.userId,
      id,
      is_form_download ? id : null,
      this.security_key,
      this.sk,
      name
    );
  }

  onReset() {
    // reset whole form back to initial state
    this.submitted = false;
    this.documentForm.reset();
    this.t.clear();
  }

  onClear() {
    // clear errors and reset ticket fields
    this.submitted = false;
    this.t.reset();
  }

  checkFileEncryption(): Observable<any> {
    //check to see if there is a security key being used
    //if so send api call to check for any files that might need to be encrypted
    if (this.isSecurityKeyAdded && this.manageSecuritykey != null && this.manageSecuritykey[0]['sk']) {
      return this.documentService.checkVaultFileEncryption(this.securityStateObject.userId, this.currentFormId, this.manageSecuritykey[0]);
    } else {
      return new Observable((subscriber) => {
        subscriber.next();
      });
    }
  }
  SelectFirstGroup() {
    const url = this.router.url.split('/');
    const id = url?.length > 6 ? url[6] : url[4];
    this.defaultFoldersList.forEach((rootelement) => {
      if (rootelement.vault_user_folder_id == id) {
        this.documentForm.controls.selectSaveFolder.setValue('group_' + rootelement.groups[0].id);

        if (this.data.group_id) {
          this.documentForm.controls.selectSaveFolder.setValue('group_' + this.data.group_id);
        }
        this.subfolderList = rootelement.subfolders.filter((x) => x.parent_vault_user_folder_id == rootelement.vault_user_folder_id);
        const groupList = [];
        rootelement.groups.forEach((element) => {
          const newElement = {
            ...element,
            ...{ isGroup: true },
          };
          newElement['id'] = 'group_' + newElement['id'];
          groupList.push(newElement);
        });
        this.subfolderList = this.subfolderList.concat(groupList);
        this.showFolderList = false;
      }
      rootelement.subfolders.forEach((element) => {
        if (element.vault_user_folder_id == id) {
          this.documentForm.controls.selectSaveFolder.setValue('group_' + element.groups[0].id);
          if (this.data.group_id) {
            this.documentForm.controls.selectSaveFolder.setValue('group_' + this.data.group_id);
          }
          this.subfolderList = rootelement.subfolders.filter((x) => x.parent_vault_user_folder_id == element.vault_user_folder_id);
          const groupList = [];
          element.groups.forEach((element) => {
            const newElement = {
              ...element,
              ...{ isGroup: true },
            };
            newElement['id'] = 'group_' + newElement['id'];
            groupList.push(newElement);
          });
          this.subfolderList = this.subfolderList.concat(groupList);
          this.showFolderList = false;
        }
      });
    });
  }

  ngOnDestroy() {
    if (!this.data.isLinked) {
      $('body').css('overflow', 'auto');
    } else {
      this.subscription.add(this._notifyLinkedItemsUpdateService.sendMessage('true'));
    }
    this.vaultSideNavService.handleModal(true);
    this.commonService.clearRolePlayersState(this.templateId);
    this.addApiRapidValueService.clearPropertyDataFromLiveFeedsData(this.templateId);
    this.addApiRapidValueService.clearPropertyDataFromGeneralData(this.templateId);
    this.addApiRapidValueService.apiIndicatorsSubjectData.next('');
    this.apiConnectedData.set(false);

    // Clean up all subscriptions
    this.subscription?.unsubscribe();
    if (this.addressVehicleFieldsSubscription) {
      this.addressVehicleFieldsSubscription.unsubscribe();
    }

    // Clear timeouts
    if (this.aiCheckTimeoutId) {
      clearTimeout(this.aiCheckTimeoutId);
    }
    if (this.statusCheckTimeoutId) {
      clearTimeout(this.statusCheckTimeoutId);
    }

    // Terminate workers
    if (this.checkAIWorker) {
      this.checkAIWorker.terminate();
      this.checkAIWorker = undefined;
    }
    if (this.checkStatusWorker) {
      this.checkStatusWorker.terminate();
      this.checkStatusWorker = undefined;
    }
  }

  deleteFileFunction() {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Move to trash?',
        materialIcon: 'delete',
        text: `This file will be deleted forever from your trash after ${foreverDeletedRemainingDays} days.`,
        proceedTitle: 'Move to Trash',
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          // this.store$.dispatch(new vaultStoreActions.DeleteFileRequest(model));
          const modelRequest = {
            type: 'form',
            ids: [this.currentFormId],
          };

          this.subscription.add(
            this.commonService.moveToTrashForm(modelRequest).subscribe((data) => {
              if (data) {
                this.toastr.success(`${this.data.form_name} file moved to trash`);

                this.closedialog();
              }
            })
          );
        }
      })
    );
  }

  warnWhileTryingToDelete() {
    const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete Permission Denied',
        materialIcon: 'delete',
        text: 'You do not have permissions to delete this item. Only the owner of this item can delete it.',
        proceedTitle: 'Okay',
        hideCancel: true,
      },
    });
  }
  getFormUserPublicKey(formId) {
    if (formId) {
      this.subscription.add(
        this.documentService.getUserPublicKeyByFormId(formId).subscribe((results) => {
          if (results.public_key) {
            this.formUserPublicKey = results.public_key;
          }
        })
      );
    }
  }

  public_key() {
    return this.securityStateObject.public_key;
  }
  async fileChangeEvent(event: any): Promise<void> {
    const file = event.target.files && event.target.files[0];
    if (!file) {
      return;
    } // exit if no file selected
    const isHeic = file.name.toLowerCase().endsWith('.heic');

    if (isHeic) {
      const jpgFile = await this.convertHeicToJpg(file);
    }
    const extension = file.name.split('.').pop();
    let modalRef2;
    this.cd.markForCheck();
    if (file.type.indexOf('image') > -1) {
      this.imageChangedEvent = event;
      modalRef2 = this.openUploadModal({
        videoMimeType: file.type,
        format: 'image',
        type: 'vault-form',
        title: 'Upload form image',
        image: 'vault-form',
        vaultId: this.currentFormId,
        imageChangedEvent: this.imageChangedEvent,
        fileName: file.name,
        extension,
        isSquareImage: true,
      });
    } else if (file.type.indexOf('video') > -1) {
      this.toastr.error('Invalid image type.');
      return;
    }

    this.subscription.add(
      this.subscription.add(
        modalRef2.afterClosed().subscribe(async (upload_promise: any) => {
          const res = await upload_promise;
          if (res) {
            this.subscription.add(
              res.subscribe((res_) => {
                this.updatedFormUrl = res_.data;
                this.toastr.success('Image updated successfully');
                this.cd.detectChanges();
              })
            );
          }
        })
      )
    );
  }
  async convertHeicToJpg(heicFile: File) {
    try {
      const arrayBuffer = await heicFile.arrayBuffer();
      const blob = new Blob([arrayBuffer]);

      const convertedBlob = await heic2any({
        blob,
        toType: 'image/jpeg',
        quality: 0.8,
      });

      // Sometimes heic2any returns a PNG if it detects browser compatibility
      const finalBlob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;

      const jpgFile = new File([finalBlob], heicFile.name.replace(/\.heic$/i, '.jpg'), {
        type: 'image/jpeg',
        lastModified: heicFile.lastModified,
      });

      const fakeEvent = {
        target: {
          files: [jpgFile],
        },
      };

      this.fileChangeEvent(fakeEvent); // Reuse logic
    } catch (error: any) {
      if (error?.message?.includes('already browser readable')) {
        console.warn('Skipped conversion: already readable');
        // Fallback: use the original file as-is and treat it like a normal image
        const fallbackFile = new File([heicFile], heicFile.name.replace(/\.heic$/i, '.jpg'), {
          type: 'image/jpeg',
          lastModified: heicFile.lastModified,
        });

        const fakeEvent = {
          target: {
            files: [fallbackFile],
          },
        };

        this.fileChangeEvent(fakeEvent);
      } else {
        console.error('HEIC conversion failed:', error);
      }
    }
  }
  openUploadModal(data: any): any {
    return this.dialog.open(BsFileUploadNewComponent, {
      data,
      autoFocus: false,
      panelClass: 'full-window-dialog-2',
    });
  }

  deleteFormProfileImage() {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Are you sure you want to delete this image?',
        materialIcon: 'delete',
        text: ``,
        proceedTitle: 'Delete image',
      },
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this.documentService
              .deleteFormImage({
                vaultFormId: this.currentFormId,
                userId: this.currentValutUserId,
              })
              .subscribe(
                (res) => {
                  this.toastr.success('Image Deleted Successfully.');
                  this.updatedFormUrl = res;
                  this.cd.detectChanges();
                },
                (error) => {
                  this.toastr.error(error);
                }
              )
          );
        }
      })
    );
  }
  parentFun(evant) {
    if (evant.value) {
      const list = this.itemsToSetUp.itemsToSetUpList;
      const itemsToSetUp = list.find((x) => x.type == 'description');
      if (itemsToSetUp) {
        this.itemsToSetUp.callActionUpdate(itemsToSetUp.id, this.itemsToSetup.controls['descriptionSection'].value ? 'complete' : 'created');
      }
      this.checkValue(this.documentForm.value, false, 'Description Section');
    } else {
      this.loadDataWithReady(this.saveResponse, 'Description Section');
    }
  }
  viewImage(url: string): any {
    return this.dialog.open(ViewImageComponent, {
      data: { imageUrl: url, isDefault: this.checkIfTestImage(url) },
      autoFocus: false,
      panelClass: 'full-window-dialog-2',
    });
  }
  checkIfTestImage(url): boolean {
    return `${url}`.includes('testing.kinnect');
  }
  handleAssignedBeneficiaryUserEvent(event) {
    this.assignedBeneficiaryUser = event.assignedBeneficiaryUser;
  }

  formStatusEvent(evnet) {
    // this.getFormStatus(this.currentFormId);
  }
  manageTags(file: any) {
    const dialog = this.dialog.open(ManageTagsDialog, {
      data: { ...file, currentFormId: this.currentFormId, currentFolderId: this.currentFolderId },
      autoFocus: false,
      panelClass: 'full-window-dialog-2',
    });
    this.subscription.add(dialog.afterClosed().subscribe((isUpdated) => (isUpdated ? this.getfileliseForCurrentForms() : '')));
  }
  handleJson(attribute) {
    this.subscription.add(
      this.documentService.getFinancialAttribute().subscribe(
        (data) => {
          this.findVaultForm(data, attribute?.toLowerCase()) ?? undefined;
        },
        (error) => {
          console.error(error);
        }
      )
    );
  }
  findVaultForm(json, param) {
    for (const key in json) {
      if (typeof json[key] === 'object') {
        if (json[key]?.vault_form_code?.toLowerCase() === param) {
          return key;
        } else {
          const result = this.findVaultForm(json[key], param);
          if (result) {
            return result;
          }
        }
      }
    }
    return null;
  }
  handleSetupItem(setupItem) {
    this.itemsToSetUp.callActionUpdate(setupItem?.id, setupItem?.status == 'complete' ? 'created' : 'complete');
  }
  hasAttributeApiCall = false;
  attributesWithApiCall = [];
  handleUpdateApiEmitter(ev: any) {
    this.hasAttributeApiCall = false;
    this.cd.detectChanges();
    this.attributesWithApiCall = ev;
    setTimeout(() => {
      if (isArray(ev) && ev.length > 0) {
        this.hasAttributeApiCall = true;
      }
      this.cd.detectChanges();
    }, 2000);
  }
  closeSideNav() {
    try {
      this.templateSidenav?.close();
      this.openDataExtraction = false;
      this.cd.detectChanges();
    } catch (error) {
      console.error('error', error);
    }
  }
  createPremiumKey() {
    this.addSecurityKeyComponent?.createPremiumKey();
  }
  managePermissionKey() {
    const passingFile = JSON.parse(JSON.stringify(this.data));
    passingFile.vault_user_form_id = this.data.id || this.currentFormId;
    passingFile.currentFormId = this.currentFormId;
    passingFile.form_name = this.formName ? this.formName : this.documentForm.controls['documentName'].value;
    const dialogRef = this.dialog.open(ManagePermissionDialogComponent, {
      disableClose: true,
      width: '750px',
      height: 'auto',
      data: {
        isFile: true,
        Id: this.currentFormId,
        fileFolderName: this.documentForm.controls.documentName.value,
        file: passingFile,
        showMarkAsComplete: true,
        markAsCompleteStatus: this.itemsToSetupSharingStatus,
        origin: this?.data?.origin,
        itemsToSetupList: this.itemsToSetUp?.itemsToSetUpList,
        itemsToSetUp: this.itemsToSetUp,
      },
      panelClass: 'full-window-dialog-2',
      autoFocus: false,
    });
  }
  dynamicFieldsForm(): FormArray {
    return this.documentForm.controls['dynamicFieldsForm'].value;
  }
  handleDateChange(value, formcontrol) {
    // (this.documentForm.controls['dynamicFieldsForm'] as any).controls[0].controls[formcontrol].setValue(value != 'Invalid date' ? value : '');
  }
  handleDateChange2(value, formcontrol) {
    (this.documentForm.controls['dynamicFieldsForm'] as any).controls[0].controls[formcontrol].setValue(value != 'Invalid date' ? value : '');
  }

  copyDataFromLiveFeeds() {
    if (this.receivedPropertyData) {
      const data = this.receivedPropertyData;
      if (this.savedDynamicFieldsFormValueInDb) {
        Object.keys(this.savedDynamicFieldsFormValueInDb[0]).forEach((element) => {
          // this.documentForm.controls.dynamicFieldsForm['controls'][0]['controls'][element].setValue(
          //   this.savedDynamicFieldsFormValueInDb[0][element]
          // );
        });
      }
      switch (data.type) {
        case 'zillow':
          try {
            const stateName = USStates[data.setting.state as keyof typeof USStates] || '';
            const zillowFieldsControl = this.documentForm.controls.dynamicFieldsForm['controls'][0];
            let isLotSizeAssigned = false;
            const zillowPatchData: any = {};
            const zillowValueMapping = new Map<string, any>([
              ['streetaddress', data.setting?.StreetAddress],
              ['city', data.setting?.city],
              ['country', 'United States of America'],
              ['state', stateName],
              ['zipcode', data.setting?.zipCode],
              ['bedrooms', data.response?.bedrooms],
              ['bathrooms', data.response?.bathrooms],
              ['yearbuilt', data.response?.yearBuilt],
            ]);

            Object.keys(zillowFieldsControl.controls).forEach((controlName) => {
              const control = zillowFieldsControl.controls[controlName];
              const formControlName = controlName.toLowerCase();
              for (const [key, value] of zillowValueMapping) {
                if (formControlName.includes(key)) {
                  zillowPatchData[controlName] = value;
                  break;
                }
              }

              if (formControlName.includes('lotsize')) {
                zillowPatchData[controlName] = data.response?.lotSize;
                isLotSizeAssigned = true;
              } else if (formControlName.includes('squarefootage')) {
                zillowPatchData[controlName] = !isLotSizeAssigned ? data.response?.livingArea : '';
              }
            });
            zillowFieldsControl.patchValue(zillowPatchData);
            Object.keys(zillowPatchData).forEach((controlName) => {
              zillowFieldsControl.controls[controlName].markAsDirty();
            });
            this.toastr.success(`Data from Zillow was successfully copied to general information`);
            this.hasZillowVehicleDatabaseConnection = true;
            this.saveCurrentAddressData();
          } catch (error) {
            this.toastr.error('Error copying Zillow data');
          }
          break;
        case 'vehicleDatabase':
          try {
            const makeYear = data.setting.year.toString();
            const vehicleFieldsControl = this.documentForm.controls.dynamicFieldsForm['controls'][0];
            const vehiclePatchData: any = {};
            const vehicleValueMapping = new Map<string, any>([
              ['make', data.setting.make],
              ['model', data.setting.model],
              ['year', makeYear ?? ''],
              ['trim', data.setting.trim],
              ['condition', data.setting.condition],
            ]);
            Object.keys(vehicleFieldsControl.controls).forEach((controlName) => {
              const control = vehicleFieldsControl.controls[controlName];
              const formControlName = controlName.toLowerCase();
              for (const [key, value] of vehicleValueMapping) {
                if (formControlName.includes(key)) {
                  vehiclePatchData[controlName] = value;
                  break;
                }
              }
            });
            vehicleFieldsControl.patchValue(vehiclePatchData);
            Object.keys(vehiclePatchData).forEach((controlName) => {
              vehicleFieldsControl.controls[controlName].markAsDirty();
            });
            this.toastr.success(`Data from Vehicle Database was successfully copied to general information`);
            this.hasZillowVehicleDatabaseConnection = true;
            this.saveCurrentVehicleData();
          } catch (error) {
            this.toastr.error('Error copying vehicle data');
          }
          break;
        default:
        // this.toastr.warning(`No ${data.type} data to copy `);
      }
      this.cd.detectChanges();
    }
  }

  saveCurrentAddressData() {
    const dynamicFields = this.documentForm.controls['dynamicFieldsForm'].value?.[0];
    if (!dynamicFields) {
      return;
    }

    const type = this.toCamelCase(this.data?.type_template || this.data?.type || this.data?.template_type);
    this.lastConnectedAddressData = {
      [`${type}StreetAddress`]: dynamicFields[`${type}StreetAddress`] || '',
      [`${type}UnitNumber`]: dynamicFields[`${type}UnitNumber`] || '',
      [`${type}City`]: dynamicFields[`${type}City`] || '',
      [`${type}State`]: dynamicFields[`${type}State`] || '',
      [`${type}ZIPCode`]: dynamicFields[`${type}ZIPCode`] || '',
      [`${type}Country`]: dynamicFields[`${type}Country`] || '',
    };
  }

  saveCurrentVehicleData() {
    const dynamicFields = this.documentForm.controls['dynamicFieldsForm'].value?.[0];
    if (!dynamicFields) {
      return;
    }

    this.lastConnectedVehicleData = {
      automobileCondition: dynamicFields.automobileCondition || '',
      automobileMake: dynamicFields.automobileMake || '',
      automobileModel: dynamicFields.automobileModel || '',
      automobileTrim: dynamicFields.automobileTrim || '',
      automobileYear: dynamicFields.automobileYear || '',
      automobileVin: dynamicFields.automobileVin || '',
    };
  }

  subscribeToAddressAndVehicleFieldChanges() {
    const dynamicFieldsArray = this.documentForm.get('dynamicFieldsForm') as FormArray;
    if (!dynamicFieldsArray || !dynamicFieldsArray.at(0)) {
      return;
    }

    let fieldsToMonitor: string[] = [];
    if (this.has_real_estate_value_estimate) {
      const type = this.toCamelCase(this.data?.type_template || this.data?.type || this.data?.template_type);
      fieldsToMonitor = [`${type}StreetAddress`, `${type}UnitNumber`, `${type}City`, `${type}State`, `${type}ZIPCode`, `${type}Country`];
    } else if (this.has_api_source_motor) {
      fieldsToMonitor = ['automobileCondition', 'automobileMake', 'automobileModel', 'automobileTrim', 'automobileYear', 'automobileVin'];
    }

    if (this.addressVehicleFieldsSubscription) {
      this.addressVehicleFieldsSubscription.unsubscribe();
    }

    this.addressVehicleFieldsSubscription = this.subscription.add(
      dynamicFieldsArray
        .at(0)
        .valueChanges.pipe(debounceTime(500))
        .subscribe((formValues) => {
          const lastConnectedAddressOrVehicleData = this.lastConnectedAddressData || this.lastConnectedVehicleData;
          if (!this.hasZillowVehicleDatabaseConnection || !lastConnectedAddressOrVehicleData) {
            return;
          }

          const hasFieldChanged = fieldsToMonitor.some((fieldName) => {
            const currentValue = formValues[fieldName]?.toString().trim() || '';
            const previousValue = lastConnectedAddressOrVehicleData[fieldName]?.trim() || '';
            const changed = currentValue !== previousValue;
            return changed;
          });

          if (hasFieldChanged) {
            this.showCopyDataButton = true;
            this.isReconnectingWithDataType = false;
            this.cd.detectChanges();
          }
        })
    );
  }

  initializeAddresseAutocomplete() {
    const inputElement = (
      Array.from(this.el.nativeElement.querySelectorAll('mat-form-field')).find(
        (field: Element) => (field as HTMLElement).querySelector('mat-label')?.textContent?.trim() === 'Street Address'
      ) as HTMLElement
    )?.querySelector('input.mat-mdc-input-element') as HTMLInputElement | null;

    if (!inputElement) {
      return;
    }

    if (this.autocomplete) {
      this.autocomplete.set('place_id', null);
      this.autocomplete = null;
      this.cd.detectChanges();
    }

    const streetControlName =
      this.arrayItems.find((item) => item.formControlName.includes('StreetAddress') || item.formControlName.includes('Street'))?.formControlName ||
      '';

    let prefix;
    if (streetControlName.includes('StreetAddress')) {
      prefix = streetControlName.replace('StreetAddress', '');
    } else if (streetControlName.includes('Street')) {
      prefix = streetControlName.replace('Street', '');
    } else {
      prefix = '';
    }

    const countryData = this.arrayItems.filter((x) => x.formControlName == `${prefix}Country`)[0].options;
    // const countryControlName = (this.documentForm.controls['dynamicFieldsForm'] as any).controls[0].controls[`${prefix}Country`].value;

    const formMapping: AddressFormMapping = {
      street: streetControlName.includes('StreetAddress') ? `${prefix}StreetAddress` : `${prefix}Street`,
      city: `${prefix}City`,
      state: `${prefix}State`,
      zip: `${prefix}ZIPCode`,
      country: `${prefix}Country`,
      unitNumber: `${prefix}UnitNumber`,
    };

    // Initialize new autocomplete
    this.autocomplete = this.googleMapsService.initializeAutocomplete(
      inputElement,
      (this.documentForm.controls['dynamicFieldsForm'] as any).controls[0],
      formMapping,
      [],
      '',
      (address) => {}
    );

    this.cd.detectChanges();
  }

  moveFileItem(file) {
    const dialogRef = this.dialog.open(MoveFileItemComponent, {
      panelClass: 'attachment-move',
      data: {
        file: file,
        currentuserId: this.currentuserId,
        currentFormId: this.currentFormId,
      },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((data) => {
        if (data.isRefresh) {
          this.getfileliseForCurrentForms();
        }
      })
    );
  }
  selectedFile;
  duplicateFileItem(file) {
    const timer = setTimeout(() => {
      this.selectedFile = { ...file, file_name: `copy of ${file.file_name}`, display_file_name: `copy of ${file.display_file_name}` };
    }, 5000);

    this.subscription.add(
      this.vaultUserService
        .duplicateAttachmentFileItem({
          id: file.delete_id,
          user_id: this.currentuserId,
          vault_user_form_id: this.currentFormId,
        })
        // .pipe(delay(10000))
        .subscribe({
          next: () => {
            clearTimeout(timer);
            this.getfileliseForCurrentForms();
          },
          error: () => {
            clearTimeout(timer);
          },
        })
    );
  }
  aiFetchDocumentEvent(evant) {
    this.refrechDocument();
  }
  reTriggerAI() {
    if (this.fId == 1) {
      this.analyzeWithAi = true;
      this.subscription.add(
        this.sharedVaultService
          .refreshDocument({
            vault_user_form_id: this.currentFormId,
            user_id: this.currentuserId,
            execution_type: 'template_summary',
          })
          .subscribe((res) => {
            this.isTemplateDocumentTagLoading = true;
            this.cd.detectChanges();
            this.checkStatusTemplateSummary();
            try {
              this.documentLinkingTemplate?.checkStatus();
            } catch (error) {}

            try {
              this.formAttachment?.updateStatusWorking();
            } catch (error) {}
          })
      );
    } else {
    }
  }
  async checkStatusTemplateSummary() {
    // Terminate previous worker if exists
    if (this.checkStatusWorker) {
      this.checkStatusWorker.terminate();
    }

    return await new Promise(async (resolve) => {
      if (typeof Worker !== 'undefined') {
        this.checkStatusWorker = new Worker(new URL('./check-ai-status-upload-file.worker', import.meta.url), { type: 'module' });

        const data = {
          token: '',
          url: `${environment.apiUrl}/api/vault/check-upload-file-ai-running`,
          vault_user_form_id: this.currentFormId,
          execution_type: 'template_summary',
        };
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const token = `Bearer ${idToken}`;
        data.token = token;
        this.checkStatusWorker.onmessage = async ({ data }) => {
          if (data.data.ai_is_running) {
            this.statusCheckTimeoutId = setTimeout(() => {
              this.checkStatusTemplateSummary();
            }, 15000);
          } else {
            this.isTemplateDocumentTagLoading = false;
            this.analyzeWithAi = false;
            this.getfileliseForCurrentForms();
            try {
              this.formAttachment.is_loading = false;
              this.formAttachment?.getAiData();
            } catch (error) {}
          }
          resolve(data);
        };
        this.checkStatusWorker.postMessage(data);
      } else {
        //browser does not support web-workers so just return a new data key, UI automation will be blocked
        resolve(this.generatecreateFileAfterS3UrlCrete(null));
      }
    });
  }
  refrechDocument() {
    this.analyzeWithAi = true;
    this.subscription.add(
      this.sharedVaultService
        .refreshDocument({
          vault_user_form_id: this.currentFormId,
          user_id: this.currentuserId,
        })
        .subscribe((res) => {
          this.analyzeWithAi = false;
          this.documentLinkingTemplate.checkStatus();

          this.vaultSelectionForm.vaultSuggestion();
          this.getfileliseForCurrentForms();
          this.refreshTemplateDocumentTag();
        })
    );
  }

  refreshTemplateDocumentTag() {
    if (this.templateDocumentTagRef) {
      // Trigger ngOnChanges by updating the files input
      this.getfileliseForCurrentForms();
    }
  }
  onLinkedFormsUpdated() {
    this.refreshTemplateDocumentTag();
  }
  toCamelCase(str) {
    if (!str) return '';
    return str
      .split(' ')
      .map((word, index) => {
        if (index === 0) {
          // lower first char of first word
          return word.charAt(0).toLowerCase() + word.slice(1);
        }
        // capitalize first char of other words
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join('');
  }
  isDocumentFormValid(): boolean {
    const dynamicFields = this.documentForm.controls['dynamicFieldsForm'].value?.[0];

    if (!dynamicFields) {
      return false;
    }
    const type = this.toCamelCase(this.data?.type_template || this.data?.type || this.data?.template_type);
    const requiredFields = [type + 'StreetAddress', type + 'City', type + 'State', type + 'ZIPCode', type + 'Country'];
    const isValid = requiredFields.every((field) => {
      return dynamicFields[field]?.trim();
    });

    return isValid;
  }

  isVehicleDatabaseFormValid(): boolean {
    const dynamicFields = this.documentForm.controls['dynamicFieldsForm'].value?.[0];

    if (!dynamicFields) {
      return false;
    }

    const requiredSuffixes = ['make', 'model', 'year', 'trim', 'condition'];

    const isValid = requiredSuffixes.every((suffix) => {
      const key = Object.keys(dynamicFields).find((k) => k.toLowerCase().endsWith(suffix.toLowerCase()));
      return key && dynamicFields[key]?.toString().trim() !== '';
    });

    return isValid === true ? (!this.isTrimDataFound ? !isValid : isValid) : isValid;
  }

  onFieldBlur(fieldName: string) {
    if (fieldName.includes('automobile')) {
      const isMake = fieldName?.toLowerCase().endsWith('make');
      const isModel = fieldName?.toLowerCase().endsWith('model');
      const isYear = fieldName?.toLowerCase().endsWith('year');

      if (isMake || isModel || isYear) {
        this.checkAndFetchTrimData(fieldName);
      }
    }
  }

  checkAndFetchTrimData(fieldName: string): boolean {
    const dynamicFields = this.documentForm.controls['dynamicFieldsForm'].value?.[0];

    if (!dynamicFields) return false;

    const makeKey = Object.keys(dynamicFields).find((k) => k.toLowerCase().endsWith('make'));
    const modelKey = Object.keys(dynamicFields).find((k) => k.toLowerCase().endsWith('model'));
    const yearKey = Object.keys(dynamicFields).find((k) => k.toLowerCase().endsWith('year'));

    const make = dynamicFields[makeKey]?.trim();
    const model = dynamicFields[modelKey]?.trim();
    const year = dynamicFields[yearKey];

    if (make && model && year) {
      const comboKey = `${make}|${model}|${year}`;

      if (this.previousComboKey !== comboKey) {
        this.previousComboKey = comboKey;
        this.getTrimVehicledata(make, model, year);
      }
      return true;
    }

    return false;
  }

  getTrimVehicledata(makeValue, modelValue, yearValue) {
    this.arrayItems.forEach((item) => {
      const formArray = this.documentForm.get('dynamicFieldsForm') as FormArray;
      const formGroup = formArray.at(0) as FormGroup;
      if (item.formControlName.includes('Trim')) {
        formGroup.get(item.formControlName)?.setValue('');
      }
      if (item.formControlName.includes('Trim')) {
        item.type = 'text';
      }
    });
    this.isLoadingTrimData = true;
    this.isTrimOptionsNotAvailable = false;
    const data = {
      year: new Date(yearValue).getFullYear(),
      model: modelValue,
      make: makeValue,
    };

    this.subscription.add(
      this.userService.getCarDetails(data).subscribe((res) => {
        if (res.status == 'error') {
          this.arrayItems.forEach((item) => {
            if (item.formControlName.includes('Trim')) {
              item.options = [];
            }
          });
          this.isTrimOptionsNotAvailable = true;
          this.isTrimDataFound = false;
          this.isLoadingTrimData = false;
          this.cd.detectChanges();
          return;
        } else {
          try {
            this.vehiclePayload = data;
            this.vehicleResponse = res;
            this.isTrimOptionsNotAvailable = false;
            this.isTrimDataFound = true;
            let trimList = res.data.market_value.market_value_data.map((x) => x.trim);
            if (trimList.length) {
              this.arrayItems.forEach((item) => {
                if (item.formControlName.includes('Trim')) {
                  item.type = 'select';
                  item.api_field_mapping = item.label;
                  trimList.forEach((element, index) => {
                    if (index == 0) {
                      const formArray = this.documentForm.get('dynamicFieldsForm') as FormArray;
                      const formGroup = formArray.at(0) as FormGroup;

                      formGroup.get(item.formControlName)?.setValue(element);
                    }
                    this.trimList.push({
                      value: element,
                      label: element,
                    });
                  });
                  item.options = this.trimList;
                  this.cd.detectChanges();
                }
              });
            }
            this.isLoadingTrimData = false;
            this.cd.detectChanges();
          } catch (error) {
            this.isLoadingTrimData = false;
            this.cd.detectChanges();
          }
        }
      })
    );
  }

  setEstimateValue(response, setting) {
    try {
      let trim = response.data.market_value.market_value_data.find((x) => x.trim == setting.trim);
      return trim['market value'].find((x) => x.Condition == setting.condition)[setting.type];
    } catch (error) {
      return '$0';
    }
  }

  connectVehicleDatabase() {
    this.isConnectingWithDataType = true;
    this.cd.detectChanges();
    const dynamicFields = this.documentForm.controls['dynamicFieldsForm'].value?.[0];
    let setting = {
      condition: dynamicFields.automobileCondition,
      make: dynamicFields.automobileMake.trim(),
      model: dynamicFields.automobileModel.trim(),
      trim: dynamicFields.automobileTrim,
      type: dynamicFields.automobileType || 'Trade-In',
      vin: dynamicFields.automobileVin || '',
      year: dynamicFields.automobileYear,
      estimateValue: null,
      isVehicleDetails: null,
    };
    try {
      setting.estimateValue = this.setEstimateValue(this.vehicleResponse, setting);
      setting.year = setting.year.years();
      setting.isVehicleDetails = true;
    } catch (error) {}
    const data = {
      vault_user_form_id: this.currentFormId,
      type: 'vehicleDatabase',
      status: 'connected',
      response: JSON.stringify(this.vehicleResponse),
      setting: JSON.stringify(setting),
      payload: JSON.stringify(this.vehiclePayload),
    };
    this.subscription.add(
      this.documentService.createVaultFormRapidIntegration(data).subscribe((res) => {
        this.addApiRapidPropertyValueService.clearPropertyDataFromGeneralData(this.templateId);
        this.attributeSubject.handleFetchData(true);
        this.getVehicleData();
        this.hasZillowVehicleDatabaseConnection = true;
        this.saveCurrentVehicleData();
        this.cd.detectChanges();
      })
    );
  }

  reconnectVehicleDatabase() {
    this.isReconnectingWithDataType = false;
    this.isConnectingWithDataType = true;
    this.connectVehicleDatabase();
    this.cd.detectChanges();
  }

  getVehicleData() {
    this.isConnectingWithDataType = true;
    this.cd.detectChanges();
    this.subscription.add(
      this.documentService.getVaultFormRapidIntegration(this.currentFormId).subscribe((res) => {
        this.apiMotorValueList = [];

        if (!res || res?.length == 0) {
          this.addApiRapidPropertyValueService.propertyDataSubjectData.next([]);
          this.addApiRapidPropertyValueService.vehicleDataSubjectData.next([]);
          this.isDataFeedConnected.set(false);
          this.cd.detectChanges();
          return;
        }
        if (res?.length && res.filter((x) => x.type === 'vehicleDatabase')?.length) {
          this.addApiRapidPropertyValueService.vehicleDataSubjectData.next(this.apiMotorValueList);
          const element = res.filter((x) => x.type === 'vehicleDatabase')[0];
          element.payload = JSON.parse(element.payload);
          try {
            element.response = JSON.parse(element.response);
          } catch (error) {}
          element.setting = JSON.parse(element.setting);
          this.apiMotorValueList.push(element);
          this.addApiRapidPropertyValueService.vehicleDataSubjectData.next(this.apiMotorValueList);
          this.addApiRapidPropertyValueService.setPropertyDataFromLiveFeeds(element, this.templateId);
          this.hasZillowVehicleDatabaseConnection = true;
          this.saveCurrentVehicleData();
        }
        if (res?.length && res.filter((x) => x.type === 'zillow')?.length) {
          this.addApiRapidPropertyValueService.propertyDataSubjectData.next(this.apiMotorValueList);
          const element = res.filter((x) => x.type === 'zillow')[0];
          element.payload = JSON.parse(element.payload);
          element.response = JSON.parse(element.response);
          element.setting = JSON.parse(element.setting);
          this.apiMotorValueList.push(element);
          this.getUpdatedImage();
          this.addApiRapidPropertyValueService.propertyDataSubjectData.next(this.apiMotorValueList);
          this.addApiRapidPropertyValueService.setPropertyDataFromLiveFeeds(element, this.templateId);
          this.hasZillowVehicleDatabaseConnection = true;
          this.saveCurrentAddressData();
        }
        this.isConnectingWithDataType = false;
        this.cd.detectChanges();
      })
    );
  }

  reconnectZillow() {
    if (!this.isDocumentFormValid()) {
      return;
    }
    this.isReconnectingWithDataType = false;
    this.isConnectingWithDataType = true;
    this.connectZillow();
    this.cd.detectChanges();
  }

  connectZillow() {
    if (!this.isDocumentFormValid()) {
      return;
    }
    this.isConnectingWithDataType = true;
    const dynamicFields = this.documentForm.controls['dynamicFieldsForm'].value?.[0];

    let address = '';
    const type = this.toCamelCase(this.data?.type_template || this.data?.type || this.data?.template_type);

    if (dynamicFields[`${type}StreetAddress`]?.length) {
      address = address + dynamicFields[`${type}StreetAddress`].trim() + (dynamicFields[`${type}UnitNumber`]?.length ? ' ' : ', ');
    }

    if (dynamicFields[`${type}UnitNumber`]?.length) {
      address = address + dynamicFields[`${type}UnitNumber`].trim() + ', ';
    }

    if (dynamicFields[`${type}City`]?.length) {
      address = address + dynamicFields[`${type}City`].trim() + ', ';
    }

    if (dynamicFields[`${type}State`]?.length) {
      const stateName = Object.entries(USStates).find(([abbr, name]) => name === dynamicFields[`${type}State`])?.[0];
      if (stateName) {
        address = address + stateName + ', ';
      }
    }

    if (dynamicFields[`${type}ZIPCode`]?.length) {
      address = address + dynamicFields[`${type}ZIPCode`].trim();
    }

    const data = {
      address: address,
    };

    this.subscription.add(
      this.userService.getPropertyDetails(data).subscribe(async (res) => {
        if ((res.status == 'error' || !res.status) && !res.zestimate) {
          this.isConnectingWithDataType = false;
          this.isReconnectingWithDataType = true;
          this.cd.detectChanges();
        } else {
          await this.saveEstimate(res, data);
          const dynamicFields = this.documentForm.controls['dynamicFieldsForm'].value?.[0];
          if (dynamicFields) {
            const type = this.toCamelCase(this.data?.type_template || this.data?.type || this.data?.template_type);
            if (res.bathrooms) {
              dynamicFields[`${type}Bathrooms`] = res.bathrooms;
            }
            if (res.bedrooms) {
              dynamicFields[`${type}Bedrooms`] = res.bedrooms;
            }
            if (res.livingArea) {
              dynamicFields[`${type}SquareFootage`] = res.livingArea;
            }
            if (res.yearBuilt) {
              dynamicFields[`${type}YearBuilt`] = res.yearBuilt;
            }
          }
          this.isConnectingWithDataType = false;
          this.isReconnectingWithDataType = false;
          this.cd.detectChanges();
          this.documentForm.controls['dynamicFieldsForm'].patchValue([dynamicFields]);
          this.cd.detectChanges();
          const templateId = `template-${uuidv4()}`;

          this.addApiRapidPropertyValueService.clearPropertyDataFromGeneralData(templateId);
          this.attributeSubject.handleFetchData(true);
          this.getVehicleData();

          this.showCopyDataButton = false;
          this.hasZillowVehicleDatabaseConnection = true;
          this.saveCurrentAddressData();
          this.cd.detectChanges();
        }
      })
    );
  }

  saveEstimate(response, payload) {
    return new Promise((resolve) => {
      const type = this.toCamelCase(this.data?.type_template || this.data?.type || this.data?.template_type);
      let setting = {
        StreetAddress: this.documentForm.controls['dynamicFieldsForm'].value?.[0][`${type}StreetAddress`],
        UnitNumber: this.documentForm.controls['dynamicFieldsForm'].value?.[0][`${type}UnitNumber`],
        city: this.documentForm.controls['dynamicFieldsForm'].value?.[0][`${type}City`],
        state: Object.entries(USStates).find(
          ([abbr, name]) => name === this.documentForm.controls['dynamicFieldsForm'].value?.[0][`${type}State`]
        )?.[0],
        zipCode: this.documentForm.controls['dynamicFieldsForm'].value?.[0][`${type}ZIPCode`],
        propertyValue: response?.data?.zestimate,
        estimateValue: `$0`,
      };
      const data = {
        vault_user_form_id: this.currentFormId,
        type: 'zillow',
        status: 'connected',
        response: JSON.stringify(response),
        setting: JSON.stringify(setting),
        payload: JSON.stringify(payload),
      };

      this.subscription.add(
        this.documentService.createVaultFormRapidIntegration(data).subscribe((res) => {
          resolve(res);
        })
      );
    });
  }

  documentUpdateEvent(documents) {
    this.linkDocuments = documents;
    this.cd.detectChanges();
  }
  templateTypeToBeUpdated = '';
  handleStatusMenu(event) {
    event.stopPropagation();
    event.preventDefault();
    const target = event.target as HTMLElement;
    const classEl = document.querySelectorAll('.statusMenu');
    if (target) {
      const computedStyle = window.getComputedStyle(target);
      const { width } = computedStyle;
      classEl.forEach((element: HTMLElement) => {
        element.style.minWidth = width;
        element.style.width = width;
        this.cd.detectChanges();
      });

      const statusWrapper = document.querySelector('.mat-mdc-menu-content');
      if (statusWrapper) {
        (statusWrapper as any).style.padding = '0';
      }
      const statusItem = document.querySelectorAll('.mat-mdc-menu-item-text');
      statusItem.forEach((element: HTMLElement) => {
        element.style.fontSize = '12px';
        element.style.fontWeight = '600';
        element.style.textAlign = 'left';
        element.style.width = '100%';
      });
      this.cd.detectChanges();
    }
  }
  multiItemExtractionCategoriesEvent(event) {
    if (event?.multi_item_extraction_categories?.length) {
      this.multi_item_extraction_categories = event.multi_item_extraction_categories;
    }
  }
  getStatusMenuItemClass(status: TemplateStatus | string): string {
    return this.templateStatusMenuClassMap[status] ?? '';
  }

  handleTemplateStatusChange(status: TemplateStatus | string, item) {
    const currentStatus = this.templateData?.template_status || 'notStarted';
    if (status === currentStatus) {
      return;
    }
    this.templateData.template_status = status;
    this.templateTypeToBeUpdated = status;
    this.subscription.add(
      this.documentService
        .updateVaultFormTemplateStatus({
          templateIds: [item.id ?? item.vault_user_form_id],
          templateStatus: status,
        })
        .subscribe(() => {
          // this.setEdittempletdataform();
        })
    );
  }
  transformToUser() {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '500px',
      data: {
        title: 'Transform this Contact?',
        materialIcon: 'info',
        text: `Doing this will delete this contact and replace all role player assignments with the user selected or created.`,
        proceedTitle: 'Transform',
        showCancelBtn: true,
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((res) => {
        if (res?.confirmation) {
          // Open transform to user dialog
          const transformDialogRef = this.dialog.open(TransformToUserDialogComponent, {
            width: '750px',
            panelClass: 'transform-to-user-dialog',
            data: {
              currentFormId: this.currentFormId,
              contactName: this.documentForm.controls.documentName.value,
            },
          });

          this.subscription.add(
            transformDialogRef.afterClosed().subscribe((transformRes) => {
              if (transformRes?.confirmation && transformRes?.action) {
                // Handle different actions in add-document component
                switch (transformRes.action) {
                  case 'invite_new_user':
                    this.openInviteNewUserDialog();
                    break;
                  case 'create_new_guardian':
                    this.openCreateNewGuardianDialog();
                    break;
                  case 'sync_existing_user':
                    this.openSyncExistingUserDialog();
                    break;
                }
              }
            })
          );
        }
      })
    );
  }
  getContactDetailsFromForm() {
    const vaultFormData = this.saveResponse?.vaultFormData?.[0];
    if (!vaultFormData) {
      return {};
    }

    const parsedTemplate = this.safeJsonParse(vaultFormData.template, []);
    const template =
      (Array.isArray(this.arrayItems) && this.arrayItems.length
        ? this.arrayItems
        : (Array.isArray(parsedTemplate) && parsedTemplate[0]?.singleFieldForm) || []) || [];

    const liveValues = this.documentForm?.controls?.dynamicFieldsForm?.['controls']?.[0]?.value || {};
    const parsedFormData = this.safeJsonParse(vaultFormData.form_data, {});
    const formValues = Object.keys(liveValues).length ? liveValues : parsedFormData?.dynamicFieldsForm || {};

    if (!template.length && !Object.keys(formValues).length) {
      return {};
    }

    const pick = (...predicates: Array<(item: any) => boolean>) => {
      for (const predicate of predicates) {
        const field = template.find(predicate);
        if (field?.formControlName && formValues[field.formControlName]) {
          return formValues[field.formControlName];
        }
      }
      return undefined;
    };

    const emailFromDropdown = () => {
      for (const item of template) {
        if (item.type === 'MultiPleDropDown' && Array.isArray(item.data)) {
          for (const dropdown of item.data) {
            const field = dropdown.template?.find((child) => child.type === 'email' && child.formControlName);
            if (field && formValues[field.formControlName]) {
              return formValues[field.formControlName];
            }
          }
        }
      }
      return undefined;
    };

    const emailFromValues = () => {
      const emailKey = Object.keys(formValues).find((key) => key?.toLowerCase().includes('email') && formValues[key]);
      return emailKey ? formValues[emailKey] : undefined;
    };

    return {
      firstName: pick(
        (item) => item.label?.toLowerCase().includes('first name'),
        (item) => item.formControlName?.toLowerCase().includes('first')
      ),
      lastName: pick(
        (item) => item.label?.toLowerCase().includes('last name'),
        (item) => item.formControlName?.toLowerCase().includes('last')
      ),
      email:
        pick(
          (item) => item.type === 'email',
          (item) => item.label?.toLowerCase().includes('email'),
          (item) => item.formControlName?.toLowerCase().includes('email')
        ) ||
        emailFromDropdown() ||
        emailFromValues(),
    };
  }

  private safeJsonParse(value: string, fallback: any) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }
  openInviteNewUserDialog() {
    const contactDetails = this.getContactDetailsFromForm();
    const inviteData = {
      forPrefessionalUser: true,
      hideRelationship: true,
      custom_user_type: UserTypeEnum.Professional,
      custom_user_type_DropDown: ProfessionalUserRelationShip.name,
      ...(contactDetails.firstName && { firstName: contactDetails.firstName }),
      ...(contactDetails.lastName && { lastName: contactDetails.lastName }),
      ...(contactDetails.email && { email: contactDetails.email }),
    };
    const modalRef = this.dialog.open(UserInviteComponent, {
      data: inviteData,
      autoFocus: false,
      panelClass: 'full-window-dialog-2-mobile-responsive',
    });

    this.subscription.add(
      modalRef.afterClosed().subscribe((res) => {
        if (res && res['success']) {
          this.store$.dispatch(new relationshipStoreActions.AllRelationships());

          // Get user ID from the response (it's in res.user.id based on user-invite.component.ts line 248)
          const userId = res.user?.id || res.id;

          if (userId) {
            // Call transform API directly after invite (no success screen)
            this.subscription.add(
              this.documentService
                .transformContact({
                  vault_user_form_id: this.currentFormId,
                  user_id: userId,
                })
                .subscribe(
                  (response) => {
                    this.toastr.success(`Invitation to ${res.user.nickname || res.user.first_name + ' ' + res.user.last_name} sent successfully`);
                    // Close add-document dialog
                    this.dialogRef.close();
                  },
                  (error) => {
                    this.toastr.error('Failed to transform contact');
                  }
                )
            );
          }
        }
      })
    );
  }

  openCreateNewGuardianDialog() {
    const contactDetails = this.getContactDetailsFromForm();
    const guardianData = {
      custom_user_type: 'normal',
    };
    const prefillData: any = {};
    if (contactDetails.firstName) {
      prefillData.first_name = contactDetails.firstName;
    }
    if (contactDetails.lastName) {
      prefillData.last_name = contactDetails.lastName;
    }
    const modalRef = this.dialog.open(AddConnectionComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'full-window-dialog-2',
      data: {
        data: guardianData,
        filterList: [],
        formNetworkSetup: true,
        custom_user_type: '',
        fromSharing: true, // This ensures the dialog closes with response
        ...(Object.keys(prefillData).length > 0 && { prefillData }),
      },
    });

    this.subscription.add(
      modalRef.afterClosed().subscribe((res) => {
        if (res && res.id) {
          this.store$.dispatch(new relationshipStoreActions.AllRelationships());

          // Call transform API with the created guardian's user ID
          this.subscription.add(
            this.documentService
              .transformContact({
                vault_user_form_id: this.currentFormId,
                user_id: res.id,
              })
              .subscribe(
                (response) => {
                  this.toastr.success('Guardian Account created successfully');
                  // Close add-document dialog
                  this.dialogRef.close();
                },
                (error) => {
                  this.toastr.error('Failed to transform contact');
                }
              )
          );
        }
      })
    );
  }

  openSyncExistingUserDialog() {
    const syncDialogRef = this.dialog.open(SyncUserDialogComponent, {
      width: '700px',
      panelClass: 'sync-user-dialog',
      data: {
        placeholderText: 'Search Connections',
        title: 'Select User To Sync With',
        currentFormId: this.currentFormId,
      },
    });

    this.subscription.add(
      syncDialogRef.afterClosed().subscribe((res) => {
        if (res?.confirmation && res?.selectedUser && res.selectedUser.user_id) {
          this.store$.dispatch(new relationshipStoreActions.AllRelationships());

          // Call transform API with the selected user's ID
          this.subscription.add(
            this.documentService
              .transformContact({
                vault_user_form_id: this.currentFormId,
                user_id: res.selectedUser.user_id,
              })
              .subscribe(
                (response) => {
                  this.toastr.success('Contact has been synced successfully');
                  // Close add-document dialog
                  this.dialogRef.close();
                },
                (error) => {
                  this.toastr.error('Failed to transform contact');
                }
              )
          );
        }
      })
    );
  }

  openSyncExistingEntityDialog() {
    const userId = this.loginStateObject?.id ?? this.currentuserId;
    const vaultId = this.vaultStateObject?.vaultId;
    const syncDialogRef = this.dialog.open(SyncEntityDialogComponent, {
      width: '700px',
      panelClass: 'sync-entity-dialog',
      data: {
        userId,
        vaultId,
      },
    });

    this.subscription.add(
      syncDialogRef.afterClosed().subscribe((res) => {
        if (res?.confirmation && res?.selectedEntity?.id && this.currentFormId) {
          const payload = {
            vault_user_form_id: this.currentFormId,
            new_vault_user_form_id: res.selectedEntity.id,
          };
          this.subscription.add(
            this.documentService.transformPlaceholder(payload).subscribe(
              () => {
                this.store$.dispatch(
                  new vaultStoreActions.PersonalFolderFilesRequest({
                    userId: this.loginStateObject?.id ?? this.currentuserId,
                    folderId: 'Entities',
                    mydata: this.router.url.includes('mydata') ? true : false,
                  })
                );
                this.toastr.success('Entity has been synced successfully');
                this.dialogRef.close();
              },
              () => {
                this.toastr.error('Failed to sync entity');
              }
            )
          );
        }
      })
    );
  }

  openCreateEntityFromTransform() {
    const dialogRef = this.dialog.open(AddEntityDilaogComponent, {
      panelClass: 'full-window-dialog',
      autoFocus: false,
      data: {
        hidePlaceholderEntity: true,
        placeHolderFormId: this.currentFormId,
      },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        if (res?.status === 'success' && res?.data?.hub_vault_user_form_id && this.currentFormId) {
          const payload = {
            vault_user_form_id: this.currentFormId,
            new_vault_user_form_id: res.data.hub_vault_user_form_id,
          };
          this.subscription.add(
            this.documentService.transformPlaceholder(payload).subscribe(
              () => {
                this.toastr.success('Entity has been created successfully');
                this.store$.dispatch(
                  new vaultStoreActions.PersonalFolderFilesRequest({
                    folderId: 'Entities',
                    userId: this.loginStateObject?.id ?? this.currentuserId,
                    mydata: this.router.url.includes('mydata') ? true : false,
                  })
                );
                this.dialogRef.close();
              },
              () => {
                this.toastr.error('Failed to transform placeholder entity');
              }
            )
          );
        }
      })
    );
  }

  openRenameSuggestionDialog() {
    const modalRef = this.dialog.open(RenameDocumentNameComponent, {
      panelClass: 'full-window-dialog-2',
      disableClose: true,
      autoFocus: false,
      data: {
        headerTitle: 'Rename Suggestion',
        buttonName: 'Rename',
        currentFormName: this.documentForm.controls.documentName.value,
        suggestedFormName: this.newAISuggestedFormName || '',
        dismissLabel: 'Dismiss this suggestion without renaming this document',
      },
    });

    this.subscription.add(
      modalRef.afterClosed().subscribe((res) => {
        if (res?.renameConfirmation) {
          const payload = {
            form_name: res.suggestedFormName,
            id: this.currentFormId,
            vault_user_inbox_suggestion_id: this.vaultUserInboxSuggestionId,
            deactive_suggestion: true,
          };
          this.subscription.add(
            this.documentService.saveFormNameInDb(payload, true).subscribe(
              (response) => {
                this.newAISuggestedFormName = '';
                this.documentForm.controls.documentName.setValue(res.suggestedFormName);
                // this.nameSaveInDB = this.documentForm.controls.documentName.value;
                this.cd.detectChanges();
              },
              (error) => {
                console.error('Error saving form name in db:', error);
              }
            )
          );
        } else if (res?.dismissConfirmation) {
          this.subscription.add(
            this.documentService.updateDeactvateSuggestion(this.vaultUserInboxSuggestionId).subscribe(
              (response) => {
                this.newAISuggestedFormName = '';
                this.cd.detectChanges();
              },
              (error) => {
                console.error('Error dismissing document name suggestion:', error);
              }
            )
          );
        }
      })
    );
  }
  transformToLegalEntity() {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '500px',
      data: {
        title: 'Transform this Entity Placeholder?',
        materialIcon: 'info',
        text: `Doing this will delete this placeholder and replace all role player assignments with the entity selected or created.`,
        proceedTitle: 'Transform',
        showCancelBtn: true,
      },
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((res) => {
        if (res?.confirmation) {
          const transformDialogRef = this.dialog.open(TransformToUserDialogComponent, {
            width: '550px',
            panelClass: 'transform-to-user-dialog',
            data: {
              mode: 'entity',
              currentFormId: this.currentFormId,
              contactName: this.documentForm.controls.documentName.value,
            },
          });

          this.subscription.add(
            transformDialogRef.afterClosed().subscribe((transformRes) => {
              if (transformRes?.confirmation && transformRes?.action) {
                switch (transformRes.action) {
                  case TransformToUserAction.CreateNewEntity:
                    this.openCreateEntityFromTransform();
                    break;
                  case TransformToUserAction.SyncWithExistingEntity:
                    this.openSyncExistingEntityDialog();
                    break;
                }
              }
            })
          );
        }
      })
    );
  }

  get selectedItemsArray() {
    return this.globalSelections.map((item, idx) => ({
      rowIndex: idx,
      data: item,
      tag: item.tag,
      type: item.type,
      source: item.source,
    }));
  }

  onTagSelectionChange(event: { type: string; tag: string; index: number; isChecked: boolean }) {
    const key = `document_tags_${event.type}_${event.index}_${event.tag}`;
    if (event.isChecked) {
      if (!this.globalSelectionsMap.has(key)) {
        const arrayIndex = this.globalSelections.length;
        this.globalSelections.push({
          source: 'document_tags',
          type: event.type,
          tag: event.tag,
          index: event.index,
          data: event,
        });
        this.globalSelectionsMap.set(key, arrayIndex);
      }
    } else {
      const arrayIndex = this.globalSelectionsMap.get(key);
      if (arrayIndex !== undefined) {
        this.globalSelections.splice(arrayIndex, 1);
        this.globalSelectionsMap.delete(key);
        this.globalSelectionsMap.forEach((idx, mapKey) => {
          if (idx > arrayIndex) {
            this.globalSelectionsMap.set(mapKey, idx - 1);
          }
        });
      }
    }
  }

  onDocumentLinkedTemplateSelectionChange(event: {
    type: 'linked_template' | 'existing_ai_suggestion' | 'new_ai_suggestion';
    template: any;
    index: number;
    isChecked: boolean;
  }) {
    const key = `document_linked_templates_${event.type}_${event.index}_${event.template?.id}`;
    if (event.isChecked) {
      if (!this.globalSelectionsMap.has(key)) {
        const arrayIndex = this.globalSelections.length;
        this.globalSelections.push({
          source: 'document_linked_templates',
          type: event.type,
          template: event.template,
          index: event.index,
          data: event,
        });
        this.globalSelectionsMap.set(key, arrayIndex);
      }
    } else {
      const arrayIndex = this.globalSelectionsMap.get(key);
      if (arrayIndex !== undefined) {
        this.globalSelections.splice(arrayIndex, 1);
        this.globalSelectionsMap.delete(key);
        this.globalSelectionsMap.forEach((idx, mapKey) => {
          if (idx > arrayIndex) {
            this.globalSelectionsMap.set(mapKey, idx - 1);
          }
        });
      }
    }
  }

  onRolePlayerSelectionChange(event: { rolePlayer: any; index: number; isChecked: boolean; category: string }) {
    const key = `role_players_role_player_${event.index}_${event.rolePlayer?.id}_${event.category}`;
    if (event.isChecked) {
      if (!this.globalSelectionsMap.has(key)) {
        const arrayIndex = this.globalSelections.length;
        this.globalSelections.push({
          source: 'role_players',
          type: 'role_player',
          rolePlayer: event.rolePlayer,
          category: event.category,
          index: event.index,
          data: event,
        });
        this.globalSelectionsMap.set(key, arrayIndex);
      }
    } else {
      const arrayIndex = this.globalSelectionsMap.get(key);
      if (arrayIndex !== undefined) {
        this.globalSelections.splice(arrayIndex, 1);
        this.globalSelectionsMap.delete(key);
        this.globalSelectionsMap.forEach((idx, mapKey) => {
          if (idx > arrayIndex) {
            this.globalSelectionsMap.set(mapKey, idx - 1);
          }
        });
      }
    }
  }

  onRolePlayerAISuggestionSelectionChange(event: { suggestion: any; index: number; isChecked: boolean; category: string }) {
    const key = `role_players_role_player_ai_suggestion_${event.index}_${event.suggestion?.vault_user_inbox_suggestion_id}_${event.category}`;
    if (event.isChecked) {
      if (!this.globalSelectionsMap.has(key)) {
        const arrayIndex = this.globalSelections.length;
        this.globalSelections.push({
          source: 'role_players',
          type: 'role_player_ai_suggestion',
          suggestion: event.suggestion,
          category: event.category,
          index: event.index,
          data: event,
        });
        this.globalSelectionsMap.set(key, arrayIndex);
      }
    } else {
      const arrayIndex = this.globalSelectionsMap.get(key);
      if (arrayIndex !== undefined) {
        this.globalSelections.splice(arrayIndex, 1);
        this.globalSelectionsMap.delete(key);
        this.globalSelectionsMap.forEach((idx, mapKey) => {
          if (idx > arrayIndex) {
            this.globalSelectionsMap.set(mapKey, idx - 1);
          }
        });
      }
    }
  }

  onNonDocumentLinkedTemplateSelectionChange(event: { template: any; index: number; isChecked: boolean }) {
    const key = `non_document_linked_templates_linked_template_${event.index}_${event.template?.id}`;
    if (event.isChecked) {
      if (!this.globalSelectionsMap.has(key)) {
        const arrayIndex = this.globalSelections.length;
        this.globalSelections.push({
          source: 'non_document_linked_templates',
          type: 'linked_template',
          template: event.template,
          index: event.index,
          data: event,
        });
        this.globalSelectionsMap.set(key, arrayIndex);
      }
    } else {
      const arrayIndex = this.globalSelectionsMap.get(key);
      if (arrayIndex !== undefined) {
        this.globalSelections.splice(arrayIndex, 1);
        this.globalSelectionsMap.delete(key);
        this.globalSelectionsMap.forEach((idx, mapKey) => {
          if (idx > arrayIndex) {
            this.globalSelectionsMap.set(mapKey, idx - 1);
          }
        });
      }
    }
  }

  onNonDocumentSuggestionSelectionChange(event: { suggestion: any; index: number; isChecked: boolean; type: 'linked' | 'new' }) {
    const expectedType = event.type === 'linked' ? 'existing_ai_suggestion' : 'new_ai_suggestion';
    const key = `non_document_linked_templates_${expectedType}_${event.index}_${event.suggestion?.id}`;
    if (event.isChecked) {
      if (!this.globalSelectionsMap.has(key)) {
        const arrayIndex = this.globalSelections.length;
        this.globalSelections.push({
          source: 'non_document_linked_templates',
          type: expectedType,
          suggestion: event.suggestion,
          index: event.index,
          data: event,
        });
        this.globalSelectionsMap.set(key, arrayIndex);
      }
    } else {
      const arrayIndex = this.globalSelectionsMap.get(key);
      if (arrayIndex !== undefined) {
        this.globalSelections.splice(arrayIndex, 1);
        this.globalSelectionsMap.delete(key);
        this.globalSelectionsMap.forEach((idx, mapKey) => {
          if (idx > arrayIndex) {
            this.globalSelectionsMap.set(mapKey, idx - 1);
          }
        });
      }
    }
  }

  onNonDocumentTemplateSuggestionSelectionChange(event: { templateSuggestion: any; index: number; isChecked: boolean }) {
    const key = `non_document_linked_templates_template_suggestion_${event.index}_${event.templateSuggestion?.id}`;
    if (event.isChecked) {
      if (!this.globalSelectionsMap.has(key)) {
        const arrayIndex = this.globalSelections.length;
        this.globalSelections.push({
          source: 'non_document_linked_templates',
          type: 'template_suggestion',
          templateSuggestion: event.templateSuggestion,
          index: event.index,
          data: event,
        });
        this.globalSelectionsMap.set(key, arrayIndex);
      }
    } else {
      const arrayIndex = this.globalSelectionsMap.get(key);
      if (arrayIndex !== undefined) {
        this.globalSelections.splice(arrayIndex, 1);
        this.globalSelectionsMap.delete(key);
        this.globalSelectionsMap.forEach((idx, mapKey) => {
          if (idx > arrayIndex) {
            this.globalSelectionsMap.set(mapKey, idx - 1);
          }
        });
      }
    }
  }

  onLinkedTemplateMethodSelectionChange(event: { template: any; index: number; isChecked: boolean; linkType: string }) {
    const key = `linked_template_methods_linked_template_${event.index}_${event.template?.id}_${event.linkType}`;
    if (event.isChecked) {
      if (!this.globalSelectionsMap.has(key)) {
        const arrayIndex = this.globalSelections.length;
        this.globalSelections.push({
          source: 'linked_template_methods',
          type: 'linked_template',
          template: event.template,
          linkType: event.linkType,
          index: event.index,
          data: event,
        });
        this.globalSelectionsMap.set(key, arrayIndex);
      }
    } else {
      const arrayIndex = this.globalSelectionsMap.get(key);
      if (arrayIndex !== undefined) {
        this.globalSelections.splice(arrayIndex, 1);
        this.globalSelectionsMap.delete(key);
        this.globalSelectionsMap.forEach((idx, mapKey) => {
          if (idx > arrayIndex) {
            this.globalSelectionsMap.set(mapKey, idx - 1);
          }
        });
      }
    }
  }

  onLocationLinkedTemplateSelectionChange(event: { template: any; index: number; isChecked: boolean; locationType: string }) {
    const key = `location_linked_templates_linked_template_${event.index}_${event.template?.id}_${event.locationType}`;
    if (event.isChecked) {
      if (!this.globalSelectionsMap.has(key)) {
        const arrayIndex = this.globalSelections.length;
        this.globalSelections.push({
          source: 'location_linked_templates',
          type: 'linked_template',
          template: event.template,
          locationType: event.locationType,
          index: event.index,
          data: event,
        });
        this.globalSelectionsMap.set(key, arrayIndex);
      }
    } else {
      const arrayIndex = this.globalSelectionsMap.get(key);
      if (arrayIndex !== undefined) {
        this.globalSelections.splice(arrayIndex, 1);
        this.globalSelectionsMap.delete(key);
        this.globalSelectionsMap.forEach((idx, mapKey) => {
          if (idx > arrayIndex) {
            this.globalSelectionsMap.set(mapKey, idx - 1);
          }
        });
      }
    }
  }

  onLinkedOwnershipPositionSelectionChange(event: { record: any; index: number; isChecked: boolean; categoryKey: string }) {
    const key = `linked_ownership_positions_linked_position_${event.index}_${event.record?.id}_${event.categoryKey}`;
    if (event.isChecked) {
      if (!this.globalSelectionsMap.has(key)) {
        const arrayIndex = this.globalSelections.length;
        this.globalSelections.push({
          source: 'linked_ownership_positions',
          type: 'linked_position',
          record: event.record,
          categoryKey: event.categoryKey,
          index: event.index,
          data: event,
        });
        this.globalSelectionsMap.set(key, arrayIndex);
      }
    } else {
      const arrayIndex = this.globalSelectionsMap.get(key);
      if (arrayIndex !== undefined) {
        this.globalSelections.splice(arrayIndex, 1);
        this.globalSelectionsMap.delete(key);
        this.globalSelectionsMap.forEach((idx, mapKey) => {
          if (idx > arrayIndex) {
            this.globalSelectionsMap.set(mapKey, idx - 1);
          }
        });
      }
    }
  }

  onRolePlayerAssociationSelectionChange(event: {
    record: any;
    index: number;
    isChecked: boolean;
    categoryKey: string;
    isBeneficialOwnership: boolean;
  }) {
    const type = event.isBeneficialOwnership ? 'role_player_beneficial_ownership' : 'role_player_owned_items';
    const key = `role_player_associations_${type}_${event.index}_${event.record?.id}_${event.categoryKey}`;
    if (event.isChecked) {
      if (!this.globalSelectionsMap.has(key)) {
        const arrayIndex = this.globalSelections.length;
        this.globalSelections.push({
          source: 'role_player_associations',
          type: type,
          record: event.record,
          categoryKey: event.categoryKey,
          isBeneficialOwnership: event.isBeneficialOwnership,
          index: event.index,
          data: event,
        });
        this.globalSelectionsMap.set(key, arrayIndex);
      }
    } else {
      const arrayIndex = this.globalSelectionsMap.get(key);
      if (arrayIndex !== undefined) {
        this.globalSelections.splice(arrayIndex, 1);
        this.globalSelectionsMap.delete(key);
        this.globalSelectionsMap.forEach((idx, mapKey) => {
          if (idx > arrayIndex) {
            this.globalSelectionsMap.set(mapKey, idx - 1);
          }
        });
      }
    }
  }

  onNonDocumentAttachmentSelectionChange(event: { file: any; index: number; isChecked: boolean }) {
    const type = event.file.is_suggestion ? 'linked_document_suggestion' : 'linked_document';
    const fileId = event.file.is_suggestion ? event.file.id : event.file.linked_form_id || event.file.formid;
    const key = `non_document_attachments_${type}_${event.index}_${fileId}`;
    if (event.isChecked) {
      if (!this.globalSelectionsMap.has(key)) {
        const arrayIndex = this.globalSelections.length;
        this.globalSelections.push({
          source: 'non_document_attachments',
          type: type,
          file: event.file,
          index: event.index,
          data: event,
        });
        this.globalSelectionsMap.set(key, arrayIndex);
      }
    } else {
      const arrayIndex = this.globalSelectionsMap.get(key);
      if (arrayIndex !== undefined) {
        this.globalSelections.splice(arrayIndex, 1);
        this.globalSelectionsMap.delete(key);
        this.globalSelectionsMap.forEach((idx, mapKey) => {
          if (idx > arrayIndex) {
            this.globalSelectionsMap.set(mapKey, idx - 1);
          }
        });
      }
    }
  }

  handleGlobalBulkRemoval() {
    const documentTags = this.globalSelections.filter((item) => item.source === 'document_tags' && item.type === 'document_type');
    const suggestionTags = this.globalSelections.filter((item) => item.source === 'document_tags' && item.type === 'tag_ai_suggestion');
    const linkedTemplates = this.globalSelections.filter((item) => item.source === 'document_linked_templates' && item.type === 'linked_template');
    const suggestions = this.globalSelections.filter(
      (item) => item.source === 'document_linked_templates' && (item.type === 'existing_ai_suggestion' || item.type === 'new_ai_suggestion')
    );
    const rolePlayers = this.globalSelections.filter((item) => item.source === 'role_players' && item.type === 'role_player');
    const rolePlayerAISuggestions = this.globalSelections.filter(
      (item) => item.source === 'role_players' && item.type === 'role_player_ai_suggestion'
    );
    const nonDocumentLinkedTemplates = this.globalSelections.filter(
      (item) => item.source === 'non_document_linked_templates' && item.type === 'linked_template'
    );
    const nonDocumentSuggestions = this.globalSelections.filter(
      (item) => item.source === 'non_document_linked_templates' && (item.type === 'existing_ai_suggestion' || item.type === 'new_ai_suggestion')
    );
    const nonDocumentTemplateSuggestions = this.globalSelections.filter(
      (item) => item.source === 'non_document_linked_templates' && item.type === 'template_suggestion'
    );
    const linkedTemplateMethods = this.globalSelections.filter(
      (item) => item.source === 'linked_template_methods' && item.type === 'linked_template'
    );
    const locationLinkedTemplates = this.globalSelections.filter(
      (item) => item.source === 'location_linked_templates' && item.type === 'linked_template'
    );
    const linkedOwnershipPositions = this.globalSelections.filter(
      (item) => item.source === 'linked_ownership_positions' && item.type === 'linked_position'
    );
    const rolePlayerOwnedItems = this.globalSelections.filter(
      (item) => item.source === 'role_player_associations' && item.type === 'role_player_owned_items'
    );
    const rolePlayerBeneficialOwnership = this.globalSelections.filter(
      (item) => item.source === 'role_player_associations' && item.type === 'role_player_beneficial_ownership'
    );
    const nonDocumentAttachments = this.globalSelections.filter(
      (item) => item.source === 'non_document_attachments' && item.type === 'linked_document'
    );
    const nonDocumentAttachmentSuggestions = this.globalSelections.filter(
      (item) => item.source === 'non_document_attachments' && item.type === 'linked_document_suggestion'
    );

    // Remove document type tags
    if (documentTags.length > 0 && this.templateDocumentTagRef) {
      const deleteTagObservables = documentTags.map(({ tag }) =>
        this.templateDocumentTagRef.deleteVaultUserTagObservable(tag).pipe(
          take(1),
          catchError((error) => {
            console.error(`Error deleting tag "${tag}":`, error);
            return of(null);
          })
        )
      );
      this.subscription.add(
        forkJoin(deleteTagObservables).subscribe({
          next: () => {
            this.getfileliseForCurrentForms();
          },
          error: (error) => {
            console.error('Error in bulk removal of document tags:', error);
          },
        })
      );
    }

    // Remove AI suggestion tags
    if (suggestionTags.length > 0 && this.templateDocumentTagRef) {
      const deleteSuggestionTagObservables = suggestionTags.map(({ tag }) =>
        this.templateDocumentTagRef.removeDocumentSuggestionTagObservable(tag).pipe(
          take(1),
          catchError((error) => {
            console.error(`Error removing suggestion tag "${tag}":`, error);
            return of(null);
          })
        )
      );
      this.subscription.add(
        forkJoin(deleteSuggestionTagObservables).subscribe({
          next: () => {
            this.getfileliseForCurrentForms();
          },
          error: (error) => {
            console.error('Error in bulk removal of suggestion tags:', error);
          },
        })
      );
    }

    // Remove linked templates
    if (linkedTemplates.length > 0 && this.documentLinkingTemplate) {
      const deleteLinkedTemplateObservables = linkedTemplates.map(({ template }) =>
        this.documentLinkingTemplate.deleteFileFunctionObservable(template).pipe(
          take(1),
          catchError((error) => {
            console.error(`Error deleting linked template "${template?.form_name || template?.id}":`, error);
            return of(null);
          })
        )
      );
      this.subscription.add(
        forkJoin(deleteLinkedTemplateObservables).subscribe({
          next: () => {
            this.documentLinkingTemplate.getLinkedForms();
          },
          error: (error) => {
            console.error('Error in bulk removal of linked templates:', error);
          },
        })
      );
    }

    // Remove linked templates suggestions
    if (suggestions.length > 0 && this.documentLinkingTemplate) {
      const removeSuggestionObservables = suggestions.map(({ template }) =>
        this.documentLinkingTemplate.updateDeactvateSuggestionObservable(template).pipe(
          take(1),
          catchError((error) => {
            console.error(`Error removing linked template suggestion "${template?.form_name || template?.id}":`, error);
            return of(null);
          })
        )
      );
      this.subscription.add(
        forkJoin(removeSuggestionObservables).subscribe({
          next: () => {
            this.documentLinkingTemplate.getSuggestions(false);
          },
          error: (error) => {
            console.error('Error in bulk removal of linked template suggestions:', error);
          },
        })
      );
    }

    // Remove role players
    if (rolePlayers.length > 0 && this.rolePlayersInFormComponent) {
      rolePlayers.forEach(({ rolePlayer, category }) => {
        this.rolePlayersInFormComponent.deleteRolePlayer(rolePlayer, category);
      });
    }

    // Remove role player AI suggestions
    if (rolePlayerAISuggestions.length > 0 && this.rolePlayersInFormComponent) {
      rolePlayerAISuggestions.forEach(({ suggestion, category }) => {
        this.rolePlayersInFormComponent.deleteRolePlayerAISuggestion(suggestion, category);
      });
    }

    // Remove non-document linked templates
    if (nonDocumentLinkedTemplates.length > 0 && this.nonDocumentLinkingTemplate) {
      nonDocumentLinkedTemplates.forEach(({ template }) => {
        this.nonDocumentLinkingTemplate.deleteFileFunction(template);
      });
    }

    // Remove non-document suggestions
    if (nonDocumentSuggestions.length > 0 && this.nonDocumentLinkingTemplate) {
      nonDocumentSuggestions.forEach(({ suggestion }) => {
        this.nonDocumentLinkingTemplate.removeDocumentSuggestionTag(suggestion);
      });
    }

    // Remove non-document template suggestions
    if (nonDocumentTemplateSuggestions.length > 0 && this.nonDocumentLinkingTemplate) {
      nonDocumentTemplateSuggestions.forEach(({ templateSuggestion }) => {
        this.nonDocumentLinkingTemplate.deleteSuggestion(templateSuggestion);
      });
    }

    // Remove linked template methods
    if (linkedTemplateMethods.length > 0 && this.linkedTemplateMethodComponents) {
      const groupedByLinkType = linkedTemplateMethods.reduce((acc, item) => {
        const linkType = item.linkType;
        if (!acc[linkType]) {
          acc[linkType] = [];
        }
        acc[linkType].push(item);
        return acc;
      }, {} as Record<string, typeof linkedTemplateMethods>);

      this.linkedTemplateMethodComponents.forEach((component) => {
        const linkType = component.selectedLinkType;
        const itemsToRemove = groupedByLinkType[linkType] || [];
        itemsToRemove.forEach(({ template }) => {
          component.deleteTemplate(template);
        });
      });
    }

    // Remove location linked templates
    if (locationLinkedTemplates.length > 0 && this.locationLinkedTemplatesComponents) {
      const groupedByLocationType = locationLinkedTemplates.reduce((acc, item) => {
        const locationType = item.locationType || '';
        if (!acc[locationType]) {
          acc[locationType] = [];
        }
        acc[locationType].push(item);
        return acc;
      }, {} as Record<string, typeof locationLinkedTemplates>);

      this.locationLinkedTemplatesComponents.forEach((locationComponent) => {
        if (locationComponent.viewTemplateListComponents) {
          locationComponent.viewTemplateListComponents.forEach((viewTemplateList) => {
            locationLinkedTemplates.forEach(({ template }) => {
              viewTemplateList.removeTemplate(template);
            });
          });
        }
      });
    }

    // Remove linked ownership positions
    if (linkedOwnershipPositions.length > 0 && this.linkedOwnershipPositions) {
      const recordsToRemove = linkedOwnershipPositions.map(({ record }) => record);
      this.linkedOwnershipPositions.deleteVaultUserFormLinkedPositions(recordsToRemove);
    }

    // Remove role player owned items
    if (rolePlayerOwnedItems.length > 0 && this.rolePlayersAssociationCardComponents) {
      const recordsToRemove = rolePlayerOwnedItems.map(({ record }) => record);
      this.rolePlayersAssociationCardComponents.forEach((component) => {
        if (!component.isBeneficialOwnership) {
          component.deleteVaultUserOwnedItem(recordsToRemove);
        }
      });
    }

    // Remove role player beneficial ownership
    if (rolePlayerBeneficialOwnership.length > 0 && this.rolePlayersAssociationCardComponents) {
      const recordsToRemove = rolePlayerBeneficialOwnership.map(({ record }) => record);
      this.rolePlayersAssociationCardComponents.forEach((component) => {
        if (component.isBeneficialOwnership) {
          component.deleteVaultUserBeneficialOwnership(recordsToRemove);
        }
      });
    }

    // Remove non-document attachments
    if ((nonDocumentAttachments.length > 0 || nonDocumentAttachmentSuggestions.length > 0) && this.nonDocumentAttachmentComponent) {
      const filesToRemove = [
        ...nonDocumentAttachments.map((item) => item.file).filter((file) => file != null),
        ...nonDocumentAttachmentSuggestions.map((item) => item.file).filter((file) => file != null),
      ];
      this.nonDocumentAttachmentComponent.deleteNonDocumentAttachments(filesToRemove);
    }

    setTimeout(() => {
      this.clearAllSelections();
    }, 500);
  }

  clearAllSelections() {
    if (this.templateDocumentTagRef) {
      this.templateDocumentTagRef.clearSelections();
    }
    if (this.documentLinkingTemplate) {
      this.documentLinkingTemplate.clearSelections();
    }
    if (this.rolePlayersInFormComponent) {
      this.rolePlayersInFormComponent.clearSelections();
    }
    if (this.nonDocumentLinkingTemplate) {
      this.nonDocumentLinkingTemplate.clearSelections();
    }
    if (this.linkedTemplateMethodComponents) {
      this.linkedTemplateMethodComponents.forEach((component) => {
        component.clearSelections();
      });
    }
    if (this.locationLinkedTemplatesComponents) {
      this.locationLinkedTemplatesComponents.forEach((component) => {
        component.clearSelections();
      });
    }
    if (this.linkedOwnershipPositions) {
      this.linkedOwnershipPositions.clearSelections();
    }
    if (this.rolePlayersAssociationCardComponents) {
      this.rolePlayersAssociationCardComponents.forEach((component) => {
        component.clearSelections();
      });
    }
    if (this.nonDocumentAttachmentComponent) {
      this.nonDocumentAttachmentComponent.clearSelections();
    }
    this.globalSelections = [];
    this.globalSelectionsMap.clear();
  }

  floaterActionHandler(event: string) {
    if (event === 'close') {
      this.clearAllSelections();
    } else if (event === 'removeSuggestion') {
      this.handleGlobalBulkRemoval();
    }
  }
}
